function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var App = {
  // Properties
  module: false,
  controller: false,
  action: false,
  fbAppId: false,
  fbLanguage: false,
  // Methods
  start: function start(module, controller, action, baseUrl, fbAppId, fbLanguage) {
    if ((typeof PhoneApp === "undefined" ? "undefined" : _typeof(PhoneApp)) == 'object') {
      $('*').off();
    }
    App.module = module;
    App.controller = controller;
    App.action = action;
    App.fbAppId = fbAppId;
    App.fbLanguage = fbLanguage;
    App.reset();
    App.run();
    Loading.end();

    // $.smartbanner({
    //     title: "Rue des Vignerons : expériences vin et spiritueux",
    //     button: 'Voir',
    //     price: 'Gratuit',
    //     inGooglePlay: 'Sur le Play Store',
    //     author: '',
    //     onClose: function (e) {
    //         $(e.target).closest('#smartbanner').remove()
    //     }
    // });
  },

  reset: function reset() {
    ViewHelpers.reset();
  },
  run: function run() {
    if (parent && window.name === 'phonegap' && typeof parent.postMessage === 'function') {
      $('body').addClass('mobile-app');
    }
    Device.init();
    if (App.module && App.controller && _typeof(window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller']) === 'object' && typeof window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'].init === 'function') {
      window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'].init();
      if (typeof window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'][App.action + 'Action'] === 'function') {
        window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'][App.action + 'Action']();
      }
    }
    ViewHelpers.init();
    MySwipers.init();
    $(window).resize(App.onResize);
    $(window).scroll(App.onScroll);
    $(document.body).on('touchmove', App.onScroll);
    $(document).on("mousewheel DOMMouseScroll wheel", App.onScroll);
    if (parent && window.name === 'phonegap' && typeof parent.postMessage === 'function') {
      parent.postMessage({
        action: 'app.loaded'
      }, '*');
      App.bindMobileAppEvents();
    }
  },
  gotoPage: function gotoPage(url) {
    if ((typeof PhoneApp === "undefined" ? "undefined" : _typeof(PhoneApp)) == 'object') {
      PhoneApp.goto(url);
    } else {
      window.location.href = url;
    }
  },
  onResize: function onResize() {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    if ($('body').hasClass('mobile-app')) {
      windowHeight = 500;
    }
    Device.onResize(windowWidth, windowHeight);
    // Trigger resize of view helpers
    ViewHelpers.onResize(windowWidth, windowHeight);
    // Trigger resize of view helpers
    if (App.module && App.controller && _typeof(window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller']) === 'object' && typeof window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'].onResize === 'function') {
      window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'].onResize(windowWidth, windowHeight);
    }
  },
  onScroll: function onScroll() {
    var scrollTop = $(window).scrollTop();
    // Trigger resize of view helpers
    ViewHelpers.onScroll(scrollTop);
    // Trigger resize of view helpers
    if (App.module && App.controller && _typeof(window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller']) === 'object' && typeof window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'].onScroll === 'function') {
      window[App.module.ucfirst() + '_' + App.controller.ucfirst() + 'Controller'].onScroll(scrollTop);
    }
  },
  bindMobileAppEvents: function bindMobileAppEvents() {
    // open external links on new window
    $(document).on('click', "a[target='_blank']", function (e) {
      e.preventDefault();
      parent.postMessage({
        action: 'window.open',
        args: [$(this).attr('href'), '_system', 'location=no']
      }, '*');
    });
  }
};
;
var Accordion = {
  heading: undefined,
  init: function init(heading) {
    this.heading = heading;
    return this;
  },
  showOne: function showOne() {
    var $this = this;
    (function ($) {
      var accordionHeading = $($this.heading);
      accordionHeading.each(function () {
        $(this).on("click", function () {
          var item = $(this);
          if (item.hasClass('active')) {
            item.removeClass('active');
          } else {
            accordionHeading.each(function () {
              var element = $(this);
              element.hasClass('active') ? element.removeClass('active') : null;
              var arrow = $(element.find('.arrow')[0]);
              arrow.hasClass('up') ? arrow.removeClass('up') : null;
              arrow.addClass('down');
            });
            item.addClass('active');
          }
          var arrow = $(item.find('.arrow')[0]);
          if (arrow.hasClass('down')) {
            arrow.removeClass('down');
            arrow.addClass('up');
          } else {
            arrow.removeClass('up');
            arrow.addClass('down');
          }
        });
      });
    })(jQuery);
  }
};
;
var styles = window.getComputedStyle(document.documentElement, '');
var cssPrefix = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
CSS = {
  /**
   * Generates CSS3's translate3d transformation style for Opera, Chrome/Safari, Firefox and IE
   *
   * @method translate3d
   * @param {Number} x The X axis coordinate
   * @param {Number} y The Y axis coordinate
   * @param {Number} z The Z axis coordinate
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return {String} The css style code
   */
  translate3d: function translate3d(x, y, z, t) {
    t = typeof t === "undefined" ? 0 : t; //defaults to 0
    x = x.toString();
    y = y.toString();
    z = z.toString();
    if (x.substring(x.length - 1) != '%') x = parseInt(x) + 'px';
    if (y.substring(y.length - 1) != '%') y = parseInt(y) + 'px';
    if (z.substring(z.length - 1) != '%') z = parseInt(z) + 'px';
    if (Modernizr.csstransforms3d) {
      var tr = '-' + cssPrefix + '-transform: translate3d(' + x + ', ' + y + ', ' + z + ');' +
      //            '-moz-transform: translate3d(' + x + ', ' + y + ', ' + z + ');' +
      //            '-ms-transform: translate3d(' + x + ', ' + y + ', ' + z + ');' +
      //            '-o-transform: translate(' + x + ', ' + y + ');' +
      'transform: translate3d(' + x + ', ' + y + ', ' + z + ');';
      if (t > 0) {
        tr += ' -' + cssPrefix + '-transition: ' + t + 'ms;' +
        //                '-moz-transition: ' + t + 'ms;' +
        //                '-ms-transition: ' + t + 'ms;' +
        //                '-o-transition: ' + t + 'ms;' +
        'transition: ' + t + 'ms;';
      }
      return tr;
    } else {
      return 'margin-top:' + y;
    }
  },
  /**
   * Generates CSS3's translate transformation style for Opera, Chrome/Safari, Firefox and IE
   *
   * @method translate3d
   * @param {Number} x The X axis coordinate
   * @param {Number} y The Y axis coordinate
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return {String} The css style code
   */
  translate: function translate(x, y, t) {
    t = typeof t === "undefined" ? 0 : t; //defaults to 0
    x = x.toString();
    y = y.toString();
    if (x.substring(x.length - 1) != '%') x = parseInt(x) + 'px';
    if (y.substring(y.length - 1) != '%') y = parseInt(y) + 'px';
    var tr = '-' + cssPrefix + '-transform: translate(' + x + ', ' + y + ');' +
    //            '-moz-transform: translate3d(' + x + ', ' + y + ', ' + z + ');' +
    //            '-ms-transform: translate3d(' + x + ', ' + y + ', ' + z + ');' +
    //            '-o-transform: translate(' + x + ', ' + y + ');' +
    'transform: translate(' + x + ', ' + y + ');';
    if (t > 0) {
      tr += ' -' + cssPrefix + '-transition: ' + t + 'ms;' +
      //                '-moz-transition: ' + t + 'ms;' +
      //                '-ms-transition: ' + t + 'ms;' +
      //                '-o-transition: ' + t + 'ms;' +
      'transition: ' + t + 'ms;';
    }
    return tr;
  },
  /**
   * Generates CSS3's scale3d transformation style for Opera, Chrome/Safari, Firefox and IE
   * The scaling is symetric, with the same value for width and height
   *
   * @method scale3d
   * @param {Number} s The scale
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return {String} The css style code
   */
  scale3d: function scale3d(s, y, z, t) {
    t = typeof t === "undefined" ? 0 : t; //defaults to 0
    var tr = '-' + cssPrefix + '-transform: scale3d(' + s + ', ' + 1 + ', 1);' +
    //            '-moz-transform: scale3d(' + s + ', ' + 1 + ', 1);' +
    //            '-ms-transform: scale3d(' + s + ', ' + 1 + ', 1);' +
    //            '-o-transform: scale(' + s + ');' +
    'transform: scale3d(' + s + ', ' + 1 + ', 1);';
    if (t > 0) {
      tr += ' -' + cssPrefix + '-transition: ' + t + 'ms;' +
      //                '-moz-transition: ' + t + 'ms;' +
      //                '-ms-transition: ' + t + 'ms;' +
      //                '-o-transition: ' + t + 'ms;' +
      'transition: ' + t + 'ms;';
    }
    return tr;
  },
  /**
   * Generates CSS3's scale3d transformation style for Opera, Chrome/Safari, Firefox and IE
   * The scaling is symetric, with the same value for width and height
   *
   * @method scale3d
   * @param {Number} s The scale
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return {String} The css style code
   */
  scale3d2: function scale3d2(s) {
    t = typeof t === "undefined" ? 0 : t; //defaults to 0
    var tr = '-' + cssPrefix + '-transform: scale3d(' + s + ', ' + s + ', ' + s + ');' +
    //            '-moz-transform: scale3d(' + s + ', ' + 1 + ', 1);' +
    //            '-ms-transform: scale3d(' + s + ', ' + 1 + ', 1);' +
    //            '-o-transform: scale(' + s + ');' +
    'transform: scale3d(' + s + ', ' + s + ', ' + s + ');';
    if (t > 0) {
      tr += ' -' + cssPrefix + '-transition: ' + t + 'ms;' +
      //                '-moz-transition: ' + t + 'ms;' +
      //                '-ms-transition: ' + t + 'ms;' +
      //                '-o-transition: ' + t + 'ms;' +
      'transition: ' + t + 'ms;';
    }
    return tr;
  },
  /**
   * Used to move a scaled element using translate, while keeping the scale
   * Generates the required CSS3 style for Opera, Chrome/Safari, Firefox and IE
   *
   * @method zoomTo
   * @param {Number} x The X axis coordinate of the transformation
   * @param {Number} y The Y axis coordinate of the transformation
   * @param {Number} s The scale of the element (symetric, with the same value for width and height)
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return The css style code
   */
  zoomTo: function zoomTo(x, y, s, t) {
    s = typeof s === "undefined" ? 2 : s; //defaults to 2
    t = typeof t === "undefined" ? 0 : t; //defaults to 0

    var tr = '-' + cssPrefix + '-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-moz-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-ms-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-o-transform: translate(' + x + 'px, ' + y + 'px) scale(' + s + ');' +
    'transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' + '-' + cssPrefix + '-transition: ' + t + 'ms;' +
    //            '-moz-transition: ' + t + 'ms;' +
    //            '-ms-transition: ' + t + 'ms;' +
    //            '-o-transition: ' + t + 'ms;' +
    'transition: ' + t + 'ms;';
    return tr;
  },
  /**
   * Used to move a scaled element using translate, while keeping the scale
   * Generates the required CSS3 style for Opera, Chrome/Safari, Firefox and IE
   *
   * @method zoomTo
   * @param {Number} x The X axis coordinate of the transformation
   * @param {Number} y The Y axis coordinate of the transformation
   * @param {Number} s The scale of the element (symetric, with the same value for width and height)
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return The css style code
   */
  rotate: function rotate(angle) {
    var tr = '-' + cssPrefix + '-transform: rotate(' + angle + 'deg) -' + cssPrefix + '-translate3d(0,0,0);' +
    //            '-ms-transform: rotate('+angle+'deg) -ms-translate3d(0,0,0);'+
    //            '-webkit-transform: rotate('+angle+'deg) -webkit-translate3d(0,0,0);'+
    'transform: rotate(' + angle + 'deg) translate3d(0,0,0);';
    //        var tr = '-webkit-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-moz-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-ms-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-o-transform: translate(' + x + 'px, ' + y + 'px) scale(' + s + ');' +
    //            'transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-webkit-transition: ' + t + 'ms;' +
    //            '-moz-transition: ' + t + 'ms;' +
    //            '-ms-transition: ' + t + 'ms;' +
    //            '-o-transition: ' + t + 'ms;' +
    //            'transition: ' + t + 'ms;';

    return tr;
  },
  /**
   * Used to move a scaled element using translate, while keeping the scale
   * Generates the required CSS3 style for Opera, Chrome/Safari, Firefox and IE
   *
   * @method zoomTo
   * @param {Number} x The X axis coordinate of the transformation
   * @param {Number} y The Y axis coordinate of the transformation
   * @param {Number} s The scale of the element (symetric, with the same value for width and height)
   * @param {Number} t The transition time / animation duration, defaults to 0
   * @return The css style code
   */
  rotate3d: function rotate3d(angle) {
    var tr = '-' + cssPrefix + '-transform: rotate3d(0,0,1,' + angle + 'deg);' +
    //            '-ms-transform: rotate3d(0,0,1,'+angle+'deg);'+
    //            '-webkit-transform: rotate3d(0,0,1,'+angle+'deg);'+
    'transform: rotate3d(0,0,1,' + angle + 'deg);';
    //        var tr = '-webkit-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-moz-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-ms-transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-o-transform: translate(' + x + 'px, ' + y + 'px) scale(' + s + ');' +
    //            'transform: translate3d(' + x + 'px, ' + y + 'px, 0px) scale3d(' + s + ', ' + s + ', 1);' +
    //            '-webkit-transition: ' + t + 'ms;' +
    //            '-moz-transition: ' + t + 'ms;' +
    //            '-ms-transition: ' + t + 'ms;' +
    //            '-o-transition: ' + t + 'ms;' +
    //            'transition: ' + t + 'ms;';

    return tr;
  }
};
;
var Device = {
  // Properties
  isMobile: false,
  isTabletteXS: false,
  isDisplayedMenuMobile: false,
  init: function init() {
    Device.onResize($(window).width(), 0);
  },
  // Methods
  onResize: function onResize(windowWidth, windowHeight) {
    Device.isMobile = windowWidth <= 600;
    Device.isTabletteXS = windowWidth <= 800;
    Device.isDisplayedMenuMobile = !!$("#menu_mobile:visible").size();
  }
};
;
var GoogleMap = {
  // Properties
  mapElement: false,
  debug: true,
  map: false,
  loaded: false,
  callbackName: null,
  stackToCall: [],
  // Methods
  load: function load(callback) {
    if (!callback) callback = "GoogleMap.initialize" + App.module.ucfirst();
    if (this.loaded) {
      var funcCall = callback + "();";
      eval(funcCall);
      return;
    }
    this.stackToCall.push(callback);
    GoogleMap.mapElement = $(".google-map");
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.setAttribute('async', true);
      js.setAttribute('defer', true);
      js.src = "//maps.googleapis.com/maps/api/js?callback=GoogleMap.callback&loading=async&key=" + GOOGLE_API_KEY;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "gmaps");
  },
  /**
   * Ajout d'un marker
   * @param x latitude
   * @param y longitude
   * @param title (optionnel)
   * @param map (optionnel)
   * @param color (optionnel, blue/red/...)
   */
  addMarker: function addMarker(x, y, title, map, color, zIndex) {
    if (!color) color = "blue";
    if (!map) map = GoogleMap.map;
    new google.maps.Marker({
      position: new google.maps.LatLng(x, y),
      map: map,
      title: title,
      zIndex: zIndex,
      icon: "https://maps.gstatic.com/mapfiles/ms2/micons/" + color + "-dot.png"
    });
  },
  initializeFront: function initializeFront() {
    var mapOptions = {
      center: {
        lat: -25.397,
        lng: 131.644
      },
      zoom: 8
    };
    GoogleMap.map = new google.maps.Map(GoogleMap.mapElement.get(0), mapOptions);
    var markers = [];
    // To add the marker to the map, use the 'map' property
    markers.push(new google.maps.Marker({
      position: new google.maps.LatLng(-25.363882, 131.044922),
      title: "Hello World!"
    }));

    // To add the marker to the map, use the 'map' property
    markers.push(new google.maps.Marker({
      position: new google.maps.LatLng(-26.063882, 130.944922),
      title: "Hello World 2!"
    }));
    // To add the marker to the map, use the 'map' property
    markers.push(new google.maps.Marker({
      position: new google.maps.LatLng(-24.063882, 131.944922),
      title: "Hello World 3!"
    }));
    mc = new MarkerClusterer(GoogleMap.map, markers);
  },
  reCenter: function reCenter(latlng, offsetx, offsety, map) {
    var point1 = map.getProjection().fromLatLngToPoint(latlng instanceof google.maps.LatLng ? latlng : map.getCenter());
    var point2 = new google.maps.Point((typeof offsetx == "number" ? offsetx : 0) / Math.pow(2, map.getZoom()) || 0, (typeof offsety == "number" ? offsety : 0) / Math.pow(2, map.getZoom()) || 0);
    map.setCenter(map.getProjection().fromPointToLatLng(new google.maps.Point(point1.x - point2.x, point1.y + point2.y)));
    return map;
  },
  callback: function callback() {
    this.loaded = true;
    for (var i = 0; i < this.stackToCall.length; i++) {
      var callback = this.stackToCall[i];
      var funcCall = callback + "();";
      eval(funcCall);
    }
    this.stackToCall = [];
  }
};
;
var GoogleMapForm = {
  init: function init() {
    // load Google map
    if ($('input.google-map').size()) {
      GoogleMap.load('GoogleMapForm.run');
    }
  },
  run: function run() {
    var map = false;
    var inputCount = $('input.google-map').size();
    $('input.google-map').each(function () {
      var value = $(this).val();
      var input = $(this);
      var pos = {
        lat: 46.10495433786921,
        lng: 2.4722470703125055
      };
      var zoom = 9;
      if (value !== '' && value.split(',').length >= 2) {
        pos = value.split(',');
        if (input.hasClass('google-map-no-zoomsave')) zoom = 10;else zoom = parseInt(pos[2]);
        pos = {
          lat: parseFloat(pos[0]),
          lng: parseFloat(pos[1])
        };
      }
      if (map === false) {
        var div = $('<div class="google-map"></div>');
        div.insertAfter($('input.google-map').last());
        div.append('<div/>');
        map = new google.maps.Map(div.find('div').get(0));
      }
      map.setZoom(zoom);
      var mapField = input.data('map-field');
      if (typeof mapField === 'undefined') {
        mapField = false;
      } else {
        mapField = $(mapField);
        if (!input.data('hide-detect-button')) {
          var btn = $('<a class="btn btn-primary btn-sm">Détecter automatiquement</a>');
          btn.insertAfter(input);
          btn.click(function (e) {
            e.preventDefault();
            var defaultValue = btn.text();
            btn.html(btn + ' (recherche en cours)');
            geocode(function () {
              btn.html(defaultValue);
            });
          });
        }
      }
      map.setCenter(pos);
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(pos.lat, pos.lng),
        map: map,
        draggable: true
      });
      var geocode = function geocode(callback) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': mapField.val() + ', FRANCE'
        }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var position = results[0].geometry.location;
            marker.setPosition(position);
            map.setCenter(position);
            updateInputValue();
          } else {
            if (App.module == 'admin') alert('Geocode was not successful for the following reason: ' + status);else console.error('Geocode error : ' + status);
          }
          if (typeof callback == 'function') {
            callback();
          }
        });
      };
      if (App.module != 'admin' && mapField !== false) {
        $(mapField).on('change', function () {
          if ($(this).val().length > 2) {
            geocode();
          }
        });
      }
      var updateInputValue = function updateInputValue() {
        var position = marker.getPosition();
        var finalValue = position.lat() + ',' + position.lng();
        if (!input.hasClass('google-map-no-zoomsave')) finalValue += ',' + map.getZoom();
        input.val(finalValue);
        return position;
      };
      google.maps.event.addListener(marker, 'dragend', function () {
        if (inputCount > 1) updateInputValue();else map.setCenter(updateInputValue());
      });
      google.maps.event.addListener(map, 'zoom_changed', function () {
        updateInputValue();
      });
      google.maps.event.addListener(marker, 'drag', function () {
        updateInputValue();
      });
    });
  }
};
var MySwipers = {
  buildSwiper: function buildSwiper(containerId, size, options) {
    if (Swiper === undefined) {
      console.error("The swiper library is not loaded");
      return;
    }
    var sliderContainerSelector = "#" + containerId + ".slider-container";
    var pepiteAutoSliderBreakpoint = 1000;
    var isPepiteSwiper = size === "pepite" && window.innerWidth < pepiteAutoSliderBreakpoint;
    var shouldSwiper = size !== "pepite" || isPepiteSwiper;
    return shouldSwiper ? new Swiper(sliderContainerSelector + " .swiper", Object.assign(Object.assign({
      // Optional parameters
      direction: "horizontal",
      loop: false,
      spaceBetween: 16,
      spaceBefore: 16,
      spaceAfter: 16,
      watchOverflow: true,
      // Navigation arrows
      navigation: {
        nextEl: sliderContainerSelector + " .swiper-button-next",
        prevEl: sliderContainerSelector + " .swiper-button-prev"
      }
    }, typeof SWIPER_CONFIGS[size] === "function" ? SWIPER_CONFIGS[size](sliderContainerSelector, size) : SWIPER_CONFIGS[size]), options)) : null;
  },
  init: function init() {
    var self = this;
    $(function () {
      $(".slider-container").each(function (index, elem) {
        var options = {};
        var size = $(elem).data("size") || "md";
        self.buildSwiper(elem.id, size, options);
        console.log("swiper ", elem.id);
        $(elem).attr("data-initialized", true);
      });
    });
  }
};
;
function detectRobot(userAgent) {
  var robots = new RegExp([/bot/, /spider/, /crawl/,
  // GENERAL TERMS
  /APIs-Google/, /AdsBot/, /Googlebot/,
  // GOOGLE ROBOTS
  /mediapartners/, /Google Favicon/, /FeedFetcher/, /Google-Read-Aloud/, /DuplexWeb-Google/, /googleweblight/, /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/,
  // OTHER ENGINES
  /ecosia/, /ia_archiver/, /facebook/, /instagram/, /pinterest/, /reddit/,
  // SOCIAL MEDIA
  /slack/, /twitter/, /whatsapp/, /youtube/, /semrush/ // OTHER
  ].map(function (r) {
    return r.source;
  }).join("|"), "i"); // BUILD REGEXP + "i" FLAG

  return robots.test(userAgent);
}
var Obfuscation = {
  unobfuscate: function unobfuscate() {
    (function ($) {
      $('span.thumbnail-link').each(function () {
        var ref = this.getAttribute('data-ref');
        var data = JSON.parse(atob(ref.replace(ref.substring(4, 7), "")));
        var isRobot = detectRobot(navigator.userAgent);
        if (data.link && !isRobot) {
          var link = document.createElement('a');
          link.innerHTML = this.innerHTML;
          link.setAttribute('href', data.link);
          this.classList.remove('thumbnail-link');
          if (this.classList.length > 0) {
            link.classList = this.classList;
          }
          var style = this.getAttribute('style');
          if (style) {
            link.setAttribute('style', style);
          }
          if (data.target) {
            link.setAttribute('target', data.target);
          }
          if (data.rel) {
            link.setAttribute('rel', data.rel);
          }
          this.replaceWith(link);
        }
      });
    })(jQuery);
  }
};
Obfuscation.unobfuscate();
var SWIPER_THUMBS_CONFIGS = {
  pepite: {
    spaceBetween: 14,
    slidesPerView: 4,
    centerInsufficientSlides: true
  }
};
var SWIPER_CONFIGS = {
  xs: {
    slidesPerView: 2.2,
    breakpoints: {
      350: {
        slidesPerView: 2.4,
        slidesPerGroup: 2
      },
      430: {
        slidesPerView: 3.4,
        slidesPerGroup: 3
      },
      530: {
        slidesPerView: 4.4,
        slidesPerGroup: 4
      },
      650: {
        slidesPerView: 5.4,
        slidesPerGroup: 5
      },
      750: {
        slidesPerView: 6.4,
        slidesPerGroup: 6
      },
      850: {
        slidesPerView: 7.4,
        slidesPerGroup: 7
      },
      920: {
        slidesPerView: 8,
        slidesPerGroup: 8
      }
    }
  },
  md: {
    slidesPerView: 1.4,
    breakpoints: {
      420: {
        slidesPerView: 1.8,
        slidesPerGroup: 2
      },
      500: {
        slidesPerView: 2.2,
        slidesPerGroup: 2
      },
      540: {
        slidesPerView: 2.4,
        slidesPerGroup: 2
      },
      600: {
        slidesPerView: 2.8,
        slidesPerGroup: 2
      },
      740: {
        slidesPerView: 3.2,
        slidesPerGroup: 2
      },
      780: {
        slidesPerView: 3.4,
        slidesPerGroup: 3
      },
      840: {
        slidesPerView: 3.8,
        slidesPerGroup: 3
      },
      920: {
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  },
  lg: {
    slidesPerView: 1.2,
    breakpoints: {
      450: {
        slidesPerView: 1.4,
        slidesPerGroup: 1
      },
      600: {
        slidesPerView: 2.2,
        slidesPerGroup: 2
      },
      750: {
        slidesPerView: 2.4,
        slidesPerGroup: 2
      },
      920: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  tooltip: {
    slidesPerView: 1.1,
    breakpoints: {
      500: {
        slidesPerView: 1
      }
    }
  },
  pepite: function pepite(sliderContainerSelector, size) {
    return {
      autoplay: {
        delay: 3000
      },
      thumbs: {
        swiper: new Swiper(sliderContainerSelector + " .thumbs-swiper", SWIPER_THUMBS_CONFIGS[size])
      },
      centeredSlides: true,
      rewind: true,
      slidesPerView: 1,
      breakpoints: {
        800: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3
        },
        1000: {
          slidesPerView: 4
        }
      }
    };
  }
};
;
var ViewHelpers = {
  // Methods
  reset: function reset() {
    Pepites.reset();
  },
  init: function init() {
    // Dialog
    DialogV2.init();

    // Appearing Sticky
    AppearingSticky.init();

    // forms
    $('select.select2:not(.select2-hidden-accessible)').select2();
    MaxSelectionMultiSelect.init();
    FormRangeSlider.init();
    GoogleMapForm.init();
    AppEvents.init();
    Pepites.init();
    FormSearch.init();
    FullSearch.init();
    ClearableFilters.init();
    FormSearchDomainMobile.init();
    FormFilterActivitiesMobile.init();
    // Inputs autofill
    Autofill.init();
    MobileBottomBar.init();
    LinkBySms.init();
    Loading.init();
    Excerpt.init();
    FilteredContent.init();
    Ajaxify.init();
    Popin.init();
    Alertify.init();
    Facebook.init();
    Tooltip.init();
    HeaderFiltersTitle.init();
    GmapStaticLoader.init();
    GmapSharedEmbed.init();
    FullscreenSlider.init();
    ModuleReservation.init();
    MoveReservation.init();
    ModuleCommand.init();
    CssRadioCheckbox.init();
    Layout_Favorites.init();
    Layout_MenuMobile.init();
    FormMultiCheckboxElement.init();
    VigneronsMenu.init();
    IntroductionTabs.init();
    CodePostalAutocomplete.init();
    Faq.init();
    $(document).confirmHelper();
    $('.front-datepicker').each(function () {
      var input = $(this);
      input.attr('autocomplete', 'off');
      input.datetimepicker({
        lang: 'fr',
        timepicker: false,
        format: 'd/m/Y',
        minDate: input.data('mindate'),
        startDate: input.data('mindate'),
        maxDate: input.data('maxdate'),
        scrollInput: false,
        closeOnDateSelect: true,
        dayOfWeekStart: 1,
        onGenerate: function onGenerate(ct) {
          $('.xdsoft_datetimepicker ').addClass('search-datetimepicker');
        },
        onClose: function onClose() {
          $(this).parent().find('.clear-datepicker').addClass('visible');
        }
      });
      if ($(this).hasClass('front-datepicker--allow-clear')) {
        $('<a class="ico-cross-grey clear-datepicker"/>').insertAfter(this);
        if ($(this).val() !== '') {
          $(this).parent().find('.clear-datepicker').addClass('visible');
        }
      }
    });
    $('body').on('click', '.clear-datepicker', function () {
      $(this).prev().val('');
      $(this).removeClass('visible');
    });
    $('.front-datetimepicker').datetimepicker({
      lang: $('#CURRENT_LANG').val(),
      format: 'd/m/Y H:i',
      scrollInput: false,
      dayOfWeekStart: 1,
      closeOnDateSelect: true,
      onGenerate: function onGenerate(ct) {
        $('.xdsoft_datetimepicker ').addClass('search-datetimepicker');
      }
    });
    if ((typeof tinymce === "undefined" ? "undefined" : _typeof(tinymce)) == 'object') {
      tinymce.init({
        selector: '.tinymce-light',
        font_formats: '',
        fontsize_formats: '',
        menubar: false,
        statusbar: false,
        content_css: '/css/reset-tinymce.css',
        plugins: 'paste',
        toolbar: "bold | italic | underline | pastetext"
      });
    }
    TableManager.init();
    OrderBtn.init();

    // Fixed Footer
    FixedFooter.init();
  },
  onResize: function onResize(windowWidth, windowHeight) {
    Front_IndexController.onResize();
    Pepites.onResize();
    HeaderFiltersTitle.onResize();
    ModuleReservation.onResize();
    IntroductionTabs.onResize();
    FullSearch.onResize(windowWidth, windowHeight);
    FormSearch.onResize();
    AppearingSticky.onResize();
    FixedFooter.onResize();
  },
  onScroll: function onScroll(scrollTop) {
    FormSearch.onScroll(scrollTop);
    ModuleReservation.onScroll(scrollTop);
    AppearingSticky.onScroll(scrollTop);
    FullSearch.onScroll(scrollTop);
  }
};
;
var Front_DomainesController = {
  // Methods
  nearestSliderLoaded: false,
  nearestSlider: null,
  init: function init() {
    this.initFicheAction();

    // disables slider inside block layout domain
    // only if domain status is ended
    if (parseInt($('#isOnline').val()) == 0) {
      $('.layout-domain-container .bxslider').addClass('loaded');
    }
    (function ($) {
      $(window).load(function () {
        var splitParams = window.location.href.split('?');
        if (splitParams.length > 1) {
          var search = splitParams[1].split('&');
          if (search.length > 0) {
            for (var i = 0; i < search.length; i++) {
              var params = search[i].split('=');
              if (params[0] === 'date') {
                var date = new Date();
                $('#date').val(date.toLocaleDateString('fr-FR')).closest('form').trigger('submit');
              }
            }
          }
        }
        var selectedDate = $(".form-search-domain").find("[name='date']").val();
        var adultes = $(".form-search-domain").find("[name='nb_adultes']").val();
        var lang = $(".form-search-domain").find("[name='lang']").val();
        if ('' !== selectedDate && adultes !== '' && adultes !== "0" && adultes !== 0 && lang !== '') {
          Activities.update(false);
        }
      });
    })(jQuery);
    $('#more-wines').on('click', function (e) {
      e.preventDefault();
      $(this).next('ul').removeClass('hidden');
      $(this).hide();
    });
    $('.wines-container .filter').on('click', function (e) {
      e.preventDefault();
      $('#more-wines').click();
    });
    $('body').on('click', 'main#content.controller-domaines .container-activity .main-block', function () {
      var href = $(this).closest('.container-activity').find('.sub-block .description a').attr('href');
      if (href !== undefined) {
        window.location = href;
      }
    });
    this.setNearestDomainsSlider();
    this.faqSnippetArrow();
    this.showServiceProvider();
  },
  initFicheAction: function initFicheAction() {
    if ($(".controller-domaines.action-fiche").length === 0) {
      return;
    }
    $(document).on("apply-filters-v2", function (e) {
      Activities.update(e.activitiesUpdateScrollToContainer);
    });
  },
  onScroll: function onScroll(scrollTop) {},
  onResize: function onResize(windowWidth, windowHeight) {},
  faqSnippetArrow: function faqSnippetArrow() {
    var accordion = Accordion.init('.schema-faq-question');
    accordion.showOne();
  },
  showServiceProvider: function showServiceProvider() {
    $('.js-see-more').on('click', function (e) {
      e.preventDefault();
      var $link = $(e.currentTarget);
      var $icon = $link.find('i');
      if ($icon.hasClass('up')) {
        $icon.removeClass('up');
        $icon.addClass('down');
      } else {
        $icon.removeClass('down');
        $icon.addClass('up');
      }
      if ($link.hasClass('open')) {
        $link.removeClass('open');
        $link.find('.text').text($link.data('closed-text'));
        $($link.data('target')).hide();
      } else {
        $link.addClass('open');
        $link.find('.text').text($link.data('opened-text'));
        $($link.data('target')).show();
      }
    });
  },
  setNearestDomainsSlider: function setNearestDomainsSlider() {
    if ($('.container-nearest-domains .layout-domain-container').size() == 0 || this.nearestSliderLoaded == true) return;
    var config = {
      pager: false,
      maxSlides: 3,
      slideWidth: $('.container-nearest-domains > .layout-domain-container').outerWidth(),
      hideControlOnEnd: true,
      infiniteLoop: false,
      moveSlides: 1,
      onSlideAfter: function onSlideAfter($slideElement, oldIndex, newIndex) {
        if (newIndex !== 0) {
          $('.block-nearest-domains > .bx-wrapper .bx-prev').addClass('enabled');
        }
      }
    };
    this.nearestSliderLoaded = true;
    this.nearestSlider = $('.container-nearest-domains').bxSlider(config);
  }
};
;
var Front_IndexController = {
  fondParallax: false,
  // Methods
  init: function init() {
    this.onResize($(window).width(), $(window).height());
  },
  indexAction: function indexAction() {
    Front_IndexController.fondParallax = $('.homepage-bloc-visuel .fond').get(0);
    $("a[href='#autourdemoi'], a[href='#aroundme']").click(function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      var lang = $(this).attr('href') == '#aroundme' ? 'en' : 'fr';
      navigator.geolocation.getCurrentPosition(function (position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        App.gotoPage('/' + lang + '/recherche?location=' + encodeURI(text) + '&id_location=' + latitude + '%2C' + longitude + '&type_location=geoloc&order=distance');
      });
    });
  },
  onScroll: function onScroll(scrollTop) {
    if (App.action === 'index') {
      scrollTop -= $('#homepage').offset().top;
      Front_IndexController.moveBackground(scrollTop / 4);
    }
  },
  onResize: function onResize(windowWidth, windowHeight) {
    if ($('body').hasClass('mobile-app')) {
      windowHeight = 500;
    }
    var $cookie_bar = $(".cookie-toolbar-container.open");
    if (!$cookie_bar.size()) {
      $homepage = $("#homepage");
      $homepage.find(".barre").css("bottom", 0);
      $homepage.find('.form').css("bottom", 0);
    }
  },
  moveBackground: function moveBackground(position, t) {
    $('body').on('keypress', '.form-search input#q', function () {});
    Front_IndexController.fondParallax.style.cssText = CSS.translate3d(0, position, 0, t);
  },
  depotAvisAction: function depotAvisAction() {
    // populate stars
    $('input.criteria').each(function (i, res) {
      if ($(res).val() != 0) {
        $element = $('.ratings .criteria[data-id=' + $(res).data('id') + ']');
        $element.find('.note').text($(res).val() + '/5');
        $element.find('.rating-item').eq(5 - $(res).val()).addClass('active'); // a cause du RTL
      }
    });

    // populate btn
    if ($("#id_note_occasion").val() != '') {
      $('.btn-occasion').find('.name').append("<span class='active'> : " + $(".btn-occasion a[data-id=" + $("#id_note_occasion").val() + "]").text() + " </span>");
    }
    $('.rating-item').on('click', function () {
      var index = $(this).index();
      $parent = $(this).parent('.container-ratings');
      $parent.find('.rating-item').removeClass('active');
      $(this).addClass('active');
      $parent.find('.note').text(6 - index + '/5');
      var id = $(this).parents('.criteria').data('id');
      $("#rating_" + id).val(6 - index);
    });
    $('.btn-occasion li a').on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $("#id_note_occasion").val($(this).data('id'));
      $(this).parents('.btn-occasion').find('.name .active').remove();
      $(this).parents('.btn-occasion').find('.name').append("<span class='active'> : " + $(this).text() + " </span>");
      $(this).parents('ul').find('li').show();
      $(this).parent('li').hide();
      $(this).parents('.btn-occasion').removeClass('open');
    });
    $('.Front_Form_Reservation_Rating').on('submit', function (e) {
      $('#submitRating').attr('disabled', true).addClass('loading');
    });
  }
};
;
var Front_IntroPartnersController = {
  presentationTimeout: false,
  presentationSlider: false,
  iconsSlider: [],
  // Methods
  init: function init() {},
  presentationAction: function presentationAction() {
    Front_IntroPartnersController.initPresentationSlider();
  },
  initPresentationSlider: function initPresentationSlider() {
    if (!Device.isTabletteXS) {
      // Desktop
      if (Front_IntroPartnersController.presentationSlider) {
        Front_IntroPartnersController.presentationSlider.destroySlider();
        Front_IntroPartnersController.presentationSlider = false;
      }
    } else {
      // Tablette
      if (!Front_IntroPartnersController.presentationSlider) {
        Front_IntroPartnersController.presentationSlider = $('.module-front.controller-intro-partners .bloc-top .icons').bxSlider({
          controls: false
        });
      }
    }
  },
  onResize: function onResize(windowWidth, windowHeight) {
    if (App.action == 'presentation') {
      if (Front_IntroPartnersController.presentationTimeout) clearTimeout(Front_IntroPartnersController.presentationTimeout);
      Front_IntroPartnersController.presentationTimeout = setTimeout(Front_IntroPartnersController.initPresentationSlider, 1000);
    }
  }
};
;
var Front_IntroVigneronsController = {
  presentationTimeout: false,
  presentationSlider: false,
  // Methods
  init: function init() {
    $("body").on('click', 'a.see-video', function (e) {
      e.preventDefault();
      var iframe = $("#video iframe");
      iframe.attr('src', iframe.data('src'));
      $('body,html').animate({
        scrollTop: $('#bloc-video').offset().top
      }, 600);
    });
  },
  presentationAction: function presentationAction() {
    Front_IntroVigneronsController.initPresentationSlider();
  },
  initPresentationSlider: function initPresentationSlider() {
    if (!Device.isTabletteXS) {
      // Desktop
      if (Front_IntroVigneronsController.presentationSlider) {
        Front_IntroVigneronsController.presentationSlider.destroySlider();
        Front_IntroVigneronsController.presentationSlider = false;
      }
    } else {
      // Tablette
      if (!Front_IntroVigneronsController.presentationSlider) {
        Front_IntroVigneronsController.presentationSlider = $('.module-front.controller-intro-vignerons .bloc-top .icons').bxSlider({
          controls: false
        });
      }
    }
  },
  onResize: function onResize(windowWidth, windowHeight) {
    if (App.action == 'presentation') {
      if (Front_IntroVigneronsController.presentationTimeout) clearTimeout(Front_IntroVigneronsController.presentationTimeout);
      Front_IntroVigneronsController.presentationTimeout = setTimeout(Front_IntroVigneronsController.initPresentationSlider, 1000);
    }
  }
};
;
var Front_SearchController = {
  supportsFlexbox: false,
  // Methods
  init: function init() {
    this.supportsFlexbox = $("html").hasClass("flexbox");
    this.faqSnippetArrow();
    this.setFirstVisible();
  },
  indexAction: function indexAction() {
    this.setDomainsBlocksSizes();

    // // SEO banner
    // $("body").on("click", ".contenu-seo h1", function () {
    //     $(this).siblings(".description").slideToggle();
    // });
  },

  onResize: function onResize(windowWidth, windowHeight) {
    this.setDomainsBlocksSizes();
  },
  faqSnippetArrow: function faqSnippetArrow() {
    var accordion = Accordion.init('.schema-faq-question');
    accordion.showOne();
  },
  setDomainsBlocksSizes: function setDomainsBlocksSizes() {
    if (!this.supportsFlexbox) {
      var $container = $(".search-domains-container");
      var $domains = $container.find(".layout-domain-container");
      var $prevDomain;
      var domainHeight, prevHeight;
      $domains.find(".inner").height("auto");
      if ($domains.size() && $domains.first().width() != $container.width()) {
        $domains.filter(":odd").each(function () {
          var $self = $(this);
          $prevDomain = $self.prev(".layout-domain-container");
          domainHeight = $self.height();
          prevHeight = $prevDomain.height();
          if (domainHeight > prevHeight) {
            $prevDomain.children(".inner").height(domainHeight);
          } else {
            $self.children(".inner").height(prevHeight);
          }
        });
      }
    }
  },
  setFirstVisible: function setFirstVisible() {
    $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();
      var windowHeight = $(window).height();
      var first = false;
      $(".layout-domain-container").each(function () {
        var offset = $(this).offset();
        if (scrollTop <= offset.top && $(this).height() + offset.top < scrollTop + windowHeight && first == false) {
          $(this).addClass("first");
          first = true;
        } else {
          $(this).removeClass("first");
          first = false;
        }
      });
    });
    $(window).trigger('scroll');
  }
};
;
var Front_TestsController = {
  // Methods
  init: function init() {},
  // Methods
  mapAction: function mapAction() {
    // Load Google Map
    GoogleMap.load();
  },
  datepickerAction: function datepickerAction() {
    $('.date-picker').datetimepicker({
      lang: $('#CURRENT_LANG').val(),
      timepicker: false,
      format: 'd/m/Y',
      closeOnDateSelect: true,
      dayOfWeekStart: 1
    });
  },
  // Methods
  map2Action: function map2Action() {
    // Load Google Map
    GoogleMap.load('Front_TestsController.map2MapOK');
  },
  map2MapOK: function map2MapOK() {
    // Création de la Google Map
    GoogleMap.map = new google.maps.Map(GoogleMap.mapElement.get(0), {
      center: {
        lat: 45.7667,
        lng: 4.13333
      },
      zoom: 8
    });
    var villes = JSON.parse($('#villes').val());
    for (var i = 0; i < villes.length; i++) {
      GoogleMap.addMarker(villes[i].latitude, villes[i].longitude, villes[i].nom, GoogleMap.map, 'red');
    }

    // Coordonnées Source / Destination
    var pointA = $('#pointA').val().split(',');
    var pointB = $('#pointB').val().split(',');

    // Marker Source / Destination
    GoogleMap.addMarker(parseFloat(pointA[1]), parseFloat(pointA[0]), 'Source', GoogleMap.map, 'green', 1000);
    GoogleMap.addMarker(parseFloat(pointB[1]), parseFloat(pointB[0]), 'Destination', GoogleMap.map, 'green', 1000);
  }
};
;
var Front_TunnelGiftCardsController = {
  // Methods
  nbSymbolsGiftCard: 3,
  initStripe: function initStripe() {
    if ($("#form-validation-card-command").length === 0) {
      return;
    }
    var stripePublicKey = window.globalValues && window.globalValues.stripe_public_key ? window.globalValues.stripe_public_key : null;
    if (null === stripePublicKey) {
      throw new Error("Stripe could not be initialized. No stripePublicKey found");
    }
    var stripe = Stripe(stripePublicKey);
    var pay = function pay() {
      var url = $("#tunnel-gift-card-create-command_url").val();
      $("ul.errors").remove();
      $(".form-group.errors").removeClass("errors");
      var fetchPaymentIntent = function fetchPaymentIntent() {
        return new Promise(function (resolve, reject) {
          $.post(url, $("#form-validation-card-command").serialize(), function (result) {
            if (result.formErrors !== undefined) {
              for (var property in result.formErrors) {
                var fieldErrors = result.formErrors[property];
                $(".form-group." + property).addClass("error");
                var errorsContainer = $('<ul class="errors"></ul>');
                for (var errorKey in fieldErrors) {
                  var li = $("<li></li>");
                  li.text(fieldErrors[errorKey]);
                  li.appendTo(errorsContainer);
                }
                $("#" + property + "-element").append(errorsContainer);
              }
            }
            if (result.error !== undefined) {
              reject(result.error);
              return;
            }
            resolve(result);
          }, "json").fail(function (error) {
            reject(error);
          });
        });
      };
      fetchPaymentIntent().then(function (result) {
        var clientSecret = result.client_secret;
        return stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: cardElement
          }
        });
      }).then(function (result) {
        return new Promise(function (resolve, reject) {
          if (result.error !== undefined) {
            var _result$error$message;
            var errorMessage = _typeof(result.error) === "object" ? (_result$error$message = result.error.message) !== null && _result$error$message !== void 0 ? _result$error$message : JSON.stringify(result.error) : result.error;
            dataLayer.push({
              event: "payment_failed",
              error: errorMessage
            });
            reject(result.error.message);
            return;
          }
          resolve(result);
        });
      }).then(function (result) {
        Front_TunnelGiftCardsController.pollPendingPayment();
      }).catch(function (error) {
        $(".loader").hide();
        if (_typeof(error) === "object") {
          alert(error.message);
          if (error.redirectUrl !== undefined) {
            window.location = error.redirectUrl;
          }
        } else {
          alert(error);
        }
      });
    };
    var setupElements = function setupElements() {
      var elements = stripe.elements({
        locale: window.globalValues.language
      });
      var card = elements.create("card", {
        style: {
          base: {
            color: "#32325D",
            fontWeight: 500,
            fontFamily: "Inter, Open Sans, Segoe UI, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#CFD7DF"
            }
          },
          invalid: {
            color: "#E25950"
          }
        }
      });
      card.mount("#card-element");
      return card;
    };
    var cardElement = setupElements();
    $("#validate").on("click", function (e) {
      e.preventDefault();
      if (false === $("#form-validation-card-command")[0].reportValidity()) {
        return;
      }
      $(".loader").show();
      pay();
    });
  },
  initMobileSticky: function initMobileSticky() {
    $("#mobile-validate-button").on("click", function () {
      $("#form-validation-card-command #validate").click();
    });
  },
  init: function init() {
    this.initStripe();
    this.resumeLoading();
    this.initMobileSticky();
  },
  onScroll: function onScroll(scrollTop) {},
  onResize: function onResize(windowWidth, windowHeight) {},
  pollPendingPayment: function pollPendingPayment() {
    var keepPolling = true;
    $(".loader").show();
    (function poll() {
      var url = $("#check_pending_payment").val();
      setTimeout(function () {
        $.ajax({
          url: url,
          type: "GET",
          success: function success(data) {
            if (!data.values || data.values.code !== "PROCESSING") {
              keepPolling = false;
              $(".loader").hide();
              if (data.values.code === "SUCCESS") {
                window.location = $("#success_confirmation_url").val();
              } else {
                alert(data.values.message);
                if (data.values.code === "PAYMENT_ERROR") {
                  dataLayer.push({
                    event: "payment_failed",
                    error: {
                      message: data.values.code + " : " + data.values.message
                    }
                  });
                }
              }
            }
          },
          dataType: "json",
          complete: function complete() {
            if (keepPolling) {
              poll();
            }
          },
          timeout: 2000
        });
      }, 5000);
    })();
  },
  resumeLoading: function resumeLoading() {
    if ($(".content.is-pending-payment-intent").length > 0) {
      Front_TunnelGiftCardsController.pollPendingPayment();
    }
  }
};
;
var Front_TunnelReservationController = {
  // Methods
  nbSymbolsGiftCard: 3,
  stripe: null,
  cardElement: null,
  initStripe: function initStripe() {
    if ($("#card-element").length === 0) {
      return;
    }
    var stripePublicKey = window.globalValues && window.globalValues.stripe_public_key ? window.globalValues.stripe_public_key : null;
    if (null === stripePublicKey) {
      throw new Error("Stripe could not be initialized. No stripePublicKey found");
    }
    var stripe = Stripe(stripePublicKey);
    this.stripe = stripe;
    var setupElements = function setupElements() {
      var elements = stripe.elements({
        locale: window.globalValues.language
      });
      var card = elements.create("card", {
        style: {
          base: {
            color: "#32325D",
            fontWeight: 500,
            fontFamily: "Inter, Open Sans, Segoe UI, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#CFD7DF"
            }
          },
          invalid: {
            color: "#E25950"
          }
        }
      });
      card.mount("#card-element");
      return card;
    };
    this.cardElement = setupElements();
  },
  initMobileSticky: function initMobileSticky() {
    $("#mobile-validate-button").on("click", function () {
      $("#reservation_form #validate").click();
    });
  },
  initContactForm: function initContactForm() {
    // update contact form as validation fields are filled
    if ($(".action-validation").length === 0) {
      return;
    }
    $('#reservation_form select[name="gender"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_genre"]').val(value).change();
    });
    $('#reservation_form input[name="first_name"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_prenom"]').val(value).change();
    });
    $('#reservation_form input[name="last_name"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_nom_famille"]').val(value).change();
    });
    $('#reservation_form input[name="email"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_email"]').val(value).change();
    });
    $('#reservation_form select[name="tel_indicatif"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_tel_indicatif"]').val(value).change();
    });
    $('#reservation_form input[name="tel_number"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_tel_numero"]').val(value).change();
    });
    $('#reservation_form input[name="gift_card"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_code_cadeau"]').val(value).change();
    });
    $('#reservation_form textarea[name="comments"]').change(function (e) {
      var value = $(this).val();
      $('#validation-contact form input[name="form_demande_speciale"]').val(value).change();
    });
  },
  init: function init() {
    this.initStripe();
    this.initContactForm();
    this.handleGiftCardChange();
    this.handlePhoneCountryChange();
    this.handleMakeReservation();
    this.resumeLoading();
    this.initMobileSticky();
    this.initAffiliatedPartner();
  },
  onScroll: function onScroll(scrollTop) {},
  onResize: function onResize(windowWidth, windowHeight) {},
  bankImprint: function bankImprint() {
    var stripe = this.stripe;
    var cardElement = this.cardElement;
    var token = $("#token").val();
    var url = $("#setup_intent_url").val() + "?token=" + token;
    var fetchSetupIntent = function fetchSetupIntent() {
      return new Promise(function (resolve, reject) {
        $.post(url, function (result) {
          if (result.error !== undefined) {
            reject(result.error);
            return;
          }
          resolve(result);
        }, "json").fail(function (error) {
          reject(error);
        });
      });
    };
    fetchSetupIntent().then(function (result) {
      var clientSecret = result.client_secret;
      return stripe.confirmCardSetup(clientSecret, {
        return_url: document.location.href,
        payment_method: {
          card: cardElement
        }
      });
    }).then(function (result) {
      return new Promise(function (resolve, reject) {
        var _result$error, _result$error$payment;
        if (((_result$error = result.error) === null || _result$error === void 0 ? void 0 : (_result$error$payment = _result$error.payment_intent) === null || _result$error$payment === void 0 ? void 0 : _result$error$payment.status) === "succeeded") {
          resolve(result);
        }
        if (result.error !== undefined) {
          reject(result.error.message);
        }
        resolve(result);
      });
    }).then(function (result) {
      Front_TunnelReservationController.pollPendingPayment();
    }).catch(function (error) {
      var _error$message;
      $(".loader").hide();
      var errorMessage = _typeof(error) === "object" ? (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : JSON.stringify(error) : error;
      alert(errorMessage);
      dataLayer.push({
        event: "bank_imprint_failed",
        error: errorMessage
      });
    });
  },
  pay: function pay() {
    var token = $("#token").val();
    var stripe = this.stripe;
    var cardElement = this.cardElement;
    var fetchPaymentIntent = function fetchPaymentIntent() {
      return new Promise(function (resolve, reject) {
        var url = $("#payment_url").val() + "?token=" + token;
        $.post(url, function (result) {
          if (result.error !== undefined) {
            reject(result.error);
            return;
          }
          resolve(result);
        }, "json").fail(function (error) {
          reject(error);
        });
      });
    };
    fetchPaymentIntent().then(function (result) {
      var clientSecret = result.client_secret;
      return stripe.confirmCardPayment(clientSecret, {
        return_url: document.location.href,
        payment_method: {
          card: cardElement
        }
      });
    }).then(function (result) {
      return new Promise(function (resolve, reject) {
        var _result$error2, _result$error2$paymen;
        if (((_result$error2 = result.error) === null || _result$error2 === void 0 ? void 0 : (_result$error2$paymen = _result$error2.payment_intent) === null || _result$error2$paymen === void 0 ? void 0 : _result$error2$paymen.status) === "succeeded") {
          resolve(result);
        }
        if (result.error !== undefined) {
          reject(result.error.message);
        }
        resolve(result);
      });
    }).then(function (result) {
      Front_TunnelReservationController.pollPendingPayment();
    }).catch(function (error) {
      var _error$message2;
      $(".loader").hide();
      var errorMessage = _typeof(error) === "object" ? (_error$message2 = error.message) !== null && _error$message2 !== void 0 ? _error$message2 : JSON.stringify(error) : error;
      alert(errorMessage);
      dataLayer.push({
        event: "payment_failed",
        error: error
      });
    });
  },
  handleGiftCardChange: function handleGiftCardChange() {
    $("#gift_card").on("input", function () {
      if ($(this).val()) {
        $("#gift_card_button").prop("disabled", false);
      } else {
        $("#gift_card_button").prop("disabled", true);
      }
    });
    $("#gift_card_button").on("click", function (e) {
      var data = $("#reservation_form").serialize();
      var typeform = $("#typeform").val();
      App.gotoPage($("#BASEURL").val() + (typeform ? "/" + typeform : "") + "?" + data + "&populate=1");
    });
    if ($("#gift_card").val() !== "") {
      $("#fieldset-gift_card_group").addClass("open");
      $("#gift_card_button").prop("disabled", false);
    } else {
      $("#gift_card_button").prop("disabled", true);
    }
  },
  handlePhoneCountryChange: function handlePhoneCountryChange() {
    $("#reservation_form #tel_indicatif").on("change", function () {
      var val = $(this).val();
      var typeform = $("#typeform").val();
      var change = false;
      if (typeform == "fr" && val != "FR (+33)") {
        typeform = "b";
        change = true;
      }
      if (typeform != "fr" && val == "FR (+33)") {
        typeform = "fr";
        change = true;
      }
      if (change) {
        $("#typeform").remove();
        var data = $("#reservation_form").serialize();
        App.gotoPage($("#BASEURL").val() + (typeform ? "/" + typeform : "") + "?" + data + "&populate=1");
      }
    });
  },
  handleMakeReservation: function handleMakeReservation() {
    $("#validate").on("click", function (e) {
      e.preventDefault();
      var $form = $("#reservation_form");
      var url = $form.data("submit");
      var submitAjax = function submitAjax() {
        return new Promise(function (resolve, reject) {
          if (false === $form[0].reportValidity()) {
            $(".loader").hide();
            return;
          }
          $.ajax({
            method: "post",
            url: url,
            data: $form.serialize(),
            dataType: "json",
            cache: false,
            success: function success(res) {
              resolve(res);
            }
          }).fail(function (err) {
            reject(err);
          });
        });
      };
      $(".loader").show();
      submitAjax().then(function (result) {
        if (result.formErrors !== undefined) {
          $(".loader").hide();
          $("#hash").val(result.hash);
          var data = $("#reservation_form").serialize();
          var typeform = $("#typeform").val();
          App.gotoPage($("#BASEURL").val() + (typeform ? "/" + typeform : "") + "?" + data + "&validate=1&formErrors=1");
          return;
        }
        if (result.error !== undefined) {
          var _result$error$message2;
          var errorMessage = _typeof(result.error) === "object" ? (_result$error$message2 = result.error.message) !== null && _result$error$message2 !== void 0 ? _result$error$message2 : JSON.stringify(result.error) : result.error;
          alert(errorMessage);
          $(".loader").hide();
          dataLayer.push({
            event: "make_reservation_failed",
            error: errorMessage
          });
          return;
        }
        var tunnelMode = $("#reservation_form").attr("tunnelmode");
        $("#token").val(result.token);
        if (tunnelMode === "bank_imprint") {
          Front_TunnelReservationController.bankImprint(result.token);
        }
        if (tunnelMode === "online") {
          Front_TunnelReservationController.pay(result.token);
        }
        if (tunnelMode === "offline") {
          window.location = $("#success_confirmation_url").val();
          return;
        }
      });
    });
  },
  pollPendingPayment: function pollPendingPayment() {
    var keepPolling = true;
    $(".loader").show();
    (function poll() {
      var token = $("#token").val();
      var url = $("#check_pending_payment").val();
      setTimeout(function () {
        var _$$ajax;
        $.ajax((_$$ajax = {
          url: url,
          type: "POST",
          data: JSON.stringify({
            token: token
          }),
          dataType: "json",
          success: function success(data) {
            if (!data.values || data.values.code !== "PROCESSING") {
              var _data$values;
              keepPolling = false;
              $(".loader").hide();
              if (((_data$values = data.values) === null || _data$values === void 0 ? void 0 : _data$values.code) === "SUCCESS") {
                window.location = $("#success_confirmation_url").val();
              } else {
                var _data$values$message;
                alert((_data$values$message = data.values.message) !== null && _data$values$message !== void 0 ? _data$values$message : data.message);
                if (data.values.code === "PAYMENT_ERROR") {
                  dataLayer.push({
                    event: "payment_failed",
                    error: {
                      message: data.values.code + " : " + data.values.message
                    }
                  });
                }
              }
            }
          }
        }, _defineProperty(_$$ajax, "dataType", "json"), _defineProperty(_$$ajax, "complete", function complete() {
          if (keepPolling) {
            poll();
          }
        }), _defineProperty(_$$ajax, "timeout", 2000), _$$ajax));
      }, 5000);
    })();
  },
  resumeLoading: function resumeLoading() {
    if ($(".content.is-pending-setup-intent").length > 0) {
      Front_TunnelReservationController.pollPendingPayment();
    }
    if ($(".content.is-pending-payment-intent").length > 0) {
      Front_TunnelReservationController.pollPendingPayment();
    }
  },
  initAffiliatedPartner: function initAffiliatedPartner() {
    var selectElement = document.getElementById('affiliated_partner_id');
    if (!selectElement) {
      return;
    }
    var selectAffiliatedPayment = document.getElementById('affiliated_payment');
    $(selectElement).on('select2:select', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var selectedId, formFields, field, response, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            selectedId = $(selectElement).val();
            formFields = {
              nom: document.getElementById('last_name'),
              prenom: document.getElementById('first_name'),
              email: document.getElementById('email'),
              phone: document.getElementById('tel_number'),
              phone_indicatif: document.getElementById('tel_indicatif')
            };
            if (!(selectedId === '0')) {
              _context.next = 9;
              break;
            }
            selectAffiliatedPayment.value = "0";
            for (field in formFields) {
              formFields[field].value = '';
            }
            formFields.phone_indicatif.value = 'FR (+33)';
            return _context.abrupt("return");
          case 9:
            selectAffiliatedPayment.disabled = false;
          case 10:
            _context.next = 12;
            return fetch("/tunnel-reservation/affiliated-partner?partner_id=".concat(selectedId));
          case 12:
            response = _context.sent;
            if (response.ok) {
              _context.next = 15;
              break;
            }
            throw new Error('Erreur réseau ou URL incorrecte');
          case 15:
            _context.next = 17;
            return response.json();
          case 17:
            data = _context.sent;
            if (data.ok && data.partner) {
              formFields.nom.value = data.partner.last_name || '';
              formFields.prenom.value = data.partner.first_name || '';
              formFields.email.value = data.partner.email || '';
              formFields.phone.value = data.partner.tel || '';
              if (data.partner.tel_indic) {
                formFields.phone_indicatif.value = data.partner.tel_indic;
              }
            }
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
  }
};
;
var Vignerons_AffiliatedPartnersController = {
  init: function init() {
    this.initListAction();
  },
  initListAction: function initListAction() {
    if ($("#content.controller-affiliated-partners.action-index").length === 0) {
      return;
    }
    var fr = {
      "sEmptyTable": "Aucune donnée disponible dans le tableau",
      "sInfo": "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
      "sInfoEmpty": "Affichage de l'élément 0 à 0 sur 0 élément",
      "sInfoFiltered": "(filtré à partir de _MAX_ éléments au total)",
      "sInfoPostFix": "",
      "sInfoThousands": ",",
      "sLengthMenu": "Afficher _MENU_ éléments",
      "sLoadingRecords": "Chargement...",
      "sProcessing": "Traitement...",
      "sSearch": "Rechercher :",
      "sZeroRecords": "Aucun élément correspondant trouvé",
      "oPaginate": {
        "sFirst": "Premier",
        "sLast": "Dernier",
        "sNext": "Suivant",
        "sPrevious": "Précédent"
      },
      "oAria": {
        "sSortAscending": ": activer pour trier la colonne par ordre croissant",
        "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
      },
      "select": {
        "rows": {
          "_": "%d lignes sélectionnées",
          "0": "Aucune ligne sélectionnée",
          "1": "1 ligne sélectionnée"
        }
      }
    };
    $(function () {
      var $table = $('#affiliated-partners-table');
      var dt = $table.DataTable({
        "type": "POST",
        "dataType": "json",
        "language": fr,
        "lengthChange": false,
        "bFilter": false,
        "ordering": false,
        "pagingType": "simple_numbers",
        "bInfo": false,
        "pageLength": 15,
        "processing": true,
        "serverSide": true,
        "scrollX": true,
        "ajax": {
          "url": $table.data("post-ajax"),
          "type": "POST",
          "dataType": "json",
          "data": function data(d) {
            return d;
          }
        }
      });
      var $result_count_span = $("#rtable_count");
      $table.on('xhr.dt', function (e, settings, json) {
        $result_count_span.text(' (' + json.recordsFiltered + ')');
      });
      $table.on('processing.dt', function (e, settings, processing) {
        if (processing) {
          $table.addClass('processing');
        } else {
          $table.removeClass('processing');
        }
      });
    });
  }
};
;
var Vignerons_DocumentsController = {
  init: function init() {
    this.initListAction();
  },
  initListAction: function initListAction() {
    if ($("#content.controller-documents.action-list").length === 0) {
      return;
    }
    var datepickerLocale = {
      "format": "DD/MM/YYYY",
      "separator": " - ",
      "applyLabel": "Appliquer",
      "cancelLabel": "Effacer",
      "fromLabel": "Du",
      "toLabel": "Au",
      "customRangeLabel": "Custom",
      "weekLabel": "W",
      "daysOfWeek": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
      "monthNames": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"],
      "firstDay": 1
    };
    var fr = {
      "sEmptyTable": "Aucune donnée disponible dans le tableau",
      "sInfo": "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
      "sInfoEmpty": "Affichage de l'élément 0 à 0 sur 0 élément",
      "sInfoFiltered": "(filtré à partir de _MAX_ éléments au total)",
      "sInfoPostFix": "",
      "sInfoThousands": ",",
      "sLengthMenu": "Afficher _MENU_ éléments",
      "sLoadingRecords": "Chargement...",
      "sProcessing": "Traitement...",
      "sSearch": "Rechercher :",
      "sZeroRecords": "Aucun élément correspondant trouvé",
      "oPaginate": {
        "sFirst": "Premier",
        "sLast": "Dernier",
        "sNext": "Suivant",
        "sPrevious": "Précédent"
      },
      "oAria": {
        "sSortAscending": ": activer pour trier la colonne par ordre croissant",
        "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
      },
      "select": {
        "rows": {
          "_": "%d lignes sélectionnées",
          "0": "Aucune ligne sélectionnée",
          "1": "1 ligne sélectionnée"
        }
      }
    };
    $(function () {
      var daterangepicker = $('input[name="daterange"]');
      var $table = $('#documents-table');
      daterangepicker.daterangepicker({
        opens: 'right',
        autoUpdateInput: false,
        locale: datepickerLocale
      });
      var dt = $table.DataTable({
        "type": "POST",
        "dataType": "json",
        "language": fr,
        "lengthChange": false,
        "bFilter": false,
        "ordering": false,
        "pagingType": "simple_numbers",
        "bInfo": false,
        "pageLength": 15,
        "processing": true,
        "serverSide": true,
        "scrollX": true,
        "ajax": {
          "url": $table.data("post-ajax"),
          "type": "POST",
          "dataType": "json",
          "data": function data(d) {
            if (daterangepicker.data('val') !== '') {
              d.daterange = daterangepicker.data('val');
            }
            return d;
          }
        }
      });
      var $result_count_span = $("#rtable_count");
      $table.on('xhr.dt', function (e, settings, json) {
        $result_count_span.text(' (' + json.recordsFiltered + ')');
      });
      $table.on('processing.dt', function (e, settings, processing) {
        if (processing) {
          $table.addClass('processing');
        } else {
          $table.removeClass('processing');
        }
      });
      daterangepicker.on('apply.daterangepicker', function (ev, picker) {
        var label = picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY');
        var value = picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD');
        $(this).data('val', value);
        $(this).val(label);
        dt.ajax.reload();
      });
      daterangepicker.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val($(this).data('placeholder'));
        $(this).data('val', '');
        dt.ajax.reload();
      });
    });
  }
};
;
var Vignerons_GiftCardCommandController = {
  init: function init() {
    this.initListAction();
  },
  initListAction: function initListAction() {
    if ($("#content.controller-gift-card-command.action-list").length === 0) {
      return;
    }
    var datepickerLocale = {
      "format": "DD/MM/YYYY",
      "separator": " - ",
      "applyLabel": "Appliquer",
      "cancelLabel": "Effacer",
      "fromLabel": "Du",
      "toLabel": "Au",
      "customRangeLabel": "Custom",
      "weekLabel": "W",
      "daysOfWeek": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
      "monthNames": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"],
      "firstDay": 1
    };
    var fr = {
      "sEmptyTable": "Aucune donnée disponible dans le tableau",
      "sInfo": "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
      "sInfoEmpty": "Affichage de l'élément 0 à 0 sur 0 élément",
      "sInfoFiltered": "(filtré à partir de _MAX_ éléments au total)",
      "sInfoPostFix": "",
      "sInfoThousands": ",",
      "sLengthMenu": "Afficher _MENU_ éléments",
      "sLoadingRecords": "Chargement...",
      "sProcessing": "Traitement...",
      "sSearch": "Rechercher :",
      "sZeroRecords": "Aucun élément correspondant trouvé",
      "oPaginate": {
        "sFirst": "Premier",
        "sLast": "Dernier",
        "sNext": "Suivant",
        "sPrevious": "Précédent"
      },
      "oAria": {
        "sSortAscending": ": activer pour trier la colonne par ordre croissant",
        "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
      },
      "select": {
        "rows": {
          "_": "%d lignes sélectionnées",
          "0": "Aucune ligne sélectionnée",
          "1": "1 ligne sélectionnée"
        }
      }
    };
    $(function () {
      var daterangepicker = $('input[name="daterange"]');
      var $table = $('#gift-card-command-table');
      daterangepicker.daterangepicker({
        opens: 'right',
        autoUpdateInput: false,
        locale: datepickerLocale
      });
      var dt = $table.DataTable({
        "type": "POST",
        "dataType": "json",
        "language": fr,
        "lengthChange": false,
        "bFilter": false,
        "pagingType": "simple_numbers",
        "bInfo": false,
        "pageLength": 15,
        "processing": true,
        "serverSide": true,
        "scrollX": true,
        "ajax": {
          "url": $table.data("post-ajax"),
          "type": "POST",
          "dataType": "json",
          "data": function data(d) {
            if (daterangepicker.data('val') !== '') {
              d.daterange = daterangepicker.data('val');
            }
            return d;
          }
        }
      });
      var $result_count_span = $("#rtable_count");
      $table.on('xhr.dt', function (e, settings, json) {
        $result_count_span.text(' (' + json.recordsFiltered + ')');
      });
      $table.on('processing.dt', function (e, settings, processing) {
        if (processing) {
          $table.addClass('processing');
        } else {
          $table.removeClass('processing');
        }
      });
      daterangepicker.on('apply.daterangepicker', function (ev, picker) {
        var label = picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY');
        var value = picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD');
        $(this).data('val', value);
        $(this).val(label);
        dt.ajax.reload();
      });
      daterangepicker.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val($(this).data('placeholder'));
        $(this).data('val', '');
        dt.ajax.reload();
      });
    });
  }
};
var Vignerons_ReservationsController = {
  init: function init() {
    this.initIndexAction();
    this.initListAction();
  },
  initIndexAction: function initIndexAction() {
    if ($(".module-vignerons.controller-reservations.action-index").length === 0) {
      return;
    }
    $(document).on("apply-filters-v2", function (e) {
      Activities.update(e.activitiesUpdateScrollToContainer);
    });
  },
  initListAction: function initListAction() {
    if ($("#content.controller-reservations.action-list").length === 0) {
      return;
    }
    var datepickerLocale = {
      "format": "DD/MM/YYYY",
      "separator": " - ",
      "applyLabel": "Appliquer",
      "cancelLabel": "Effacer",
      "fromLabel": "Du",
      "toLabel": "Au",
      "customRangeLabel": "Custom",
      "weekLabel": "W",
      "daysOfWeek": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
      "monthNames": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"],
      "firstDay": 1
    };
    var fr = {
      "sEmptyTable": "Aucune donnée disponible dans le tableau",
      "sInfo": "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
      "sInfoEmpty": "Affichage de l'élément 0 à 0 sur 0 élément",
      "sInfoFiltered": "(filtré à partir de _MAX_ éléments au total)",
      "sInfoPostFix": "",
      "sInfoThousands": ",",
      "sLengthMenu": "Afficher _MENU_ éléments",
      "sLoadingRecords": "Chargement...",
      "sProcessing": "Traitement...",
      "sSearch": "Rechercher :",
      "sZeroRecords": "Aucun élément correspondant trouvé",
      "oPaginate": {
        "sFirst": "Premier",
        "sLast": "Dernier",
        "sNext": "Suivant",
        "sPrevious": "Précédent"
      },
      "oAria": {
        "sSortAscending": ": activer pour trier la colonne par ordre croissant",
        "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
      },
      "select": {
        "rows": {
          "_": "%d lignes sélectionnées",
          "0": "Aucune ligne sélectionnée",
          "1": "1 ligne sélectionnée"
        }
      }
    };
    $(function () {
      var daterangepicker = $('input[name="daterange"]');
      var $table = $('#reservations-table');
      daterangepicker.daterangepicker({
        opens: 'right',
        autoUpdateInput: false,
        locale: datepickerLocale
      });
      var affiliatedPartners = [];
      var dt = $table.DataTable({
        "type": "POST",
        "dataType": "json",
        "language": fr,
        "lengthChange": false,
        "bFilter": false,
        "pagingType": "simple_numbers",
        "bInfo": false,
        "pageLength": 15,
        "processing": true,
        "serverSide": true,
        "scrollX": true,
        "ajax": {
          "url": $table.data("post-ajax"),
          "type": "POST",
          "dataType": "json",
          "data": function data(d) {
            if (daterangepicker.data('val') !== '') {
              d.daterange = daterangepicker.data('val');
            }
            d.affiliated_partners = affiliatedPartners;
            return d;
          }
        }
      });
      var $result_count_span = $("#rtable_count");
      $table.on('xhr.dt', function (e, settings, json) {
        $result_count_span.text(' (' + json.recordsFiltered + ')');
      });
      $table.on('processing.dt', function (e, settings, processing) {
        if (processing) {
          $table.addClass('processing');
        } else {
          $table.removeClass('processing');
        }
      });
      daterangepicker.on('apply.daterangepicker', function (ev, picker) {
        var label = picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY');
        var value = picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD');
        $(this).data('val', value);
        $(this).val(label);
        dt.ajax.reload();
      });
      daterangepicker.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val($(this).data('placeholder'));
        $(this).data('val', '');
        dt.ajax.reload();
      });
      var $selectAffiliatedPartners = $("#filter-affiliated-partners-select");
      var dialog = document.getElementById("dialog-filter-affiliated-partner");
      $(dialog).on("showModal", function () {
        if (!$selectAffiliatedPartners.hasClass('initialized')) {
          setTimeout(function () {
            $selectAffiliatedPartners.select2({
              width: 'element',
              dropdownParent: $("#dialog-filter-affiliated-partner"),
              dropdownAutoWidth: true
            });
          }, 5);
          $selectAffiliatedPartners.addClass('initialized');
        }
      });
      var $filterBtnAffiliatedPartners = $("#js-filter-btn-affiliated-partner");
      var updateAffiliatedPartnerFilterBtn = function updateAffiliatedPartnerFilterBtn() {
        if (affiliatedPartners.length > 0) {
          var $option = $selectAffiliatedPartners.find('option[value="' + affiliatedPartners[0] + '"]').first();
          var text = $option.text();
          if (affiliatedPartners.length > 1) {
            text = text + ' (+ ' + (affiliatedPartners.length - 1) + ')';
          }
          $filterBtnAffiliatedPartners.text(text);
        } else {
          $filterBtnAffiliatedPartners.text($filterBtnAffiliatedPartners.data('placeholder'));
        }
      };
      $("#js-btn-confirm-partners").on('click', function (e) {
        var _$selectAffiliatedPar;
        $(dialog).trigger("close");
        affiliatedPartners = (_$selectAffiliatedPar = $selectAffiliatedPartners.val()) !== null && _$selectAffiliatedPar !== void 0 ? _$selectAffiliatedPar : [];
        updateAffiliatedPartnerFilterBtn();
        dt.ajax.reload();
      });
      $("#js-btn-clear-partners").on('click', function (e) {
        $(dialog).trigger("close");
        $selectAffiliatedPartners.val(null).trigger('change');
        affiliatedPartners = [];
        updateAffiliatedPartnerFilterBtn();
        dt.ajax.reload();
      });
      $("#js-btn-export").on('click', function (e) {
        var url = $(this).data('url');
        var dateRange = daterangepicker.data('val');
        if (!dateRange || dateRange === '') {
          dateRange = '';
        }
        var searchParams = new URLSearchParams({
          affiliated_partners: JSON.stringify(affiliatedPartners),
          daterange: dateRange
        });
        var queryString = searchParams.toString();
        var redirect = url + "?" + queryString;
        window.location = redirect;
      });
    });
  }
};
var Vignerons_SettingsController_OnlinePayment = {
  stripe: null,
  init: function init() {
    if ($("#Vignerons_Form_Infos_StepOnlinePayment").length === 0) {
      return;
    }
    var stripe = Stripe(globalValues.stripe_public_key);
    this.stripe = stripe;
    var link = document.querySelector('#stripeOnboarding');
    var showError = function showError(error) {
      console.error(error);
      var $div = $('#stripe-error');
      if ($div.length <= 0) {
        $div = $('<div class="errors"></div>').appendTo('#stripe_message-element');
        $div.css('margin-top', '2em');
      }
      $div.text("D\xE9sol\xE9, une erreur est survenue. Code : \"".concat(error.code, "\", Message: \"").concat(error.message, "\""));
    };
    var handleClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var hasAccount, resultUrl, accountData, accountResult, iban, bankAccountResult, createAccount, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              $(link).addClass('btn-disabled');
              hasAccount = globalValues.account === undefined;
              resultUrl = '';
              if (hasAccount) {
                _context2.next = 33;
                break;
              }
              accountData = globalValues.account;
              accountData.tos_shown_and_accepted = true;
              _context2.next = 9;
              return stripe.createToken('account', accountData);
            case 9:
              accountResult = _context2.sent;
              if (!(accountResult.error !== undefined)) {
                _context2.next = 14;
                break;
              }
              $(link).removeClass('btn-disabled');
              showError(accountResult.error);
              return _context2.abrupt("return");
            case 14:
              iban = $("#iban_stripe-element .text-splitted").map(function (index, elem) {
                return $(elem).children('input').val();
              }).get().join('');
              _context2.next = 17;
              return stripe.createToken('bank_account', {
                country: 'FR',
                currency: 'EUR',
                account_number: iban
              });
            case 17:
              bankAccountResult = _context2.sent;
              if (!(bankAccountResult.error !== undefined)) {
                _context2.next = 22;
                break;
              }
              showError(bankAccountResult.error);
              $(link).removeClass('btn-disabled');
              return _context2.abrupt("return");
            case 22:
              createAccount = function createAccount(accountToken, bankAccountToken) {
                return new Promise(function (resolve, reject) {
                  $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: '/vignerons/settings_ajax/connect-onboarding',
                    data: JSON.stringify({
                      "account": accountToken,
                      "bank_account": bankAccountToken
                    }),
                    cache: false,
                    contentType: "application/json",
                    success: function success(res) {
                      resolve(res);
                    }
                  }).fail(function (err) {
                    reject(err);
                  });
                });
              };
              _context2.next = 25;
              return createAccount(accountResult.token.id, bankAccountResult.token.id);
            case 25:
              result = _context2.sent;
              if (!(result.error !== undefined)) {
                _context2.next = 30;
                break;
              }
              showError(result.error);
              $(link).removeClass('btn-disabled');
              return _context2.abrupt("return");
            case 30:
              resultUrl = result.url;
              _context2.next = 34;
              break;
            case 33:
              resultUrl = $(event.currentTarget).attr('href');
            case 34:
              window.location = resultUrl;
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    if (null !== link) {
      link.addEventListener('click', handleClick);
    }
  }
};
;
var Vignerons_SettingsController_Widget = {
  initStepWidgetLangs: function initStepWidgetLangs() {
    $('<span class="css-checkbox"></span>').insertAfter("#widget_langs-element input");
    var applyMax = function applyMax() {
      var max = $("#Vignerons_Form_Widget_StepWidgetLangs").data("max");
      if (max === "none") {
        return;
      }
      max = parseInt(max);
      var checkedCount = $("#widget_langs-element input:checked").length;
      if (checkedCount >= max) {
        $("#widget_langs-element input:not(:checked)").prop("disabled", true);
      } else {
        $("#widget_langs-element input:not(:checked)").prop("disabled", false);
      }
    };
    applyMax();
    $("#widget_langs-element").on("change", '[name="widget_langs[]"]', function () {
      applyMax();
    });
  },
  initStepWidgetIntegration: function initStepWidgetIntegration() {
    /**
     * Code Mode
     */
    $("#code-mode-buttons .code-mode").on("click", function () {
      var activeMode = $(this).data("value");
      var oldMode = $("#code-mode-buttons .code-mode.active").data("value");
      $("#code-mode-buttons .code-mode.active").removeClass("active");
      $(this).addClass("active");
      $("#integration-codes").removeClass(oldMode);
      $("#integration-codes").addClass(activeMode);
    });

    /**
     * Form values
     */
    var token = $("#Vignerons_Form_Widget_StepWidgetIntegration #widget_token").val();
    $("#display-widget-token").text(token);
    var locale = $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_locale"]').val();
    var integrationType = $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_integration_type"]').val();
    var startingPage = $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_starting_page"]').val();
    var experienceId = $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_experience"]').val();

    /**
     * Code container - on click
     */
    $("code").on("click", function (e) {
      console.log($(this).text());
      if (navigator.clipboard) {
        navigator.clipboard.writeText($(this).text());
        alert("Code copié dans le presse-papier");
      }
    });

    /**
     * Update code on form change
     */
    var handleFormChange = function handleFormChange() {
      var isModal = integrationType === "modal";
      /**
       * hide/show containers
       */
      if (isModal) {
        $("#widget-integration-result #integration-codes .code-container.iframe-code:not(.modal-code),#widget-integration-result #integration-preview #integration-preview-iframe").addClass("hidden");
        $("#widget-integration-result #integration-codes .code-container.modal-code,#widget-integration-result #integration-preview #integration-preview-modal").removeClass("hidden");
      } else {
        $("#widget-integration-result #integration-codes .code-container.modal-code:not(.iframe-code),#widget-integration-result #integration-preview #integration-preview-modal").addClass("hidden");
        $("#widget-integration-result #integration-codes .code-container.iframe-code,#widget-integration-result #integration-preview #integration-preview-iframe").removeClass("hidden");
      }

      /**
       * experienceId param
       */
      var experienceIdIframeParam = "";
      var experienceIdButtonClass = "";
      switch (startingPage) {
        case "experience-page":
          experienceIdIframeParam = "&experienceId=".concat(experienceId);
          experienceIdButtonClass = "wld-id-experience-".concat(experienceId);
          $(".widget_experience_form").removeClass("hidden");
          break;
        case "experience-tunnel":
          experienceIdIframeParam = "&bookingExperienceId=".concat(experienceId);
          experienceIdButtonClass = "wld-id-booking-experience-".concat(experienceId);
          $(".widget_experience_form").removeClass("hidden");
          break;
        case "voucher-tunnel":
          experienceIdIframeParam = "&bookingVoucherExperienceId=".concat(experienceId);
          experienceIdButtonClass = "wld-id-booking-voucher-experience-".concat(experienceId);
          $(".widget_experience_form").removeClass("hidden");
          break;
        case "experience-list":
          $(".widget_experience_form").addClass("hidden");
        default:
          break;
      }
      var wixExperienceIdButtonClass = experienceIdButtonClass != "" ? experienceIdButtonClass : "wld-id-list";
      var iframeUrlBase = "https://wgrdv.io?identifier=".concat(token);
      var localeParam = "&locale=".concat(locale);
      var iframeUrlNoLocale = "".concat(iframeUrlBase).concat(experienceIdIframeParam);
      var iframeUrlNoExperienceId = "".concat(iframeUrlBase).concat(localeParam);
      var iframeUrlFull = "".concat(iframeUrlNoLocale).concat(localeParam);

      /**
       * Elements to change
       */

      var iframeOnlyStandardCodeContainer = $("#widget-integration-result #integration-codes #iframe-only-code pre.standard code");
      var iframeOnlyShopifyCodeContainer = $("#widget-integration-result #integration-codes #iframe-only-code pre.shopify code");
      var iframeOnlyWixCodeContainer = $("#widget-integration-result #integration-codes #iframe-only-code pre.wix code");
      var buttonStandardCodeContainer = $("#widget-integration-result #integration-codes #button-code pre.standard code");
      var buttonWixCodeContainers = $("#widget-integration-result #integration-codes #button-code pre.wix code");
      var iframeInModalStandardCodeContainer = $("#widget-integration-result #integration-codes #iframe-in-modal-code pre.standard code");
      var iframeInModalWordpressCodeContainer = $("#widget-integration-result #integration-codes #iframe-in-modal-code pre.wordpress code");
      var iframeInModalWixCodeContainer = $("#widget-integration-result #integration-codes #iframe-in-modal-code pre.wix code");
      var iframeInModalShopifyCodeContainer = $("#widget-integration-result #integration-codes #iframe-in-modal-code pre.shopify code");

      /**
       * Insert code
       */
      if (isModal) {
        // empty iframe-only-code
        $(iframeOnlyStandardCodeContainer).html("");
        $(iframeOnlyShopifyCodeContainer).html("");
        $(iframeOnlyWixCodeContainer).html("");

        // update button-code standard
        var buttonCode = "&ltbutton class=\"wld-modal-open-button ".concat(experienceIdButtonClass, "\"&gtClick me&lt/button&gt");
        $(buttonStandardCodeContainer).html(buttonCode);

        // update button-code wix
        var buttonWixCode1 = "#".concat(wixExperienceIdButtonClass);
        var buttonWixCode2 = "const elementIds = [\n    \"#".concat(wixExperienceIdButtonClass, "\",\n];\n\nelementIds.forEach(elementId => {\n    $w(elementId).customClassList.add(\"wld-modal-open-button\");\n    $w(elementId).customClassList.add(elementId.split('#')[1]);\n});");
        buttonWixCodeContainers.each(function (index, element) {
          $(element).html(index === 0 ? buttonWixCode1 : buttonWixCode2);
        });

        /* update iframe-in-modal-code */

        // update iframe-in-modal-code standard
        var iframeInModalStandardCode = "&ltdiv id=\"wld-modal\" data-wld-modal-open=\"false\"&gt\n  &ltdiv class=\"wld-modal-outer-container wld-container\"&gt\n    &ltdiv class=\"wld-spinner\"&gt&lt/div&gt\n    &ltbutton\n      title=\"Close\"\n      aria-label=\"Close\"\n      class=\"wld-modal-close-button\"\n      onclick=\"handleWldModalClose()\"\n    &gt\n      &ltsvg viewBox=\"0 0 9 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"&gt\n        &lttitle&gtclose icon&lt/title&gt\n        &ltg transform=\"translate(0.500000, 0.500000)\"&gt\n          &ltline x1=\"0\" y1=\"0\" x2=\"8\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n          &ltline x1=\"8\" y1=\"0\" x2=\"0\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n        &lt/g&gt\n      &lt/svg&gt\n    &lt/button&gt\n    &ltdiv class=\"wld-modal-inner-container\"&gt\n      &ltiframe\n        loading=\"lazy\"\n        class=\"wld-widget wld-widget-in-modal\"\n        src=\"".concat(iframeUrlNoExperienceId, "&modal\"\n        width=\"100%\"\n        style=\"min-height: 400px\"\n      &gt&lt/iframe&gt\n      &ltdiv class=\"wld-powered-by\"&gt\n        &ltspan&gt\n          &ltspan class=\"wld-powered-by-powered-by\"&gtPowered by&lt/span&gt\n          &lta \n            class=\"wld-powered-by-back-link\" \n            href=\"https://www.ruedesvignerons.com\"\n            target=\"_blank\"\n          &gtRue&ltspan class=\"wld-powered-by-des\"&gtDes&lt/span&gtVignerons&lt/a&gt\n        &lt/span&gt\n      &lt/div&gt\n    &lt/div&gt\n  &lt/div&gt\n&lt/div&gt");
        $(iframeInModalStandardCodeContainer).html(iframeInModalStandardCode);

        // update iframe-in-modal-code shopify
        var iframeInModalShopifyCode = "&ltdiv id=\"wld-modal\" data-wld-modal-open=\"false\"&gt\n  &ltdiv class=\"wld-modal-outer-container wld-container\"&gt\n    &ltdiv class=\"wld-spinner\"&gt&lt/div&gt\n    &ltbutton\n      title=\"Close\"\n      aria-label=\"Close\"\n      class=\"wld-modal-close-button\"\n      onclick=\"handleWldModalClose()\"\n    &gt\n      &ltsvg viewBox=\"0 0 9 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"&gt\n        &lttitle&gtclose icon&lt/title&gt\n        &ltg transform=\"translate(0.500000, 0.500000)\"&gt\n          &ltline x1=\"0\" y1=\"0\" x2=\"8\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n          &ltline x1=\"8\" y1=\"0\" x2=\"0\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n        &lt/g&gt\n      &lt/svg&gt\n    &lt/button&gt\n    &ltdiv class=\"wld-modal-inner-container\"&gt\n      &ltiframe\n        loading=\"lazy\"\n        class=\"wld-widget wld-widget-in-modal\"\n        src=\"".concat(iframeUrlBase, "&modal&locale={{ request.locale.iso_code }}\"\n        width=\"100%\"\n        style=\"min-height: 400px\"\n      &gt&lt/iframe&gt\n      &ltdiv class=\"wld-powered-by\"&gt\n        &ltspan&gt\n          &ltspan class=\"wld-powered-by-powered-by\"&gtPowered by&lt/span&gt\n          &lta \n            class=\"wld-powered-by-back-link\" \n            href=\"https://www.ruedesvignerons.com\"\n            target=\"_blank\"\n          &gtRue&ltspan class=\"wld-powered-by-des\"&gtDes&lt/span&gtVignerons&lt/a&gt\n        &lt/span&gt\n      &lt/div&gt\n    &lt/div&gt\n  &lt/div&gt\n&lt/div&gt");
        $(iframeInModalShopifyCodeContainer).html(iframeInModalShopifyCode);

        // update iframe-in-modal-code wordpress
        var iframeInModalWordpressCode = "function rdv_widget_footer() {\n  $locale = get_locale();\n  $locale = explode('_', $locale)[0] ?? \"en\";\n  ?&gt\n  &ltdiv id=\"wld-modal\" data-wld-modal-open=\"false\"&gt\n    &ltdiv class=\"wld-modal-outer-container wld-container\"&gt\n      &ltdiv class=\"wld-spinner\"&gt&lt/div&gt\n      &ltbutton\n        title=\"Close\"\n        aria-label=\"Close\"\n        class=\"wld-modal-close-button\"\n        onclick=\"handleWldModalClose()\"\n      &gt\n        &ltsvg viewBox=\"0 0 9 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"&gt\n          &lttitle&gtclose icon&lt/title&gt\n          &ltg transform=\"translate(0.500000, 0.500000)\"&gt\n            &ltline x1=\"0\" y1=\"0\" x2=\"8\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n            &ltline x1=\"8\" y1=\"0\" x2=\"0\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n          &lt/g&gt\n        &lt/svg&gt\n      &lt/button&gt\n      &ltdiv class=\"wld-modal-inner-container\"&gt\n        &ltiframe\n          loading=\"lazy\"\n          class=\"wld-widget wld-widget-in-modal\"\n          src=\"".concat(iframeUrlBase, "&modal&locale=&lt?php echo $locale; ?&gt\"\n          width=\"100%\"\n          style=\"min-height: 400px\"\n        &gt&lt/iframe&gt\n        &ltdiv class=\"wld-powered-by\"&gt\n          &ltspan&gt\n            &ltspan class=\"wld-powered-by-powered-by\"&gtPowered by&lt/span&gt\n            &lta \n              class=\"wld-powered-by-back-link\" \n              href=\"https://www.ruedesvignerons.com\"\n              target=\"_blank\"\n            &gtRue&ltspan class=\"wld-powered-by-des\"&gtDes&lt/span&gtVignerons&lt/a&gt\n          &lt/span&gt\n        &lt/div&gt\n      &lt/div&gt\n    &lt/div&gt\n  &lt/div&gt\n  &lt?php\n}\nadd_action('wp_footer', 'rdv_widget_footer');");
        $(iframeInModalWordpressCodeContainer).html(iframeInModalWordpressCode);

        // update iframe-in-modal-code wix
        var iframeInModalWixCode = "&ltdiv id=\"wld-modal\" data-wld-modal-open=\"false\"&gt\n  &ltdiv class=\"wld-modal-outer-container wld-container\"&gt\n    &ltdiv class=\"wld-spinner\"&gt&lt/div&gt\n    &ltbutton\n      title=\"Close\"\n      aria-label=\"Close\"\n      class=\"wld-modal-close-button\"\n      onclick=\"handleWldModalClose()\"\n    &gt\n      &ltsvg viewBox=\"0 0 9 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"&gt\n        &lttitle&gtclose icon&lt/title&gt\n        &ltg transform=\"translate(0.500000, 0.500000)\"&gt\n          &ltline x1=\"0\" y1=\"0\" x2=\"8\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n          &ltline x1=\"8\" y1=\"0\" x2=\"0\" y2=\"8\" stroke-linecap=\"round\"&gt&lt/line&gt\n        &lt/g&gt\n      &lt/svg&gt\n    &lt/button&gt\n    &ltdiv class=\"wld-modal-inner-container\"&gt\n      &ltiframe\n        loading=\"lazy\"\n        class=\"wld-widget wld-widget-in-modal\"\n        src=\"".concat(iframeUrlBase, "&locale=en&modal\"\n        width=\"100%\"\n        style=\"min-height: 400px\"\n      &gt&lt/iframe&gt\n      &ltdiv class=\"wld-powered-by\"&gt\n        &ltspan&gt\n          &ltspan class=\"wld-powered-by-powered-by\"&gtPowered by&lt/span&gt\n          &lta \n            class=\"wld-powered-by-back-link\" \n            href=\"https://www.ruedesvignerons.com\"\n            target=\"_blank\"\n          &gtRue&ltspan class=\"wld-powered-by-des\"&gtDes&lt/span&gtVignerons&lt/a&gt\n        &lt/span&gt\n      &lt/div&gt\n    &lt/div&gt\n  &lt/div&gt\n&lt/div&gt\n&ltscript&gt\n  function getLanguageFromHtmlTag() {\n    const htmlTag = document.documentElement;\n    return htmlTag.getAttribute('lang') || 'en';\n  }\n  function injectLanguageIntoIframe() {\n    const lang = getLanguageFromHtmlTag();\n    const iframe = document.querySelector('.wld-widget-in-modal');\n    if (iframe) {\n      iframe.src = iframe.src.replace('locale=en', 'locale=' + lang);\n    }\n  }\n  injectLanguageIntoIframe();\n&lt/script&gt");
        $(iframeInModalWixCodeContainer).html(iframeInModalWixCode);
      } else {
        // empty button code
        $(buttonStandardCodeContainer).html("");
        buttonWixCodeContainers.each(function (index, element) {
          $(element).html("");
        });
        // empty iframe-in-modal-code
        $(iframeInModalStandardCodeContainer).html("");
        $(iframeInModalShopifyCodeContainer).html("");
        $(iframeInModalWordpressCodeContainer).html("");
        $(iframeInModalWixCodeContainer).html("");

        /* update iframe-only-code */
        // update iframe-only-code standard
        var iframeOnlyStandardCode = "&ltdiv class=\"wld-container\"&gt\n  &ltdiv class=\"wld-spinner\"&gt&lt/div&gt\n  &ltiframe\n    loading=\"lazy\"\n    class=\"wld-widget wld-widget-only\"\n    src=\"".concat(iframeUrlFull, "\"\n    width=\"100%\"\n    height=\"100%\"\n    style=\"min-height: 400px\"\n  &gt&lt/iframe&gt\n  &ltdiv class=\"wld-powered-by\"&gt\n    &ltspan&gt\n      &ltspan class=\"wld-powered-by-powered-by\"&gtPowered by&lt/span&gt\n      &lta\n        class=\"wld-powered-by-back-link\"\n        href=\"https://www.ruedesvignerons.com\"\n        target=\"_blank\"\n      &gtRue&ltspan class=\"wld-powered-by-des\"&gtDes&lt/span&gtVignerons&lt/a&gt\n    &lt/span&gt\n  &lt/div&gt\n&lt/div&gt");
        $(iframeOnlyStandardCodeContainer).html(iframeOnlyStandardCode);
        $(iframeOnlyWixCodeContainer).html(iframeUrlFull);

        // update iframe-only-code shopify
        var iframeOnlyShopifyCode = "&ltdiv class=\"wld-container\"&gt\n  &ltdiv class=\"wld-spinner\"&gt&lt/div&gt\n  &ltiframe\n    loading=\"lazy\"\n    class=\"wld-widget wld-widget-only\"\n    src=\"".concat(iframeUrlNoLocale, "&locale={{ request.locale.iso_code }}\"\n    width=\"100%\"\n    height=\"100%\"\n    style=\"min-height: 400px\"\n  &gt&lt/iframe&gt\n  &ltdiv class=\"wld-powered-by\"&gt\n    &ltspan&gt\n      &ltspan class=\"wld-powered-by-powered-by\"&gtPowered by&lt/span&gt\n      &lta\n        class=\"wld-powered-by-back-link\"\n        href=\"https://www.ruedesvignerons.com\"\n        target=\"_blank\"\n      &gtRue&ltspan class=\"wld-powered-by-des\"&gtDes&lt/span&gtVignerons&lt/a&gt\n    &lt/span&gt\n  &lt/div&gt\n&lt/div&gt");
        $(iframeOnlyShopifyCodeContainer).html(iframeOnlyShopifyCode);
      }

      // update preview
      $("#widget-integration-result #integration-preview #integration-preview-modal iframe").attr("src", "".concat(iframeUrlFull, "&modal"));
      $("#widget-integration-result #integration-preview #integration-preview-iframe iframe").attr("src", "".concat(iframeUrlFull));

      // PRETTIFY CODE
      $(".prettyprinted").removeClass("prettyprinted");
      PR.prettyPrint();
    };

    // initial
    handleFormChange();

    // listen to Locale change
    $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_locale"]').change(function (e) {
      locale = e.target.value;
      handleFormChange();
    });

    // listen to IntegrationType change
    $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_integration_type"]').change(function (e) {
      integrationType = e.target.value;
      handleFormChange();
    });

    // listen to StartingPage change
    $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_starting_page"]').change(function (e) {
      startingPage = e.target.value;
      handleFormChange();
    });

    // listen to ExperienceId change
    $('#Vignerons_Form_Widget_StepWidgetIntegration [name="widget_experience"]').change(function (e) {
      experienceId = e.target.value;
      handleFormChange();
    });
  },
  init: function init() {
    if ($("#Vignerons_Form_Widget_StepWidgetLangs").length > 0) {
      this.initStepWidgetLangs();
    } else if ($("#Vignerons_Form_Widget_StepWidgetIntegration").length > 0) {
      this.initStepWidgetIntegration();
    }
  },
  nextStep: function nextStep() {
    $("form[class^='Vignerons_Form_']").submit();
  }
};
;
var Activities = {
  el: {
    container: $('.activities-container-ajax')
  },
  // Methods
  update: function update(scrollToContainer) {
    if (scrollToContainer === undefined) {
      scrollToContainer = true;
    }
    var self = this;
    $(self.el.container).each(function (i, res) {
      $(self.el.container).addClass('loading');
      $.ajax({
        url: $(res).data('url'),
        cache: false,
        success: function success(data) {
          $(res).html(data);
          if (scrollToContainer) {
            var _offset;
            var offset = $(".fullscreen-slider-super-container .form-inline").outerHeight();
            if (!offset) {
              offset = $(".vignerons-create-reservation-container .form-inline").outerHeight();
            }
            if (!offset && parseInt($(".filtersV2-sticky").css("top")) === 0) {
              offset = $(".filtersV2-sticky").outerHeight();
            }
            var containerTop = $(res).offset().top;
            if ($(res).parents(".activities-section").length > 0) {
              containerTop = $(res).parents(".activities-section").offset().top;
            }
            $("body,html").animate({
              scrollTop: containerTop - ((_offset = offset) !== null && _offset !== void 0 ? _offset : 0)
            }, 600);
          }
          $(res).removeClass('loading');
          if ($(res).parents('.filtered-content-container').size()) {
            FilteredContent.update($(res).parents('.filtered-content-container'));
          } else {
            $(res).find('.filtered-content').show();
          }
          FormSearch.init();
        }
      });
    });
  }
};
;
var Ajaxify = {
  el: {
    link: 'a.ajaxify',
    parentAjaxify: '.ajaxify-container'
  },
  // Methods
  init: function init() {
    var self = this;
    $(document).on('click', self.el.link, function (e) {
      e.preventDefault();
      var $this = $(this);
      var xhr = self.getContent($(this).attr('href'), function (content) {
        if ($this.parents(self.el.parentAjaxify).length > 0) {
          $this.parents(self.el.parentAjaxify).html(content);
          Obfuscation.unobfuscate();
        }
      });
      xhr.done(function () {
        $(self.el.parentAjaxify).removeClass('loading');
      });
    });
    $('body').on('submit', 'form.ajaxify-loading', function () {
      var div = $('<div id="ajaxify-overlay"/>');
      div.html('<div class="ajaxify-container loading"/>');
      $('#content').append(div);
    });
  },
  getContent: function getContent(url, cb) {
    $(this.el.parentAjaxify).addClass('loading');
    return $.ajax({
      url: url,
      cache: false,
      dataType: 'html',
      success: function success(content) {
        if (typeof cb == 'function') {
          cb(content);
        }
      }
    });
  }
};
;
var Alertify = {
  type: null,
  url: null,
  // Methods
  init: function init() {
    if ($("#alertify-url").length == 0) return;
    this.url = $("#alertify-url").val();
    this.type = $("#alertify-type").val();
    Popin._createPopin();
    if (this.type !== 'secondary') {
      Popin.popupElement.addClass('exit-by-btn');
    }
    Popin.open(this.url);
  }
};
;
var AppearingSticky = {
  appearingStickies: [],
  // Methods
  reset: function reset() {},
  onScroll: function onScroll(scrollTop) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'onScroll';
    if (this.appearingStickies.length > 0) {
      $(this.appearingStickies).each(function (i, appearingSticky) {
        var staticTop = $(appearingSticky).attr("data-initial-position");
        if (scrollTop > staticTop) {
          $(appearingSticky).addClass("fixed");
        } else {
          $(appearingSticky).removeClass("fixed");
        }
        $(appearingSticky).css("position", '');
      });
    }
  },
  init: function init() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'init';
    this.appearingStickies = $(".appearing-sticky");
    $(this.appearingStickies).each(function (i, el) {
      $(el).css("position", 'static');
      var staticTop = $(el).offset().top;
      $(el).attr("data-initial-position", staticTop);
    });
    this.onScroll($(window).scrollTop(), context);
  },
  onResize: function onResize() {
    this.init('resize');
  }
};
;
var AppEvents = {
  init: function init() {
    $(document).on('click', '.Front_Form_Reservation legend', function (e) {
      e.preventDefault();
      $(this).parents('fieldset').toggleClass('open');
    });
    $(document).on('click', '.container-filters-btn .big-btn-list', function (e) {
      e.preventDefault();
      $(this).toggleClass('open');
    });
    $(document).on('change', '#date', function (e) {
      e.preventDefault();
      if ($(this).parents('.date-container').hasClass('remove-date')) {
        return;
      }
      $(this).parents('.date-container').addClass('remove-date');
      $(this).parents('.date-container').append('<span class="remove-date live-added remove-date-action icon-delete-1-1"></span>');
    });
    $(document).on("change", "#nb_adultes", function (e) {
      e.preventDefault(); //?
      if ($(this).parents(".guests-container").hasClass("remove-guests")) {
        return;
      }
      $(this).parents(".guests-container").addClass("remove-guests");
      $(this).parents(".guests-container").append('<span class="remove-guests live-added remove-guests-action icon-delete-1-1"></span>');
    });
  }
};
; /**
  * Instructions
  * to open the modal:
  * $('#dialog-id').trigger('showModal');
  * to close the modal:
  * $('#dialog-id').trigger('close');
  */

var Autofill = {
  // Methods
  reset: function reset() {},
  initializeInputs: function initializeInputs() {
    var handleAnimationStart = function handleAnimationStart(e) {
      if (e.animationName === "on-autofill-start") {
        e.target.classList.add("autofilled");
      } else if (e.animationName === "on-autofill-cancel") {
        e.target.classList.remove("autofilled");
      }
    };
    var inputs = document.querySelectorAll("input,select,textarea");
    inputs.forEach(function (input) {
      input.onanimationstart = handleAnimationStart;
    });
    window.onbeforeunload = function () {
      inputs.forEach(function (input) {
        input.removeEventListener("animationstart", handleAnimationStart);
      });
    };
  },
  init: function init() {
    var self = this;
    $(document).on("ready", function () {
      self.initializeInputs();
    });
  }
};
;
var ClearableFilters = {
  init: function init() {
    $('body').on('change', '.js-embedded-select select', function () {
      var $select = $(this);
      var $container = $select.parent();
      var innerLabel = $select.find('option:selected').text();
      $container.find('.selected-inner').html(innerLabel);
      var link = '<a href="#" class="clear-filter icon-delete-1-1"></a>';
      if ($select.val() !== '') {
        if (!$container.hasClass('has-selected-item')) {
          $container.append(link);
          $container.addClass('has-selected-item');
        }
      } else {
        $container.removeClass('has-selected-item');
        $container.find(".clear-filter").remove();
      }
    });
    $('body').on('click', '.js-embedded-select .clear-filter', function (e) {
      e.preventDefault();
      var $select = $(this).parent().find('select');
      setTimeout(function () {
        $select.val('').trigger('change');
      });
    });
    $('body').on('change', '.js-embedded-input input', function () {
      var $input = $(this);
      var $container = $input.parent();
      var link = '<a href="#" class="clear-filter icon-delete-1-1"></a>';
      if ($input.val() !== '') {
        if (!$container.hasClass('has-selected-item')) {
          $container.append(link);
          $container.addClass('has-selected-item');
        }
      } else {
        $container.removeClass('has-selected-item');
        $container.find(".clear-filter").remove();
      }
    });
    $('body').on('click', '.js-embedded-input .clear-filter', function (e) {
      e.preventDefault();
      var $input = $(this).parent().find('input');
      setTimeout(function () {
        $input.val('').trigger('change');
      });
    });
  }
};
var CodePostalAutocomplete = {
  field: null,
  // Methods
  init: function init() {
    this.fields = $('input[data-autocomplete-city]');
    if (this.fields.size()) {}
    GoogleMap.load('CodePostalAutocomplete.googleMapEvents');
  },
  googleMapEvents: function googleMapEvents() {
    this.fields.each(function () {
      var field_cp = $(this);
      var field_ville = $('#' + field_cp.data('autocomplete-city'));
      CodePostalAutocomplete.autocompleteVille(field_cp, field_ville);
    });
  },
  autocompleteVille: function autocompleteVille(field_cp, field_ville) {
    if (field_cp.length > 0 && field_ville.length > 0) {
      field_cp.on('keyup', function () {
        if ($(this).val().length == $(this).attr('maxlength')) {
          var geocoder = new google.maps.Geocoder();
          var code = $(this).val();
          geocoder.geocode({
            'address': code + ' ,FRANCE'
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              field_ville.empty();
              if (results[0].postcode_localities) {
                $.each(results[0].postcode_localities, function (i, localite) {
                  field_ville.append($('<option>', {
                    value: localite,
                    text: localite
                  }));
                });
              } else {
                field_ville.append($('<option>', {
                  value: results[0].address_components[1].long_name,
                  text: results[0].address_components[1].long_name
                }));
              }
              field_ville.removeAttr('disabled');
              field_ville.val(results[0].address_components[1].long_name).change();
            }
          });
        } else {
          field_ville.empty();
          field_ville.select2({
            allowClear: true
          });
          field_ville.attr('disabled', 'disabled');
        }
      });
    }
  }
};
;
var CssRadioCheckbox = {
  // Methods
  init: function init() {
    CssRadioCheckbox.parseAll();
  },
  parseAll: function parseAll() {
    $('input.css-checkbox:not(.css-checkbox-ready)').each(function () {
      $('<span class="css-checkbox"/>').insertAfter($(this).addClass('css-checkbox-ready'));
    });
    $('input.css-radio:not(.css-radio-ready)').each(function () {
      $('<span class="css-radio"/>').insertAfter($(this).addClass('css-radio-ready'));
    });
  }
};
; /**
  * Instructions
  * to open the modal:
  * $('#dialog-id').trigger('showModal');
  * to close the modal:
  * $('#dialog-id').trigger('close');
  */

var DialogV2 = {
  // Methods
  reset: function reset() {},
  initializeDialogs: function initializeDialogs() {
    $("dialog.dialog-v2:not(.initialized)").each(function () {
      var currentDialog = $(this);
      currentDialog.addClass("initialized");

      /**
       * Close Button
       */
      var closeSvg = $("<svg\n      class=\"close-icon\"\n      viewBox=\"0 0 9 9\"\n      version=\"1.1\"\n      xmlns=\"http://www.w3.org/2000/svg\n    >\n      <title>Close icon</title>\n      <g transform=\"translate(0.500000, 0.500000)\">\n        <line x1=\"0\" y1=\"0\" x2=\"8\" y2=\"8\" strokeLinecap=\"round\"></line>\n        <line x1=\"8\" y1=\"0\" x2=\"0\" y2=\"8\" strokeLinecap=\"round\"></line>\n      </g>\n    </svg>");
      var closeButton = $("<button></button>");
      closeButton.attr("title", "Close modal");
      closeButton.attr("aria-label", "Close modal");
      closeButton.attr("class", "close-button");
      closeButton.append(closeSvg);
      /**
       * Inner dialog
       */
      var innerDialog = $("<div></div>");
      innerDialog.addClass("inner-dialog");
      var dialogContents = currentDialog.contents();
      innerDialog.append(closeButton, dialogContents);
      currentDialog.contents().remove();
      currentDialog.append(innerDialog);

      /**
       * Close dialog listeners
       */
      $(closeButton).on("click", function (e) {
        currentDialog.trigger("close");
      });
      var disableCloseClickOutside = currentDialog.data('disablecloseclickoutside');
      if (!disableCloseClickOutside) {
        currentDialog.on("click", function (e) {
          var isNotChildOfDialog = $(e.target).parents(".inner-dialog").length === 0;
          if (isNotChildOfDialog) {
            currentDialog.trigger("close");
          }
        });
      }

      /**
       * Open dialog
       */
      $(document).on("click", "[data-open-dialogV2]", function (e) {
        var elem = $(e.currentTarget);
        $(elem.attr("data-open-dialogV2")).trigger("showModal");
      });

      /**
       * Body scroll (& open/close modal fix old browsers)
       */
      currentDialog.on("showModal", function () {
        currentDialog.attr("open", "open");
        $("body").addClass("dialog-v2-open");
      });
      currentDialog.on("show", function () {
        currentDialog.attr("open", "open");
        $("body").addClass("dialog-v2-open");
      });
      currentDialog.on("close", function (e) {
        currentDialog.removeAttr("open");
        $("body").removeClass("dialog-v2-open");
      });
    });
  },
  init: function init() {
    var self = this;
    $(document).on("ready", function () {
      self.initializeDialogs();
    });
  }
};
;
var Excerpt = {
  el: {
    container: '.excerpt-container'
  },
  // Methods
  init: function init() {
    var self = this;
    $(self.el.container + ' .see-more').on('click', function (e) {
      e.preventDefault();
      var $parent = $(this).parents(self.el.container);
      $(this).addClass('hidden');
      $parent.find('.ellipsis').addClass('hidden');
      $parent.find('.text-hidden').removeClass('hidden');
    });
  }
};
;
var Facebook = {
  // Methods
  init: function init() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: App.fbAppId,
        xfbml: true,
        version: 'v2.3'
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.defer = true;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    $('body').on('click', 'a.facebook-connect', function (e) {
      e.preventDefault();
      var button = $(this);
      FB.login(function (response) {
        if (response.authResponse) {
          if (button.hasClass('popinify')) {
            Popin.open(button.attr('href'), {
              'facebook-access-token': response.authResponse.accessToken
            });
          }
        }
      }, {
        scope: 'email'
      });
    });
  }
};
;
var Faq = {
  // Methods
  init: function init() {
    if ($("#faq").size()) {
      var $form = $("#help_search");
      var $form_input = $form.find("#query");
      var $category_wrappers = $(".category_wrapper");
      var $question_wrappers = $(".question_wrapper");
      var $questions = $question_wrappers.find(".question");
      var $answers = $question_wrappers.find(".answer");

      // search form
      $form.submit(function (e) {
        e.preventDefault();
        var $query = $form_input.val();
        var $question_wrappers_matching = $questions.add($answers).filter(":contains(" + $query + ")").parent();
        $question_wrappers.not($question_wrappers_matching).addClass("folded");
        $question_wrappers_matching.removeClass("folded");
        // hide or show categories
        $category_wrappers.each(function () {
          var $self = $(this);
          var $questions = $self.find(".question_wrapper");
          if ($questions.size() == $questions.filter(".folded").size()) {
            $self.slideUp();
          } else {
            $self.slideDown();
          }
        });
        // hide or show questions
        setTimeout(function () {
          $question_wrappers.not($question_wrappers_matching).slideUp();
          $question_wrappers_matching.slideDown();
        }, 300);
      });
      $form_input.keyup(function () {
        $form.submit();
      });

      // questions click
      $questions.click(function () {
        var $self = $(this);
        var $answer = $self.next(".answer");
        $questions.not($self).removeClass("active");
        $answers.not($answer).slideUp();
        $self.toggleClass("active");
        $answer.stop().slideToggle();
      });
    }
  }
};
;
var FilteredContent = {
  el: {
    container: '.excerpt-container'
  },
  // Methods
  init: function init() {
    var self = this;
    $('body').on('click', '.filtered-content-container .filter', function (e) {
      e.preventDefault();
      var $parent = $(this).parents(".filtered-content-container");
      $parent.find('.active').removeClass('active');
      $(this).parent('li').addClass('active');
      var filterVal = $(this).data('filter-val');
      self.update($parent, filterVal);
    });
  },
  update: function update($parent, filterVal) {
    if (typeof filterVal == 'undefined') {
      filterVal = $parent.find('.active a').data('filter-val');
    }
    $.each($parent.find('.filtered-content'), function (i, res) {
      if (filterVal == 'all' || $(res).data('content-type') == filterVal) {
        $(res).show();
      } else {
        $(res).hide();
      }
    });
  }
};
;
var FixedFooter = {
  // Methods
  init: function init() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "init";
    var fixedFooters = $("*:not(#nav_mobile):not(.side-by-side-container > .right):not(#map.fixed):not(#map *)").filter(function () {
      return $(this).css("display") !== "none" && $(this).css("position") === "fixed" && $(this).css("top") !== "0px" && ($(this).css("bottom") === "0px" || $(this).hasClass("mobile-location-searchbar"));
    });
    if ($(fixedFooters).length > 0) {
      var biggestFixedFooterHeight = 0;
      var biggestFixedFooter = null;
      $(fixedFooters).each(function () {
        var height = $(this).outerHeight();
        if ($(this).hasClass("mobile-location-searchbar")) {
          height += parseInt($(this).css('bottom'));
        }
        if (height > biggestFixedFooterHeight) {
          biggestFixedFooterHeight = height;
          biggestFixedFooter = $(this);
        }
      });
      var shadowFixedFooter = $(".shadow-fixed-footer");
      if ($(shadowFixedFooter).length === 0) {
        $("body").append('<div class="shadow-fixed-footer"></div>');
        shadowFixedFooter = $(".shadow-fixed-footer");
      }
      shadowFixedFooter = $(shadowFixedFooter)[0];
      $(shadowFixedFooter).css("height", "".concat(biggestFixedFooterHeight, "px"));
    } else {
      var _shadowFixedFooter = $(".shadow-fixed-footer");
      if ($(_shadowFixedFooter).length > 0) {
        $(_shadowFixedFooter).css("height", "0px");
      }
    }
  },
  onResize: function onResize() {
    this.init("resize");
  }
};
;
var MaxSelectionMultiSelect = {
  // Methods
  init: function init() {
    $("select[data-max-selection]").each(function (i, elem) {
      $(elem).select2({
        maximumSelectionLength: $(elem).data('max-selection')
      });
    });
  }
};
var FormRangeSlider = {
  // Methods
  init: function init() {
    var self = this;
    $('.form-range').each(function () {
      if ($(this).hasClass('loaded')) return;
      $(this).addClass('loaded');
      var rangeSlider = $(this).find('.range-slider');
      var inputMin = $(this).find('input').first();
      var inputMax = $(this).find('input').last();
      var min = parseInt(inputMin.data('min'));
      var max = parseInt(inputMax.data('max'));
      if (inputMin.val() == '') inputMin.val(min + ' ' + inputMin.data('suffix'));
      if (inputMax.val() == '') inputMax.val(max + ' ' + inputMin.data('suffix'));
      rangeSlider.noUiSlider({
        start: [Math.max(min, parseInt(inputMin.val())), Math.min(max, parseInt(inputMax.val()))],
        step: 1,
        range: {
          'min': [min],
          'max': [max]
        }
      });
      rangeSlider.on({
        slide: function slide() {
          rangeSlider.parents('.form-element').addClass('edited');
        }
      });
      $(this).find('input').focus(function () {
        $(this).val(parseInt($(this).val()));
      });
      $(this).find('input').blur(function () {
        $(this).val(parseInt($(this).val()) + ' ' + inputMin.data('suffix'));
      });
      rangeSlider.Link('lower').to(inputMin, null, {
        to: function to(data) {
          return Math.round(data) + ' ' + inputMin.data('suffix');
        },
        from: Number
      });
      rangeSlider.Link('upper').to(inputMax, null, {
        to: function to(data) {
          return Math.round(data) + ' ' + inputMax.data('suffix');
        },
        from: Number
      });
    });
  }
};
;
var FormFilterActivitiesMobile = {
  init: function init() {
    var isMobileFormComplete = function isMobileFormComplete() {
      return $('#nb_adultes_mobile').val() !== '' && $('#date_mobile').val() !== '' && $('#lang_mobile').val() !== '';
    };
    $('.form-filter-activities-mobile input#date_mobile').datetimepicker({
      lang: $('#CURRENT_LANG').val(),
      timepicker: false,
      format: 'd/m/Y',
      scrollInput: false,
      scrollMonth: false,
      scrollTime: false,
      minDate: '0',
      dayOfWeekStart: 1,
      closeOnDateSelect: true,
      onGenerate: function onGenerate(ct) {
        $('.xdsoft_datetimepicker ').addClass('search-datetimepicker');
      }
    });
    $('.form-filter-activities-mobile').on('submit', function (e) {
      e.preventDefault();
      $('.form-search-domain #lang').val($('#lang_mobile').val());
      $('.form-search-domain #date').val($('#date_mobile').val());
      setTimeout(function () {
        if (isMobileFormComplete()) {
          $('form.form-search-domain').trigger('submit');
        } else {
          alert(i18n['form-search-domain.error.all_filters_required']);
        }
      });
      return false;
    });
    $('.mobile-activity-filter .js-submit').on('click', function (e) {
      $('.form-filter-activities-mobile').trigger('submit');
    });
  }
};
;
var FormMultiCheckboxElement = {
  // Methods
  init: function init() {
    var prevent = false;
    $('body').on('click touchstart', '.form-multi-checkbox-element .form-element-inner > dt label', function () {
      if (prevent) return;
      prevent = true;
      setTimeout(function () {
        prevent = false;
      }, 500);
      var formElement = $(this).parents('.form-element');
      if (formElement.hasClass('open') === false) {
        formElement.parents('form').find('.form-element').removeClass('open');
      }
      formElement.toggleClass('open');
    });
    $('body').on('click', '.form-multi-checkbox-element a.close-btn', function (e) {
      e.preventDefault();
      var formElement = $(this).parents('.form-element');
      formElement.removeClass('open');
    });
    $('body').on('change', '.form-multi-checkbox-element input', function () {
      var formElement = $(this).parents('.form-element');
      formElement.find('a.close-btn').hide();
      formElement.find('input.submit').show();
    });
    //        $('body').on('click', '.form-multi-checkbox-element input[type=checkbox],.form-multi-checkbox-element input[type=radio]', function () {
    //            var formElement = $(this).parents('.form-element');
    //            formElement.find('a.close-btn').hide();
    //            formElement.find('input.submit').show();
    //        });
    $('.form-element:has(div.filter)').each(function () {
      var element = $(this);
      element.find('input.filter').keyup(function () {
        var value = $(this).val().toLowerCase().latinize();
        element.find('.dropdown label').each(function () {
          var text = $(this).text().toLowerCase().latinize();
          if (text.indexOf(value) !== -1) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });
    });
  }
};
;
var FormSearch = {
  posTopBarre: null,
  locationValue: "",
  scrolled: false,
  // Je ne sais pas comment rendre sprintf global, ni récupérer un sprintf global existant
  sprintf: function sprintf(str) {
    for (var _len = arguments.length, argv = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      argv[_key - 1] = arguments[_key];
    }
    return argv.length === 0 ? str : FormSearch.sprintf.apply(FormSearch, [str.replace(/(%s|%d)/, argv.shift())].concat(argv));
  },
  /******************
   * External Methods
   ******************/
  reset: function reset() {},
  init: function init() {
    var _this$getFiltersV1Dat, _this$getFiltersV2Dat;
    var self = this;
    var lastSearch = false;
    self.onResize();

    /**
     * FiltersV2 Tabs
     */
    // Tab click
    $("#filtersV2-dialog .tab[data-tab-panel]").off("click", this.handleFiltersV2TabClick).on("click", this.handleFiltersV2TabClick);
    // Dialog Scroll
    $("#filtersV2-dialog .dialog-content").off("scroll", this.handleFiltersV2Scroll).scroll(this.handleFiltersV2Scroll);
    // Dialog open
    $("#filtersV2-dialog").off("showModal", this.handleFiltersV2Open).on("showModal", this.handleFiltersV2Open);

    /**
     * Reset filters
     */
    $(".search-reset, .reset-filters").off("click", this.handleResetFilters).on("click", this.handleResetFilters);
    /**
     * Taxonomy Filters
     */
    $(".taxonomy-filter").off("click", this.handleResetTaxonomyFilter).on("click", this.handleResetTaxonomyFilter);
    this.handleShowTaxonomyFilter();

    /**
     * Date Form
     */
    // Remove Date
    $(".remove-date-action").off("click", this.handleResetDateClick).on("click", this.handleResetDateClick);
    // Attach old DatePicker
    this.getFiltersV1Date().datetimepicker((_this$getFiltersV1Dat = {
      lang: $("#CURRENT_LANG").val(),
      timepicker: false,
      format: "d/m/Y",
      scrollInput: false,
      scrollMonth: false,
      scrollTime: false
    }, _defineProperty(_this$getFiltersV1Dat, "scrollInput", false), _defineProperty(_this$getFiltersV1Dat, "minDate", "0"), _defineProperty(_this$getFiltersV1Dat, "dayOfWeekStart", 1), _defineProperty(_this$getFiltersV1Dat, "closeOnDateSelect", true), _defineProperty(_this$getFiltersV1Dat, "onGenerate", function onGenerate() {
      $(this).addClass("search-datetimepicker");
    }), _this$getFiltersV1Dat));
    // Attach filtersV2 DatePicker
    this.getFiltersV2Date().datetimepicker((_this$getFiltersV2Dat = {
      lang: $("#CURRENT_LANG").val(),
      timepicker: false,
      format: "d/m/Y",
      scrollInput: false,
      scrollMonth: false,
      scrollTime: false
    }, _defineProperty(_this$getFiltersV2Dat, "scrollInput", false), _defineProperty(_this$getFiltersV2Dat, "minDate", "0"), _defineProperty(_this$getFiltersV2Dat, "dayOfWeekStart", 1), _defineProperty(_this$getFiltersV2Dat, "closeOnDateSelect", false), _defineProperty(_this$getFiltersV2Dat, "inline", true), _defineProperty(_this$getFiltersV2Dat, "validateOnBlur", true), _defineProperty(_this$getFiltersV2Dat, "todayButton", false), _defineProperty(_this$getFiltersV2Dat, "defaultDate", false), _defineProperty(_this$getFiltersV2Dat, "onGenerate", function onGenerate() {
      $(this).addClass("filtersV2-datetimepicker");
    }), _defineProperty(_this$getFiltersV2Dat, "onSelectDate", function onSelectDate(ct, $i) {
      var newDate = ct.dateFormat("d/m/Y");
      $i.val(newDate);
      $i.attr("value", newDate);
      $i.trigger("change");
    }), _this$getFiltersV2Dat));
    // filtersV1 Date change
    this.getFiltersV1Date().off("change", this.handleInitializeDateForm).on("change", this.handleInitializeDateForm);
    // filtersV2 Date change
    this.getFiltersV2Date().off("change", this.handleEnableApplyFiltersV2).on("change", this.handleEnableApplyFiltersV2);

    /**
     * Guests Form
     */
    // filtersV1 Adults Change
    this.getFiltersV1Adults().off("change", this.handleGuestsChange).on("change", this.handleGuestsChange);
    // filtersV1 Children Change
    this.getFiltersV1Children().off("change", this.handleGuestsChange).on("change", this.handleGuestsChange);

    // filtersV2 nbChildren change
    this.getFiltersV2NbChildren().off("change", this.handleNbChildrenChange).on("change", this.handleNbChildrenChange);

    // filtersV2 Adults change
    this.getFiltersV2Adults().off("change", this.handleAdultsChange).on("change", this.handleAdultsChange);

    // Remove Guests
    $(".remove-guests-action").off("click", this.handleRemoveGuests).on("click", this.handleRemoveGuests);

    /**
     * Language Form
     */
    // filtersV1 language change
    this.getFiltersV1Language().off("change", this.handleLanguageChange).on("change", this.handleLanguageChange);
    // filtersV2 language change
    this.getFiltersV2LanguageBtns().off("click", this.handleFiltersV2LanguageChange).on("click", this.handleFiltersV2LanguageChange);
    $(document).off("ready", this.handleDocumentReady).on("ready", this.handleDocumentReady);

    /**
     * Guests Dialog
     */
    // close dialog
    $("#guests-dialog").off("close", this.handleGuestsDialogClose).on("close", this.handleGuestsDialogClose);
    // apply Guests
    $("button#confirm-guests").off("click", this.handleApplyGuests).on("click", this.handleApplyGuests);

    /**
     * FiltersV2 Dialog
     */
    // apply filters
    $("#confirm-filtersV2").off("click", this.handleApplyFiltersV2).on("click", this.handleApplyFiltersV2);

    /**
     * Other
     */
    // Geoloc
    $(".form-search .btn-geoloc").off("click", this.handleGeolocClick).on("click", this.handleGeolocClick);

    // old V1 Adult placeholder TODO REMOVE?
    $(".form-search select#nb_adultes").off("change", this.handleAdultsChangePlaceHolder).on("change", this.handleAdultsChangePlaceHolder);

    // Location
    // location focus
    $("#location").off("focus", this.handleLocationFocus).on("focus", this.handleLocationFocus);
    $("#location").off("focusout", this.handleLocationFocusOut).on("focusout", this.handleLocationFocusOut);
    // location change
    $("#location").off("change", this.handleLocationChange).on("change", this.handleLocationChange);

    // location keyup
    FormSearch.scrolled = false;
    $(".form-search input#location").off("keyup", this.handleLocationKeyUp).on("keyup", this.handleLocationKeyUp);

    // location result click
    $("body").off("click", ".form-search .results a", this.handleLocationResultClick).on("click", ".form-search .results a", this.handleLocationResultClick);

    // FILTER FORM SUBMIT
    $(".form-search-domain").off("submit", this.handleFormSubmit).on("submit", this.handleFormSubmit);
  },
  onScroll: function onScroll(scrollTop) {
    var barre = $(".form-inline.barre");
    if (barre.size()) {
      if (this.posTopBarre === null) {
        this.posTopBarre = barre.offset().top;
      }
      if (scrollTop > this.posTopBarre) {
        barre.addClass("sticky");
      } else {
        barre.removeClass("sticky");
      }
    }
  },
  onResize: function onResize() {
    var locationField = $("[name=location]");
    var isOnPageDomain = $("#homepage").size() == 0 && $(".form-search-header").size();
    if (Device.isMobile || $("#header-search").size() || isOnPageDomain) {
      locationField.attr("placeholder", locationField.attr("placeholder-mobile"));
    } else {
      locationField.attr("placeholder", locationField.attr("placeholder-desktop"));
    }
    var isOnPageSearch = $("main#content").hasClass("controller-search") || $("main#content").hasClass("controller-wine-tour") || $("main#content").hasClass("controller-experience") || $("main#content").hasClass("controller-domains");
    if (isOnPageSearch && !Device.isMobile) {
      // Resize results widget
      $(".form-search.form-search-headersearch div.results").width($(".form-search.form-search-headersearch").width() - 0.08 * $(".form-search.form-search-headersearch").width());
    }
  },
  /******************
   * Internal Methods
   ******************/

  /**
   * FiltersV2 Tabs
   */
  // Tab click
  handleFiltersV2TabClick: function handleFiltersV2TabClick(e) {
    var clickedTab = $(e.currentTarget);
    $(clickedTab.attr("data-tab-panel")).get(0).scrollIntoView({
      behavior: "smooth"
    });
  },
  // Dialog Scroll
  handleFiltersV2Scroll: function handleFiltersV2Scroll() {
    var dialogContent = $("#filtersV2-dialog[open] .dialog-content");
    if ($(dialogContent).length > 0) {
      var dialogContentOffsetTop = $("#filtersV2-dialog[open] .dialog-content").offset().top;
      var activeTabId = null;
      $("#filtersV2-dialog[open] .tab[data-tab-panel]").each(function (i, el) {
        if (!activeTabId) {
          var tabPanel = $($(el).attr("data-tab-panel"));
          if ($(tabPanel).offset().top >= dialogContentOffsetTop) {
            activeTabId = $(el).attr("data-tab-panel");
          }
        }
      });
      if (activeTabId) {
        $("#filtersV2-dialog[open] .tab[data-tab-panel].active").removeClass("active");
        $("#filtersV2-dialog[open] .tab[data-tab-panel=\"".concat(activeTabId, "\"]")).addClass("active");
      }
    }
  },
  // Dialog open
  handleFiltersV2Open: function handleFiltersV2Open(e) {
    FormSearch.handleInitializeFiltersV2();
    setTimeout(function () {
      $("#filtersV2-dialog .dialog-content").scrollTop(0);
      FormSearch.handleFiltersV2Scroll();
    }, 0);
  },
  /**
   * FiltersV1 Getters
   */
  // Fields
  getFiltersV1Date: function getFiltersV1Date() {
    return $(".form-search-domain input#date");
  },
  getFiltersV1Adults: function getFiltersV1Adults() {
    return $(".form-search-domain .hidden_nb_adults-container input#nb_adultes");
  },
  getFiltersV1Children: function getFiltersV1Children() {
    return $(".form-search-domain .hidden_children-container input#children");
  },
  getFiltersV1Language: function getFiltersV1Language() {
    return $(".form-search-domain select#lang");
  },
  getFiltersV1LanguageSelectedOption: function getFiltersV1LanguageSelectedOption() {
    return $(".form-search-domain select#lang option[selected]");
  },
  getFiltersV1LanguageOptionFromValue: function getFiltersV1LanguageOptionFromValue(value) {
    return $(".form-search-domain select#lang option[value=\"".concat(value, "\"]"));
  },
  // Values
  getFiltersV1DateValue: function getFiltersV1DateValue() {
    return FormSearch.getFiltersV1Date().val();
  },
  getFiltersV1AdultsValue: function getFiltersV1AdultsValue() {
    return FormSearch.getFiltersV1Adults().val();
  },
  getFiltersV1ChildrenValue: function getFiltersV1ChildrenValue() {
    return FormSearch.getFiltersV1Children().val();
  },
  getFiltersV1LanguageValue: function getFiltersV1LanguageValue() {
    var _FormSearch$getFilter;
    var lang = (_FormSearch$getFilter = FormSearch.getFiltersV1Language().val()) !== null && _FormSearch$getFilter !== void 0 ? _FormSearch$getFilter : "";
    if (lang === "") {
      var _FormSearch$getFilter2;
      lang = (_FormSearch$getFilter2 = FormSearch.getFiltersV1LanguageSelectedOption().val()) !== null && _FormSearch$getFilter2 !== void 0 ? _FormSearch$getFilter2 : "";
    }
    return lang;
  },
  /**
   * FiltersV2 Getters
   */
  // Fields
  getFiltersV2Date: function getFiltersV2Date() {
    return $("#filtersV2-date-form #filtersV2-date");
  },
  getFiltersV2Adults: function getFiltersV2Adults() {
    return $("#filtersV2-guests-form #visible_nb_adults");
  },
  getFiltersV2NbChildren: function getFiltersV2NbChildren() {
    return $("#filtersV2-guests-form select#visible_nb_children");
  },
  getFiltersV2ChildrenAgesContainer: function getFiltersV2ChildrenAgesContainer() {
    return $("#filtersV2-guests-form #children-ages-container");
  },
  getFiltersV2ChildAgeContainers: function getFiltersV2ChildAgeContainers() {
    return $("#filtersV2-guests-form #children-ages-container .child-age-container");
  },
  getFiltersV2ChildAgesSelects: function getFiltersV2ChildAgesSelects() {
    return $("#filtersV2-guests-form #children-ages-container .child-age-container select.child-age");
  },
  getFiltersV2LanguageBtns: function getFiltersV2LanguageBtns() {
    return $("#filtersV2-language-form .language-btn");
  },
  getFiltersV2LanguageBtnSelected: function getFiltersV2LanguageBtnSelected() {
    return $("#filtersV2-language-form .language-btn.selected");
  },
  getFiltersV2LanguageBtnFromValue: function getFiltersV2LanguageBtnFromValue(value) {
    return $("#filtersV2-language-form .language-btn[value=\"".concat(value, "\"]"));
  },
  // Values
  getFiltersV2DateValue: function getFiltersV2DateValue() {
    return FormSearch.getFiltersV2Date().val();
  },
  getFiltersV2AdultsValue: function getFiltersV2AdultsValue() {
    return FormSearch.getFiltersV2Adults().val();
  },
  getFiltersV2NbChildrenValue: function getFiltersV2NbChildrenValue() {
    return FormSearch.getFiltersV2NbChildren().val();
  },
  getFiltersV2ChildAgesSelectsValue: function getFiltersV2ChildAgesSelectsValue() {
    return Array.from(FormSearch.getFiltersV2ChildAgesSelects().map(function () {
      return $(this).val();
    }));
  },
  getFiltersV2LanguageValue: function getFiltersV2LanguageValue() {
    return FormSearch.getFiltersV2LanguageBtnSelected().val();
  },
  /**
   * Filters Validity
   */
  isValidDate: function isValidDate(date) {
    return !!date && /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(date);
  },
  isValidAdults: function isValidAdults(nbAdults) {
    parseInt(nbAdults);
    return !isNaN(nbAdults) && nbAdults > 0;
  },
  isValidLanguage: function isValidLanguage(lang) {
    return !!lang;
  },
  /**
   * FiltersV1 Validity
   */
  isValidFiltersV1Date: function isValidFiltersV1Date() {
    return FormSearch.isValidDate(FormSearch.getFiltersV1DateValue());
  },
  isValidFiltersV1Guests: function isValidFiltersV1Guests() {
    return FormSearch.isValidAdults(FormSearch.getFiltersV1AdultsValue());
  },
  isValidFiltersV1Language: function isValidFiltersV1Language() {
    return FormSearch.isValidLanguage(FormSearch.getFiltersV1LanguageValue());
  },
  areFiltersV1Valid: function areFiltersV1Valid() {
    return FormSearch.isValidFiltersV1Date() && FormSearch.isValidFiltersV1Guests() && FormSearch.isValidFiltersV1Language();
  },
  handleResolveHasFilters: function handleResolveHasFilters() {
    var areFiltersValid = FormSearch.areFiltersV1Valid();
    // console.log("HERE FormSearch.handleResolveHasFilters", areFiltersValid);
    if (areFiltersValid) {
      $(".form-search.form-search-domain").addClass("has-filters");
      $(".fiche-domain").addClass("has-filters");
      $(".filtersV2-sticky").addClass("has-filters");
      $("#filtersV2-dialog").addClass("has-filters");
      $(".vignerons-create-reservation-container").addClass("has-filters");
    } else {
      $(".form-search.form-search-domain").removeClass("has-filters");
      $(".fiche-domain").removeClass("has-filters");
      $(".filtersV2-sticky").removeClass("has-filters");
      $("#filtersV2-dialog").removeClass("has-filters");
      $(".vignerons-create-reservation-container").removeClass("has-filters");
    }
    return areFiltersValid;
  },
  /**
   * FiltersV2 Validity
   */
  isValidFiltersV2Date: function isValidFiltersV2Date() {
    return FormSearch.isValidDate(FormSearch.getFiltersV2DateValue());
  },
  isValidFiltersV2Guests: function isValidFiltersV2Guests() {
    return FormSearch.isValidAdults(FormSearch.getFiltersV2AdultsValue());
  },
  isValidFiltersV2Language: function isValidFiltersV2Language() {
    return FormSearch.getFiltersV2LanguageBtnSelected().length === 1;
  },
  areFiltersV2Valid: function areFiltersV2Valid() {
    return FormSearch.isValidFiltersV2Date() && FormSearch.isValidFiltersV2Guests() && FormSearch.isValidFiltersV2Language();
  },
  handleEnableApplyFiltersV2: function handleEnableApplyFiltersV2() {
    var areFiltersValid = FormSearch.areFiltersV2Valid();
    // console.log(
    //     "HERE FormSearch.handleEnableApplyFiltersV2",
    //     areFiltersValid
    // );
    if (areFiltersValid) {
      $("#confirm-filtersV2").removeClass("btn-disabled");
    } else if (!$("#confirm-filtersV2").hasClass("btn-disabled")) {
      $("#confirm-filtersV2").addClass("btn-disabled");
    }
  },
  /**
   * Reset filters
   */
  handleResetDate: function handleResetDate() {
    // console.log("HERE FormSearch.handleResetDate");
    var dateV1Input = FormSearch.getFiltersV1Date();
    dateV1Input.val("");
    dateV1Input.trigger("change");
    $("input#date_mobile").val("");
    $("input#date_mobile").trigger("change");
    $.removeCookie("search-date", {
      path: "/"
    });
  },
  handleResetGuests: function handleResetGuests() {
    // console.log("HERE FormSearch.handleResetGuests");
    var newNbAdults = 0;
    var newChildrenAges = [];
    var nbAdultsV1Input = FormSearch.getFiltersV1Adults();
    var childrenV1Input = FormSearch.getFiltersV1Children();
    nbAdultsV1Input.val(newNbAdults);
    childrenV1Input.val(JSON.stringify(newChildrenAges));
    nbAdultsV1Input.trigger("change");
    childrenV1Input.trigger("change");
    $.removeCookie("search-people", {
      path: "/"
    });
    $.removeCookie("search-children", {
      path: "/"
    });
  },
  handleResetLang: function handleResetLang() {
    // console.log("HERE FormSearch.handleResetLang");
    var langV1Input = FormSearch.getFiltersV1Language();
    langV1Input.val("");
    langV1Input.trigger("change");
    $("#lang_mobile").val("");
    $("#lang_mobile").trigger("change");
    $.removeCookie("search-lang", {
      path: "/"
    });
  },
  handleResetFilters: function handleResetFilters(e) {
    // console.log("HERE FormSearch.handleResetFilters");
    e.preventDefault();
    FormSearch.handleResetDate();
    FormSearch.handleResetGuests();
    FormSearch.handleResetLang();
    FormSearch.handleInitializeFiltersV2();
    FormSearch.handleResolveHasFilters();
    var applyFiltersV2Event = jQuery.Event("apply-filters-v2");
    applyFiltersV2Event.activitiesUpdateScrollToContainer = false;
    $(document).trigger(applyFiltersV2Event);
  },
  handleResetTaxonomyFilter: function handleResetTaxonomyFilter(e) {
    e.preventDefault();
    var previousValue = JSON.parse($("input#taxonomies").val() || "[]") || [];
    var newValue = previousValue.filter(function (val) {
      return val != $(e.target).data("id");
    });
    $("input#taxonomies").val(JSON.stringify(newValue));
    var applyFiltersV2Event = jQuery.Event("apply-filters-v2");
    applyFiltersV2Event.activitiesUpdateScrollToContainer = false;
    $(document).trigger(applyFiltersV2Event);
    $(e.target).remove();
  },
  /**
   * Date Form
   */
  // Remove Date
  handleResetDateClick: function handleResetDateClick(e) {
    e.preventDefault();
    FormSearch.handleResetDate();
    $(this).hide();
    $(this).parents(".date-container").removeClass("remove-date");
  },
  // Init filtersV2 Date
  handleInitializeDateForm: function handleInitializeDateForm() {
    var _FormSearch$getFilter3;
    // console.log("HERE FormSearch.handleInitializeDateForm");
    var newDate = (_FormSearch$getFilter3 = FormSearch.getFiltersV1DateValue()) !== null && _FormSearch$getFilter3 !== void 0 ? _FormSearch$getFilter3 : "";
    var dateV2 = FormSearch.getFiltersV2Date();
    dateV2.val(newDate);
    dateV2.attr("value", newDate);
    if (!newDate) {
      dateV2.datetimepicker("reset");
    }
    dateV2.trigger("change");
    FormSearch.handleEnableApplyFiltersV2();
  },
  // Save filtersV2 Date
  handleSaveDateField: function handleSaveDateField() {
    // console.log("HERE FormSearch.handleSaveDateField");
    var newDate = FormSearch.getFiltersV2DateValue();
    FormSearch.getFiltersV1Date().val(newDate);
  },
  /**
   * Guests Form
   */
  // enable/disable apply Guests button
  handleEnableApplyGuests: function handleEnableApplyGuests(nbAdults) {
    var newNbAdults = nbAdults ? parseInt(nbAdults) : NaN;
    if (isNaN(newNbAdults)) {
      newNbAdults = parseInt(FormSearch.getFiltersV2AdultsValue());
    }
    if (isNaN(newNbAdults) || newNbAdults === 0) {
      $("button#confirm-guests").addClass("btn-disabled");
    } else {
      $("button#confirm-guests").removeClass("btn-disabled");
    }
  },
  // save Guests field
  handleSaveGuestsFields: function handleSaveGuestsFields() {
    // adults
    var nbAdults = parseInt(FormSearch.getFiltersV2AdultsValue());
    var adultsV1Input = FormSearch.getFiltersV1Adults();
    adultsV1Input.val(nbAdults);
    // children
    var newChildrenAges = FormSearch.getFiltersV2ChildAgesSelectsValue();
    // console.log(
    //     "HERE FormSearch.handleSaveGuestsFields",
    //     "nbAdults",
    //     nbAdults,
    //     "newChildrenAges",
    //     newChildrenAges
    // );
    var childrenV1Input = FormSearch.getFiltersV1Children();
    childrenV1Input.val(JSON.stringify(newChildrenAges));
    adultsV1Input.trigger("change");
    childrenV1Input.trigger("change");
  },
  // initialize Children ages
  handleInitializeGuestsForm: function handleInitializeGuestsForm(nbAdults, childrenAges) {
    var _ref3, _ref4;
    var newNbAdults = (_ref3 = nbAdults !== null && nbAdults !== void 0 ? nbAdults : FormSearch.getFiltersV1AdultsValue()) !== null && _ref3 !== void 0 ? _ref3 : 0;
    if (typeof newNbAdults === "string") {
      newNbAdults = parseInt(newNbAdults);
    }
    if (isNaN(newNbAdults)) {
      newNbAdults = 0;
    }
    var newChildrenAges = (_ref4 = childrenAges !== null && childrenAges !== void 0 ? childrenAges : FormSearch.getFiltersV1ChildrenValue()) !== null && _ref4 !== void 0 ? _ref4 : "[]";
    if (typeof newChildrenAges === "string" && newChildrenAges !== "") {
      newChildrenAges = JSON.parse(newChildrenAges);
    } else {
      newChildrenAges = [];
    }

    // console.log(
    //     "HERE FormSearch.handleInitializeGuestsForm",
    //     "newNbAdults",
    //     newNbAdults,
    //     "newChildrenAges",
    //     newChildrenAges
    // );
    // adults
    var adultsV2 = FormSearch.getFiltersV2Adults();
    adultsV2.val(newNbAdults);
    adultsV2.trigger("change");

    // children
    var newNbChildren = newChildrenAges.length;
    var childrenV2 = FormSearch.getFiltersV2NbChildren();
    childrenV2.val(newNbChildren);
    var childrenAgesContainer = FormSearch.getFiltersV2ChildrenAgesContainer();
    var childAgeContainers = FormSearch.getFiltersV2ChildAgeContainers();
    childAgeContainers.remove();
    if (newNbChildren > 0) {
      childrenAgesContainer.append(newChildrenAges.map(function (val) {
        return $('<div class="child-age-container select-style white"> \
                    <select class="child-age">' + new Array(18).fill(undefined).map(function (undef, i) {
          return '<option value="' + i + '" ' + (i == val ? 'selected="selected"' : "") + ">" + i + "</option>";
        }) + "</select> \
                </div>");
      }));
      childrenAgesContainer.removeClass("hidden");
    } else {
      childrenAgesContainer.addClass("hidden");
    }
    childrenV2.val(newNbChildren);
    FormSearch.handleEnableApplyFiltersV2();
  },
  // guests input changes when hidden fields change
  handleGuestsChange: function handleGuestsChange() {
    var newNbAdults = parseInt(FormSearch.getFiltersV1AdultsValue());
    var newChildrenAges = JSON.parse(FormSearch.getFiltersV1ChildrenValue());
    // console.log(
    //     "HERE FormSearch.handleGuestsChange",
    //     "newNbAdults",
    //     newNbAdults,
    //     "newChildrenAges",
    //     newChildrenAges
    // );
    var newNbChildren = newChildrenAges.length;
    var newNbGuests = newNbAdults + newNbChildren;
    var newGuestsVal = "";
    if (newNbGuests > 0) {
      var tradAttr = "data-trad-" + (newNbGuests > 1 ? "plural" : "singular");
      var trad = FormSearch.getFiltersV1Adults().attr(tradAttr);
      newGuestsVal = FormSearch.sprintf(trad, newNbGuests);
      $(".guests-container, .guests-container-mobile").addClass("remove-guests has-selected-item").removeClass("placeholder");
    } else {
      $(".guests-container, .guests-container-mobile").removeClass("remove-guests").removeClass("has-selected-item").addClass("placeholder");
    }
    $("#guests, #guests_mobile").val(newGuestsVal);
    FormSearch.handleInitializeGuestsForm();
  },
  // filtersV2 nb Children change
  handleNbChildrenChange: function handleNbChildrenChange(e) {
    var newNbChildren = FormSearch.getFiltersV2NbChildrenValue();
    // console.log(
    //     "HERE FormSearch.handleNbChildrenChange",
    //     "newNbChildren",
    //     newNbChildren
    // );
    var childrenAgesContainer = FormSearch.getFiltersV2ChildrenAgesContainer();
    var childAgeContainers = FormSearch.getFiltersV2ChildAgeContainers();
    var currentNbChildren = childAgeContainers.length;
    var diff = newNbChildren - currentNbChildren;

    // add/remove children age selects
    if (diff > 0) {
      for (var i = 0; i < diff; i++) {
        childrenAgesContainer.append($('<div class="child-age-container select-style white"> \
                    <select class="child-age">' + new Array(18).fill(undefined).map(function (undef, i) {
          return '<option value="' + i + '" ' + (i == 12 ? 'selected="selected"' : "") + ">" + i + "</option>";
        }) + "</select> \
                </div>"));
      }
    } else {
      childAgeContainers.slice(newNbChildren).remove();
    }
    // hide/show children ages
    if (newNbChildren > 0) {
      childrenAgesContainer.removeClass("hidden");
    } else {
      childrenAgesContainer.addClass("hidden");
    }
  },
  // filtersV2 Adults change
  handleAdultsChange: function handleAdultsChange(e) {
    // console.log(
    //     "HERE FormSearch.handleAdultsChange",
    //     "newNbAdults",
    //     e.target.value
    // );
    FormSearch.handleEnableApplyGuests(e.target.value);
    FormSearch.handleEnableApplyFiltersV2();
  },
  // Remove Guests
  handleRemoveGuests: function handleRemoveGuests(e) {
    // console.log("HERE FormSearch.handleRemoveGuests");
    e.preventDefault();
    FormSearch.handleResetGuests();
    FormSearch.handleInitializeGuestsForm(newNbAdults, newChildrenAges);
    $(this).parents(".guests-container").removeClass("remove-guests").addClass("placeholder");
  },
  /**
   * Language Form
   */
  // filtersV1 language change
  handleLanguageChange: function handleLanguageChange(e) {
    var newLang = e.target.value;
    // console.log("HERE FormSearch.handleLanguageChange newLang", newLang);
    FormSearch.getFiltersV1LanguageSelectedOption().removeAttr("selected");
    FormSearch.getFiltersV2LanguageBtnSelected().removeClass("selected");
    if (newLang != "") {
      FormSearch.getFiltersV1LanguageOptionFromValue(newLang).attr("selected", "selected");
      FormSearch.getFiltersV2LanguageBtnFromValue(newLang).addClass("selected");
    }
    FormSearch.handleEnableApplyFiltersV2();
  },
  // filtersV2 language init
  handleInitializeLanguageForm: function handleInitializeLanguageForm() {
    var newLang = FormSearch.getFiltersV1LanguageValue();
    FormSearch.getFiltersV2LanguageBtnSelected().removeClass("selected");
    if (newLang !== "") {
      FormSearch.getFiltersV2LanguageBtnFromValue(newLang).addClass("selected");
    }
    // console.log(
    //     "HERE FormSearch.handleInitializeLanguageForm newLang",
    //     newLang
    // );
    FormSearch.handleEnableApplyFiltersV2();
  },
  // filtersV2 language change
  handleFiltersV2LanguageChange: function handleFiltersV2LanguageChange(e) {
    var newLang = e.target.value;
    // console.log(
    //     "HERE FormSearch.handleFiltersV2LanguageChange newLang",
    //     newLang
    // );
    FormSearch.getFiltersV2LanguageBtnSelected().removeClass("selected");
    FormSearch.getFiltersV2LanguageBtnFromValue(newLang).addClass("selected");
    FormSearch.handleEnableApplyFiltersV2();
  },
  // save FiltersV2 Language
  handleSaveLanguageField: function handleSaveLanguageField() {
    var newLang = FormSearch.getFiltersV2LanguageValue();
    var langV1 = FormSearch.getFiltersV1Language();
    // console.log(
    //     "HERE FormSearch.handleSaveLanguageField newLang",
    //     newLang,
    //     langV1
    // );
    langV1.val(newLang);
    langV1.trigger("change");
  },
  /**
   * Forms
   */
  // filtersV2 Init
  handleInitializeFiltersV2: function handleInitializeFiltersV2() {
    // console.log("HERE FormSearch.handleInitializeFiltersV2");
    FormSearch.handleInitializeDateForm();
    FormSearch.handleInitializeGuestsForm();
    FormSearch.handleInitializeLanguageForm();
  },
  // Filter form submit
  handleFormSubmit: function handleFormSubmit(e) {
    e.preventDefault();
    var areFiltersValid = FormSearch.handleResolveHasFilters();
    var dateString = FormSearch.getFiltersV1DateValue();
    var lang = FormSearch.getFiltersV1LanguageValue();
    // console.log("HERE FormSearch.handleFormSubmit lang", lang);
    var nbAdults = FormSearch.getFiltersV1AdultsValue();
    nbAdults = parseInt(nbAdults);
    if (isNaN(nbAdults)) {
      nbAdults = 0;
    }
    var children = FormSearch.getFiltersV1ChildrenValue();
    var parsedChildren = typeof children === "string" ? JSON.parse(children) : [];
    if (!$.isArray(parsedChildren)) {
      parsedChildren = [];
    }
    var nbChildren = parsedChildren.length;
    var nbGuests = nbChildren + nbAdults;
    if (areFiltersValid) {
      var expiresDate = new Date();
      expiresDate.setHours(expiresDate.getHours() + 2);
      var cookieOptions = {
        path: "/",
        expires: expiresDate
      };
      // update cookies
      $.cookie("search-people", nbAdults, cookieOptions);
      $.cookie("search-children", children, cookieOptions);
      $.cookie("search-lang", lang, cookieOptions);
      $.cookie("search-date", dateString.replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})/, "$3-$2-$1"), cookieOptions);
      // update inline-filters values
      $(".inline-filters .values .date").text(dateString.replace(/([0-9]{2})\/([0-9]{2})\/[0-9]{2}([0-9]{2})/, "$1/$2/$3"));
      $(".inline-filters .values .guests").text(FormSearch.sprintf($("input#nb_adultes").attr("data-trad-" + (nbGuests > 1 ? "plural" : "singular") + "-short"), nbGuests));
      var langName = $("select#lang option[value=\"".concat(lang, "\"]")).text();
      // $(".inline-filters .values .lang").text(lang); // SHORT TEXT
      // $(".inline-filters .values .lang").text(langName); // LONG TEXT
      var image = $(".inline-filters .values .lang img");
      if (image.length === 0) {
        image = $('<img class="icon-flag-lang" />');
        $(".inline-filters .values .lang").append(image);
      }
      image.attr("src", "/static/images/front/svg-rounded-flags/".concat(lang, ".svg")).attr("title", langName).attr("alt", langName); // FLAG IMG
      var applyFiltersV2Event = jQuery.Event("apply-filters-v2");
      applyFiltersV2Event.activitiesUpdateScrollToContainer = true;
      $(document).trigger(applyFiltersV2Event);
      $("#filtersV2-dialog").trigger("close", ["save"]);
    } else {
      $.removeCookie("search-people", {
        path: "/"
      });
      $.removeCookie("search-children", {
        path: "/"
      });
      $.removeCookie("search-date", {
        path: "/"
      });
      $.removeCookie("search-lang", {
        path: "/"
      });
      alert(i18n["form-search-domain.error.all_filters_required"]);
    }
  },
  /**
   * Guests Dialog
   */
  // close dialog
  handleGuestsDialogClose: function handleGuestsDialogClose(e) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    if (!args.includes("save")) {
      setTimeout(function () {
        return FormSearch.handleInitializeGuestsForm();
      }, 200);
    }
  },
  // apply Guests
  handleApplyGuests: function handleApplyGuests(e) {
    if ($(e.target).hasClass("btn-disabled")) {
      alert($(e.target).attr("data-adults-error-trad"));
    } else {
      FormSearch.handleSaveGuestsFields();
      $("#guests-dialog").trigger("close", ["save"]);
    }
  },
  /**
   * FiltersV2 Dialog
   */
  // apply filters
  handleApplyFiltersV2: function handleApplyFiltersV2(e) {
    if ($(e.target).hasClass("btn-disabled")) {
      alert(i18n["form-search-domain.error.all_filters_required"]);
    } else {
      // console.log("HERE FormSearch.handleApplyFiltersV2");
      FormSearch.handleSaveDateField();
      FormSearch.handleSaveGuestsFields();
      FormSearch.handleSaveLanguageField();
      setTimeout(function () {
        $(".form-search-domain").trigger("submit");
      }, 200);
    }
  },
  /**
   * Document Ready
   */
  handleDocumentReady: function handleDocumentReady() {
    setTimeout(function (e) {
      // console.log("HERE FormSearch.document ready");
      FormSearch.handleInitializeFiltersV2();
      FormSearch.handleResolveHasFilters();
    }, 200);
  },
  /**
   * Other/Old
   */
  // geoloc
  handleGeolocClick: function handleGeolocClick(e) {
    // console.log("HERE FormSearch.handleGeolocClick");
    e.preventDefault();
    if (!navigator.geolocation) return;
    var self = $(this);
    navigator.geolocation.getCurrentPosition(function (position) {
      $(".form-search .results").addClass("hidden");
      $("input#type_location").val("geoloc");
      $("input#id_location").val(position.coords.latitude + "," + position.coords.longitude);
      self.locationValue = self.data("label");
      $("input#location").val(self.data("label"));
      if ($("#homepage").size() && Device.isMobile) {
        $(self).parents(".form-search").first().trigger("submit");
      }
    });
  },
  // old V1 Adult placeholder
  handleAdultsChangePlaceHolder: function handleAdultsChangePlaceHolder() {
    if ($(this).val() == "") $(this).addClass("placeholder");else $(this).removeClass("placeholder");
  },
  // Location
  handleShowTaxonomyFilter: function handleShowTaxonomyFilter() {
    if ($("#type_location").val() === "seo_pages_search") {
      $(".taxonomy-filter").addClass("hidden");
    } else {
      $(".taxonomy-filter").removeClass("hidden");
    }
  },
  // location focus
  handleLocationFocus: function handleLocationFocus() {
    // console.log("HERE FormSearch.handleLocationFocus");
    FormSearch.locationValue = $(this).val();
    $(this).val("");
  },
  handleLocationFocusOut: function handleLocationFocusOut() {
    // console.log("HERE FormSearch.handleLocationFocusOut");
    $(this).val(FormSearch.locationValue);
    var $this = $(this);
    setTimeout(function () {
      $this.next().addClass("hidden");
    }, "500");
  },
  // location change
  handleLocationChange: function handleLocationChange() {
    // console.log("HERE FormSearch.handleLocationChange");
    FormSearch.locationValue = $(this).val();
  },
  // location keyup
  handleLocationKeyUp: function handleLocationKeyUp() {
    // console.log("HERE FormSearch.handleLocationKeyUp");
    var value = $(this).val().trim();
    FormSearch.locationValue = lastSearch = value;
    var $this = $(this);
    $("input#type_location").val("manuel");
    $("input#id_location").val("");
    var searchResults = $(this).next(".results");
    if (value.length < 2) {
      searchResults.addClass("hidden");
      return;
    }
    if (searchResults.size() == 0) {
      searchResults = $('<div class="results hidden"><div></div></div>');
      searchResults.insertAfter($(this));
    }
    $.ajax({
      url: "/search/autocomplete-locations/",
      data: {
        location: value
      },
      success: function success(data) {
        if (lastSearch != value) {
          return;
        }
        if (!FormSearch.scrolled) {
          FormSearch.scrolled = true;
          var barre = $(".homepage-bloc-visuel .barre");
          if (barre.size() && $(window).scrollTop() < $(window).height() / 3) {
            $("body,html").animate({
              scrollTop: $(window).height() / 3
            }, 1000);
          }
        }
        searchResults.children().html(data);
        searchResults.removeClass("hidden");
        if ($this.hasClass("mobile")) {
          $this.parents("form").height($(".results > div").height() + 300);
        }
      }
    });
  },
  // location results click
  handleLocationResultClick: function handleLocationResultClick(e) {
    // console.log("HERE FormSearch.handleLocationResultClick");
    if ($(this).data("type") === "domains" || $(this).data("type") === "wine-tour" || $(this).data("type") === "town-tasting") return;
    e.preventDefault();
    if ($(this).hasClass("btn-geoloc")) return;
    $(".form-search input#location").val($(this).data("name"));
    $(".form-search .results").addClass("hidden");
    $("input#type_location").val($(this).data("type"));
    $("input#id_location").val($(this).data("id"));
    $(this).parents(".form-search").first().trigger("submit");
  }
};
;
var FormSearchDomainMobile = {
  init: function init() {
    var self = this;
    self.initClearableFilters();
    self.afterDomChange();
    self.initForm();
  },
  initForm: function initForm() {
    $('.form-search-mobiledomain').on('submit', function (e) {
      e.preventDefault();
      $('.form-search-headersearch #lang').val($('#lang_mobile').val());
      $('.form-search-headersearch #nb_adultes').val($('#nb_adultes_mobile').val());
      $('.form-search-headersearch #date').val($('#date_mobile').val());
      $('#order').val($('#order_mobile').val());
      setTimeout(function () {
        $('form.form-search').first().trigger('submit');
      });
      return false;
    });
  },
  initClearableFilters: function initClearableFilters() {
    $('body').on('change', '.form-search-mobiledomain .clearable-filter input, .form-search-mobiledomain .clearable-filter select', function (e) {
      if (e.originalEvent) {
        $(this).closest('form').trigger('submit');
      }
    });
    $('body').on('click', '.form-search-mobiledomain .js-embedded-select .clear-filter', function () {
      var $select = $(this).parent().find('select');
      setTimeout(function () {
        $select.closest('form').trigger('submit');
      });
    });
    $('body').on('click', '.form-search-mobiledomain .js-embedded-input .clear-filter', function () {
      var $input = $(this).parent().find('input');
      setTimeout(function () {
        $input.closest('form').submit();
      });
    });
  },
  afterDomChange: function afterDomChange() {
    var self = this;
    $('.form-search-mobiledomain input#date_mobile').datetimepicker({
      lang: $('#CURRENT_LANG').val(),
      timepicker: false,
      format: 'd/m/Y',
      scrollInput: false,
      scrollMonth: false,
      scrollTime: false,
      minDate: '0',
      dayOfWeekStart: 1,
      closeOnDateSelect: true,
      onGenerate: function onGenerate(ct) {
        $('.xdsoft_datetimepicker ').addClass('search-datetimepicker');
      },
      onSelectDate: function onSelectDate(time, $input) {
        $input.closest('form').submit();
      }
    });
    $('.js-embedded-select select').trigger('change');
    $('.js-embedded-input input').trigger('change');
    self.initForm();
  }
};
;
var FullscreenSlider = {
  loaded: false,
  sliders: [],
  // Methods
  init: function init() {
    FullscreenSlider.runSliders();
  },
  runSliders: function runSliders() {
    if (FullscreenSlider.loaded) {
      FullscreenSlider._run();
    } else {
      $(window).load(function () {
        FullscreenSlider.loaded = true;
        FullscreenSlider._run();
      });
    }
  },
  _run: function _run() {
    var self = this;
    $('.fullscreen-slider-super-container .bxslider').each(function () {
      var element = $(this);
      if (element.children().size() > 1) {
        if (element.hasClass('loaded')) return;
        element.addClass('loaded');
        self.sliders.push(element.bxSlider({
          pager: false
        }));
      }
    });
  },
  reloadSliders: function reloadSliders() {
    var self = this;
    $('.fullscreen-slider-super-container .bxslider').each(function () {
      for (var key in self.sliders) {
        if (self.sliders.hasOwnProperty(key)) {
          self.sliders[key].reloadSlider();
        }
      }
    });
  }
};
;
var FullSearch = {
  googleMap: false,
  savedZoom: false,
  markers: [],
  flagZoom: false,
  markersIcon: {},
  markersNumber: {},
  markerSearch: null,
  textInput: "",
  currentXHR: false,
  delay: 800,
  suppressNextMoveend: true,
  fixedPopups: false,
  suppressFitBounds: false,
  hasRemovedTabindex: false,
  fetchingTooltip: false,
  LatLngList: [],
  init: function init() {
    var self = this;
    if (window.maptilersdk && window.maptilersdk.config) {
      window.maptilersdk.config.session = false; // Disable maptiler sessions
    }

    // Set elements size
    FullSearch.onResize(0, $(window).height());
    var $content = $("#content");
    if ($(".form-search-full").length === 0 && !$content.hasClass("controller-wine-tour") && !$content.hasClass("controller-experience") && !$content.hasClass("controller-domains") && !$content.hasClass("controller-search")) {
      return;
    }
    self.gmapLoaded();

    //        $('body .controller-search').on('click', '.form-search-full .form-element dt label', function () {
    //            var element = $(this).parents('.form-element');
    //            if (element.hasClass('active'))
    //                $(this).parents('form').find('.form-element').removeClass('active');
    //            else {
    //                $(this).parents('form').find('.form-element').removeClass('active');
    //                element.addClass('active');
    //                element.find('input.filter').select();
    //
    //                $('.form-search-full .form-element.active .dropdown .list').jScrollPane({
    //                    autoReinitialise: true
    //                });
    //            }
    //        });

    //        $('body .controller-search').on('click', '.form-search-full .form-element a.close-btn', function () {
    //            $(this).parents('form').find('.form-element').removeClass('active');
    //        });

    /**
     * get form data
     */
    var getFormData = function getFormData() {
      var data = $("form.form-search:not(.form-search-domain:not(.has-filters))").serializeArray().filter(function (_ref5) {
        var name = _ref5.name,
          value = _ref5.value;
        return value !== "" && name !== "guests" && (name !== "children" || value !== "[]") && (name !== "page" || value !== "1");
      });
      console.log("HERE FullSearch.getFormData", data);
      return data.map(function (_ref6) {
        var name = _ref6.name,
          value = _ref6.value;
        return "".concat(name, "=").concat(value);
      }).join("&");
    };

    /**
     * get form action
     */
    var getFormAction = function getFormAction() {
      var action = "/".concat($("#CURRENT_LANG").val(), "/recherche");
      if ($("#circuit-search").val() === "1") {
        // WineTours
        action += "-circuit";
      } else if ($("#experience-search").val() === "1") {
        // Experiences
        action += "-experience";
      } else if ($("#town-tasting-search").val() === "1") {
        // Experiences
        action += "-cours-oenologie";
      } else if ($("#domain-search").val() === "1") {
        // Experiences
        action += "-domaines";
      }
      // else {
      //     // Domains (ce qu'il y avait à la base au submit du search domain)
      //     action = $("form.form-search:not(.form-search-domain)").attr(
      //         "action"
      //     );
      // }

      // TODO quand on décoche search_on_map, on ne revient pas à l'url d'origine...
      // => stocker le premier url pour pouvoir le récupérer, et le mettre à jour au click sur location result ?

      var locationType = $("input#type_location").val();
      var locationId = $("input#id_location").val();
      if (locationType !== "manuel" && locationType !== "geoloc" && locationId === null) {
        // TODO ça ne marche pas, le locationId est toujours set quand on est sur une page location, du coup on ne passe jamais ici
        action = "".concat(window.location.origin).concat(window.location.pathname);
      }

      // TODO Même quand l'url passé est /fr/recherche, on reste sur /pays/france tant que le typeLocation/idLocation ne change pas, apparemment
      console.log("HERE FullSearch.getFormAction", action, "(".concat(locationType, " ").concat(locationId, ")"), "".concat(window.location.origin).concat(window.location.pathname));
      return action;
    };

    /**
     * Results Update
     */
    var handleResultsUpdate = function handleResultsUpdate() {
      FullSearch.savedZoom = true;
      $(".location-container .results").addClass("hidden");
      if (self.currentXHR !== false) {
        self.currentXHR.abort();
      }
      setTimeout(function () {
        self.currentXHR = $.ajax({
          url: getFormAction(),
          cache: false,
          dataType: "json",
          data: getFormData(),
          success: function success(data) {
            FullSearch.callbackAjax(data);
          },
          error: function error() {
            var _console;
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }
            (_console = console).error.apply(_console, ["ajax call failed:"].concat(args));
          }
        });
      }, self.delay);
    };

    /**
     * Submit
     */
    /* Results Submit */
    var handleResultsSubmit = function handleResultsSubmit(e) {
      e.preventDefault();
      handleResultsUpdate();
    };
    $("body .controller-search, body .controller-wine-tour, body .controller-experience, body .controller-domains").on("submit", "form.form-search:not(.form-search-domain):not(.form-search-header)", handleResultsSubmit);

    /**
     * Apply Filters V2
     */
    $(document).on("apply-filters-v2", function (e) {
      console.log("HERE FullSearch.on.apply-filters-v2", $(".form-search.form-search-domain").hasClass("has-filters"));
      handleResultsUpdate();
    });

    /**
     * Order Change
     */
    $("body .controller-search, body .controller-wine-tour, body .controller-experience, body .controller-domains").on("change", ".form-search-order select#order", function (e) {
      console.log("HERE order change", $(e.target).val());
      e.preventDefault();
      $(".form-search-order select#order").val($(e.target).val());
      if ($(e.target).val() != "") {
        $(e.target).parents(".form-search-order").first().trigger("submit");
      }
    });

    /**
     * Page Change
     */
    $(document).on("click", ".change-page-search", function (e) {
      e.preventDefault();
      $("form.form-search #page").val($(this).data("page"));
      $("form.form-search #page").parents("form").trigger("submit");
      $("body,html").animate({
        scrollTop: 0
      }, 600);
    });

    /**
     * More filters
     */
    // show more/less
    $("body .controller-search").on("click", "a.show-more, a.show-less", function (e) {
      e.preventDefault();
      $(this).parents(".display-group").toggleClass("opened");
    });
    FullSearch.processResults();

    // Bouton plus de filtres
    $(document).on("click", "#more-filter", function (e) {
      e.preventDefault();
      if ($(this).hasClass("fixed")) {
        $("body,html").animate({
          scrollTop: 0
        });
        $(this).removeClass("show-more-filter");
        $("form.form-search-full").slideDown();
      } else {
        $(this).toggleClass("show-more-filter");
        $("form.form-search-full").slideToggle();
      }
    });

    // Lors d'un clic sur un filtre
    $(document).on("click", ".search-filters-bar .filter", function (e) {
      e.preventDefault();
      var target = $(this).data("target");
      if (target == "emails") {
        $("[name='emails[]'][value='" + $(this).data("val") + "']").prop("checked", false);
      } else if (target == "wine_appellation") {
        $("#domains_appellation-" + $(this).data("val")).prop("checked", false);
      } else if (target == "date" || target == "people") {
        $.removeCookie("search-" + target, {
          path: "/"
        });
        if (target == "people") {
          target = "nb_adultes";
        }
        $("#" + target).val("");
      } else if ($("#" + target + "-min").length > 0) {
        $("#" + target + "-min").val($("#" + target + "-min").data("min"));
        $("#" + target + "-max").val($("#" + target + "-min").data("max"));
      } else if ($("[name=" + target + "]").length > 0) {
        // si c'est une checkbox/radio classique
        $("[name=" + target + "]").prop("checked", false);
      } else {
        $("#" + target + "-" + $(this).data("val")).prop("checked", false);
      }
      $("form.form-search-full").first().trigger("submit");
    });

    /**
     * Domain/Experience Hover
     */
    $(document).on("mouseover", ".layout-domain-container,.layout-circuit-container,.layout-experience-container", function () {
      var marker = self.markersIcon["gps-" + $(this).data("gps")];
      var number = self.markersNumber["gps-" + $(this).data("gps")];
      if (number) {
        number = parseInt(self.markersNumber["gps-" + $(this).data("gps")]);
        if (isNaN(number)) {
          number = 1;
        }
      }
      if (typeof marker != "undefined") {
        marker.setIcon(self.createPinIcon(number, true));
      }
    });
    $(document).on("mouseout", ".layout-domain-container,.layout-circuit-container,.layout-experience-container", function () {
      var marker = self.markersIcon["gps-" + $(this).data("gps")];
      var number = self.markersNumber["gps-" + $(this).data("gps")];
      if (number) {
        number = parseInt(self.markersNumber["gps-" + $(this).data("gps")]);
        if (isNaN(number)) {
          number = 1;
        }
      }
      var hasInfoWindow = !!$(".map-tooltip-container.gps-" + $(this).data("gps")).length;
      if (typeof marker != "undefined" && !hasInfoWindow) {
        marker.setIcon(self.createPinIcon(number, false));
      }
    });
  },
  callbackAjax: function callbackAjax(data) {
    console.log("HERE FullSearch.callbackAjax", data);
    $(".breadcrumb").html($(data["breadcrumbs"]).find("ul"));
    var bandeauSEO = $("#bandeau-seo-container");
    bandeauSEO.html(data["bandeau-seo"]);
    if (data["bandeau-seo"] == "") bandeauSEO.addClass("empty");else bandeauSEO.removeClass("empty");
    $(".results-without-map > .multi-results").html(data["multi-results"]);
    $(".side-by-side-container > .left").html(data["side-left"]);
    $(".mono-results-sticky .nb-results").html($(data["side-left"]).find(".nb-results").html());
    $(".location-container .results").addClass("hidden");
    var newSliderWineToursHtml = data["other-wine-tours"];
    if (newSliderWineToursHtml !== "") {
      newSliderWineToursHtml = $(data["other-wine-tours"]).html();
    }
    $("#section-wine-tours").html(newSliderWineToursHtml);
    var newSliderTownTasting = data["other-town-tasting"];
    if (newSliderTownTasting !== "") {
      newSliderTownTasting = $(data["other-town-tasting"]).html();
    }
    $("#section-town-tasting").html(newSliderTownTasting);
    MySwipers.init();
    $("input#location").val($("input#search-location").val());
    FullSearch.processResults();
    FormSearchDomainMobile.afterDomChange();
    if ($("#no-results").size()) {
      //            FullSearch.savedZoom = false;
      $(".module-front").animate({
        scrollTop: 0
      });
    } else {
      var resultsContainerTop = $(".results-container, .results-without-map").offset().top;
      if (resultsContainerTop < 0) {
        $(".module-front").animate({
          scrollTop: $(".module-front").scrollTop() + resultsContainerTop
        });
      }
    }

    // remove old markers
    this.clearMarkers();
    // gmap markers
    this.updateMap();
    if (typeof window.history.replaceState === "function") {
      window.history.replaceState({}, data["result-url"], data["result-url"]);
    }
  },
  processResults: function processResults() {
    console.log("HERE FullSearch.processResults");
    $("#show-filters-mobile").on("click", function (e) {
      e.preventDefault();
      $("body").addClass("filters-mobile-open");
      if (typeof window.history.replaceState === "function") {
        var url = window.location.href + "&show_filters_mobile=1";
        window.history.replaceState({}, url, url);
      }
      $("html,body").animate({
        scrollTop: 0
      });
    });
    $("#cancel-filters").on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("filters-mobile-open");
      FullscreenSlider.reloadSliders();
      if (typeof window.history.replaceState === "function") {
        var url = window.location.href.replace("&show_filters_mobile=1", "");
        window.history.replaceState({}, url, url);
      }
    });
    $("#apply-filters").on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("filters-mobile-open");
      FullscreenSlider.reloadSliders();
    });

    //        $('.filters-mobile-open').on('submit','.form-search-full',function(e){
    //            e.preventDefault();
    //
    //        });
    // scrollbars filters
    $(".form-search-full .form-element .dropdown .list").jScrollPane({
      autoReinitialise: true
    });

    // bxSlider
    FullscreenSlider.runSliders();
    $(".form-search-full .form-element.choose-picture .list label").on("change", function () {
      if ($(this).find("input").is(":checked")) {
        $(this).addClass("checked");
      } else {
        $(this).removeClass("checked");
      }
    });
    $(".form-search-full .form-element .list label").on("click", function () {
      var formElement = $(this).parents(".form-element");
      formElement.addClass("edited");
      var target = false;
      if (formElement.find("#domains_appellation-label").size() != 0) {
        target = $("#wine_appellation-label").next(); //.find('input[type=checkbox]').removeAttr('checked');
      }

      if (formElement.find("#wine_appellation-label").size() != 0) {
        target = $("#domains_appellation-label").next(); //.find('input[type=checkbox]').removeAttr('checked');
      }

      if (target) {
        var index = $(this).index() + 1;
        var checked = $(this).find("input").is(":checked");
        var input = target.find("label:nth-child(" + index + ")").find("input");
        input.prop("checked", checked);
      }
    });
    $(".form-search-full .form-element.choose-picture .list label").trigger("change");
    $(".form-search-full .form-element.choose-picture .list label").click(function () {
      $(this).trigger("change");
    });
    $(".form-element:has(div.filter)").each(function () {
      var element = $(this);
      element.find("input.filter").keyup(function () {
        var value = $(this).val().toLowerCase().latinize();
        element.find(".dropdown label").each(function () {
          var text = $(this).text().toLowerCase().latinize();
          if (text.indexOf(value) !== -1) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });
    });
    FormRangeSlider.init();
    FormSearch.init();
    DialogV2.initializeDialogs();
    Front_SearchController.setDomainsBlocksSizes();
  },
  gmapLoaded: function gmapLoaded() {
    var self = this;
    if ($(".google-map").size() == 0) return;

    // Remove previous map if any
    if (FullSearch.googleMap && FullSearch.googleMap.remove) {
      FullSearch.googleMap.remove();
    }

    // Default center
    var lat = parseFloat($("#map-latitude").val()) || 47.2877947;
    var lng = parseFloat($("#map-longitude").val()) || 2.6106186;
    var zoom = 8;

    // Create Leaflet map
    self.suppressNextMoveend = true;
    FullSearch.googleMap = L.map($(".google-map").get(0), {
      zoomControl: false // disable default position
    }).setView([lat, lng], zoom);

    // Suppress scroll on focus
    window.addEventListener("pointerdown", self.removeTabindexIfPointer, true);
    window.addEventListener("mousedown", self.removeTabindexIfPointer, true);
    window.addEventListener("wheel", self.removeTabindexIfPointer, true);
    window.addEventListener("mousemove", self.removeTabindexIfPointer, true);
    if (self.fixedPopups) {
      self.googleMap.createPane("fixed-popups", document.querySelector("#map"));
    }

    // MapTiler tiles
    L.maptiler.maptilerLayer({
      style: "https://api.maptiler.com/maps/34c3a59b-a3b4-4c8e-8400-5ea451dcfb9c/style.json?key=at5rAeRYss6sG850fkEb"
      // You can add other options here if needed
    }).addTo(FullSearch.googleMap);
    L.control.zoom({
      position: "topright"
    }).addTo(FullSearch.googleMap);

    // // search pin
    FullSearch.textInput = $("#map").data("location");
    setTimeout(function () {
      self.updateMap(function () {
        self.bindMapEvents();
      });
    }, 1000);
  },
  setBoundsValue: function setBoundsValue() {
    var bds = this.googleMap.getBounds();
    var bounds = {
      sw_lat: bds.getSouthWest().lat,
      sw_lng: bds.getSouthWest().lng,
      ne_lat: bds.getNorthEast().lat,
      ne_lng: bds.getNorthEast().lng
    };
    $(".form-search input#bounds").val(JSON.stringify(bounds));
  },
  bindMapEvents: function bindMapEvents() {
    var self = this;
    $("body").on("click", ".restart-search", function (e) {
      e.preventDefault();
      $(".restart-search").removeClass("visible");
      $("#live-search").parent().removeClass("hidden");
      $("#live-search").prop("checked", true);
      FullSearch.savedZoom = true;
      $("#location").val(FullSearch.textInput);
      $("input#type_location").val("search_on_map");
      self.setBoundsValue();
      $("form.form-search-order").first().trigger("submit");
    });
    self.googleMap.on("moveend", function () {
      if (self.suppressNextMoveend || self.fetchingTooltip) {
        if (self.suppressNextMoveend || $(".loader-logo-container").length === 0) {
          self.suppressNextMoveend = false;
        }
        return;
      }
      if ($("#live-search").is(":checked")) {
        FullSearch.savedZoom = true;
        $("#location").val(FullSearch.textInput);
        $("input#type_location").val("search_on_map");
        self.setBoundsValue();
        $("form.form-search-order").first().trigger("submit");
      } else {
        $(".restart-search").addClass("visible");
        $("#live-search").parent().addClass("hidden");
      }
    });
    self.googleMap.on("click", function () {
      // Close all popups
      self.googleMap.closePopup();
    });
  },
  updateMap: function updateMap(callback) {
    var self = this;
    self.LatLngList = [];

    // Remove previous markers
    if (self.markerSearch && self.googleMap.hasLayer(self.markerSearch)) {
      self.googleMap.removeLayer(self.markerSearch);
    }
    // Remove previous result markers
    if (self.markers && self.markers.length) {
      self.markers.forEach(function (m) {
        if (self.googleMap.hasLayer(m)) self.googleMap.removeLayer(m);
      });
    }
    self.markers = [];
    self.markersIcon = {};
    self.markersNumber = {};

    // Add search marker
    // let lat = parseFloat($("#map-latitude").val());
    // let lng = parseFloat($("#map-longitude").val());
    // if (!isNaN(lat) && !isNaN(lng)) {
    //     self.markerSearch = L.marker([lat, lng], {
    //         icon: self.iconResearch,
    //     }).addTo(self.googleMap);
    //     self.LatLngList.push([lat, lng]);
    // }

    // Helper to add a marker and bind events
    function addResultMarker(coords, html, gpsKey, entityType, idsElems, distance) {
      // Guard: Only create marker if coords are valid numbers
      if (!Array.isArray(coords) || coords.length !== 2 || isNaN(coords[0]) || isNaN(coords[1])) {
        console.warn("Skipping marker with invalid coords:", coords, idsElems);
        return;
      }
      var markerIcon = self.createPinIcon(idsElems.length, false);
      var marker = L.marker(coords, {
        icon: markerIcon
      }).addTo(self.googleMap);
      marker._resultCount = idsElems.length;
      self.markers.push(marker);
      self.markersIcon["gps-" + gpsKey] = marker;
      self.markersNumber["gps-" + gpsKey] = marker._resultCount;

      // Prepare a popup with loading content
      var popupLoadingContent = "<div class=\"loader-logo-container\">\n    <svg\n        viewBox=\"0 0 50 50\"\n        version=\"1.1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        class=\"loader-logo\"\n    >\n        <title>Rue des Vignerons</title>\n        <g>\n            <path fill=\"#1AAE94\" d=\"M28.9320171,49 C28.6627777,48.9555253 28.3935383,48.9221693 28.1355172,48.8554572 C27.036123,48.5774904 26.2957146,47.8770138 25.802109,46.8874518 C25.4655598,46.1980939 25.2860669,45.4642614 25.1963204,44.7193102 C24.9719542,43.0737463 24.9382993,41.4281824 25.0280458,39.7714999 C25.1290105,37.8813252 25.5665246,36.0467438 26.2284048,34.2788745 C26.7332286,32.9223962 27.3502356,31.6215112 28.0008975,30.3206263 C28.7188692,28.8751985 29.4704958,27.4297708 30.1099394,25.9398684 C30.7381647,24.4610846 31.2429886,22.9378262 31.512228,21.3478557 C31.6692843,20.447243 31.7478124,19.5466304 31.7478124,18.634899 C31.7478124,17.0560472 31.7478124,15.4771954 31.7478124,13.8872249 C31.7478124,13.8538688 31.7478124,13.8093941 31.7478124,13.7649194 C27.2268342,13.7649194 22.7170743,13.7649194 18.196096,13.7649194 C18.196096,13.7982755 18.1848777,13.8316315 18.1848777,13.8649875 C18.1848777,15.488314 18.1848777,17.1116406 18.1848777,18.7349671 C18.196096,22.670978 19.1496522,26.3734967 21.0567646,29.8202859 C21.651335,30.8987974 22.2683419,31.9550715 22.8741306,33.0224643 C23.2443348,33.6784661 23.580884,34.3567052 23.8164685,35.0794191 C24.0408346,35.7798956 23.6818488,36.5248468 22.9863137,36.7694577 C22.2907786,37.0251872 21.505497,36.691627 21.2586942,36.0133878 C20.9333632,35.1238938 20.4734126,34.3011119 20.0022437,33.4894486 C19.2169621,32.1329703 18.4204622,30.7764919 17.758582,29.3421829 C16.7601526,27.1962786 16.0758358,24.961425 15.7392865,22.6265033 C15.5485753,21.3589744 15.4476105,20.0803268 15.4476105,18.8016791 C15.4476105,16.6780123 15.4476105,14.5543454 15.4476105,12.4306785 C15.4476105,11.6968459 15.9075611,11.1409122 16.6143146,11.0297254 C16.6816244,11.0186068 16.7489343,11.0186068 16.8162441,11.0186068 C22.2459053,11.0186068 27.6867848,11.0186068 33.116446,11.0186068 C33.8680727,11.0186068 34.4738613,11.5856592 34.496298,12.3306104 C34.5075163,12.7308827 34.496298,13.131155 34.496298,13.5314273 C34.496298,15.3104152 34.5075163,17.1005219 34.4850796,18.8795099 C34.462643,20.7696846 34.1485304,22.6265033 33.587615,24.4388473 C33.1052277,25.9732244 32.4657842,27.4520082 31.770249,28.8974359 C31.0859322,30.3095076 30.3679605,31.7104606 29.694862,33.1225323 C28.9993269,34.5790787 28.4384115,36.0912185 28.0906439,37.6700703 C27.8550595,38.7485818 27.7316581,39.8493306 27.7540947,40.9500794 C27.7765313,41.8284547 27.7877496,42.70683 27.8326228,43.5852054 C27.8662778,44.1967325 27.9448059,44.7971409 28.1467355,45.375312 C28.3935383,46.0757885 28.7076509,46.2870433 29.4592775,46.2759247 C30.0987211,46.264806 30.7157281,46.0980259 31.3215167,45.9201271 C34.787974,44.8860903 37.8393538,43.1404584 40.430783,40.6387565 C43.7289657,37.4699342 45.8492259,33.6451101 46.7803455,29.1865214 C47.1281131,27.5187202 47.2739511,25.8286816 47.2178595,24.1275244 C47.0495849,19.1463581 45.3892753,14.7211255 42.2257124,10.8518266 C40.2176352,8.3945995 37.7832623,6.47106875 34.933812,5.05899705 C32.9257348,4.05831631 30.8166928,3.38007715 28.6066861,3.02427956 C27.2043976,2.79078738 25.7908907,2.70183799 24.3661656,2.73519401 C21.1577294,2.82414341 18.0951313,3.55797595 15.212026,4.95892898 C12.9010545,6.08191514 10.8481041,7.54958021 9.05317478,9.38416156 C6.65245681,11.83027 4.91361903,14.6655321 3.83666143,17.9010665 C3.32061925,19.457681 2.98407,21.0587701 2.82701369,22.704334 C2.45680951,26.7626503 3.1186897,30.6430678 4.91361903,34.3122305 C7.08997083,38.7708192 10.4105901,42.128659 14.8306035,44.419106 C16.1431456,45.0973451 17.5117792,45.6199229 18.9365044,46.0201951 C19.6208212,46.2092126 20.0246803,46.8207397 19.9349338,47.5212162 C19.8564057,48.1660994 19.2954902,48.6664398 18.6223917,48.6886771 C18.487772,48.6886771 18.341934,48.6775584 18.2073143,48.6330837 C14.2921247,47.5323349 10.8593224,45.6088042 7.88647072,42.8513728 C5.69890061,40.827774 3.93762621,38.4706149 2.60264752,35.8132516 C1.45838008,33.5339233 0.684316805,31.1211709 0.291676015,28.5972317 C0.134619699,27.6076696 0.0448732331,26.6181076 0.0112183083,25.6285455 C0.0112183083,25.6063081 0,25.5729521 0,25.5507148 C0,25.0503744 0,24.5389154 0,24.038575 C0.0112183083,23.8050828 0.0336549248,23.5715907 0.0448732331,23.3380985 C0.157056316,21.3478557 0.504823873,19.3909689 1.11061252,17.4785568 C2.38949966,13.4091219 4.57706978,9.8956206 7.67332286,6.92693442 C9.56921696,5.11459042 11.7006955,3.63580667 14.0677586,2.49058316 C17.0854835,1.03403676 20.2827014,0.222373497 23.6369755,0.0444746993 C23.9174333,0.0333560245 24.197891,0.0111186748 24.4783487,0 C24.8261162,0 25.1738838,0 25.5328696,0 C25.5553063,0 25.5889612,0.0111186748 25.6113978,0.0111186748 C26.2844963,0.0555933742 26.9575948,0.0778307238 27.6306933,0.144542773 C29.4929325,0.32244157 31.2990801,0.722713864 33.0715728,1.32312231 C36.8857976,2.62400726 40.1951986,4.71431813 42.9997756,7.58293624 C44.8507965,9.48422963 46.3540498,11.6190152 47.5095356,13.9984116 C48.9566973,16.9670978 49.7756338,20.1025641 49.9551268,23.4048105 C49.9663451,23.6716587 49.9887817,23.9385069 50,24.2053551 C50,24.5833901 50,24.961425 50,25.3505786 C50,25.372816 49.9887817,25.406172 49.9887817,25.4284093 C49.9551268,26.8182437 49.8092888,28.1969594 49.5288311,29.5534377 C48.507965,34.5790787 46.1521203,38.8931246 42.4612968,42.4844565 C39.9259592,44.9528024 36.9755441,46.7985024 33.6324882,48.0215566 C32.6004039,48.3995916 31.5571012,48.7220331 30.457707,48.8888133 C30.2333408,48.9221693 29.9977563,48.9444066 29.7621719,48.9777627 C29.4704958,49 29.2012565,49 28.9320171,49 Z\"></path>\n        </g>\n    </svg>\n</div>";
      var popupOptions = self.fixedPopups ? {
        pane: "fixed-popups",
        // Указываем нужный pane
        className: "popup-fixed",
        autoPan: false
      } : {
        autoPan: true
      };
      var popup = L.popup(popupOptions).setContent(popupLoadingContent);
      marker.bindPopup(popup);
      marker._isHovered = false;
      marker._isPopupOpen = false;
      function updateMarkerIcon(marker) {
        // Only set icon if the state actually changed
        var active = marker._isHovered || marker._isPopupOpen;
        var currentActive = marker._currentActive;
        if (active !== currentActive) {
          marker.setIcon(self.createPinIcon(marker._resultCount, active));
          marker._currentActive = active;
        }
      }
      marker.on("mouseover", function () {
        marker._isHovered = true;
        updateMarkerIcon(marker);
        // Optionally, deactivate other markers
        self.markers.forEach(function (m) {
          if (m !== marker && !m.isPopupOpen()) {
            m._isHovered = false;
            updateMarkerIcon(m);
          }
        });
      });
      marker.on("mouseout", function () {
        marker._isHovered = false;
        updateMarkerIcon(marker);
      });
      marker.on("popupopen", function () {
        self.suppressNextMoveend = true;
        marker._isPopupOpen = true;
        updateMarkerIcon(marker);
      });
      marker.on("popupclose", function () {
        marker._isPopupOpen = false;
        updateMarkerIcon(marker);
      });
      marker.on("click", function () {
        // Suppress moveend triggered by popup auto-panning
        self.suppressNextMoveend = true;
        self.fetchingTooltip = true;
        popup.off("autopanstart"); // Remove previous listeners if any
        popup.on("autopanstart", function () {
          self.suppressNextMoveend = true;
        });

        // Load content via AJAX
        $.ajax({
          url: "/search/get-" + entityType + "-map-tooltip/?ids=" + idsElems.join(",") + "&gps=" + gpsKey + (distance ? "&distance=" + distance : ""),
          success: function success(data) {
            self.suppressNextMoveend = true;
            popup.setContent(data);
            // Run custom logic after content loads
            setTimeout(function () {
              if (typeof MySwipers !== "undefined") MySwipers.init();
              self.fetchingTooltip = false;
            }, 500);
          }
        });
      });
    }

    // 1. Gather containers by entity type
    var domainContainers = [];
    $(".layout-domain-container").each(function (i, val) {
      domainContainers.push(val);
    });
    var activityContainers = [];
    $(".layout-circuit-container").each(function (i, val) {
      activityContainers.push(val);
    });
    var experienceContainers = [];
    $(".layout-experience-container").each(function (i, val) {
      experienceContainers.push(val);
    });

    // 2. Determine entity type and containers
    var entityType = activityContainers.length > 0 ? "activities" : experienceContainers.length > 0 ? "experiences" : "domains";
    var containers = entityType === "activities" ? activityContainers : entityType === "experiences" ? experienceContainers : domainContainers;

    // 3. Group containers by GPS
    var elemsByGps = {};
    $(containers).each(function (i, res) {
      var gps = $(res).dataset ? $(res).dataset.gps : $(res).data("gps");
      if (!gps) return;
      if (elemsByGps[gps] != null) {
        elemsByGps[gps].push(res);
      } else {
        elemsByGps[gps] = [res];
      }
    });

    // 4. For each GPS group, add a marker
    $.each(elemsByGps, function (coordsGmap, resList) {
      var idsElems = [];
      var distance = undefined;
      var html = "";
      $.each(resList, function (i, res) {
        idsElems.push($(res).data("id"));
        if ($(res).data("distance") != null) {
          distance = $(res).data("distance");
        }
        // Use the first tooltip-content as popup content (or combine as needed)
        if (i === 0) {
          html = $(res).find(".tooltip-content").html();
        }
      });
      if (typeof coordsGmap !== "undefined") {
        var coords = coordsGmap.split(",");
        var lat = parseFloat(coords[0]);
        var lng = parseFloat(coords[1]);
        if (!isNaN(lat) && !isNaN(lng)) {
          self.LatLngList.push([lat, lng]);
          addResultMarker([lat, lng], html, coordsGmap, entityType, idsElems, distance);
        } else {
          console.warn("Skipping marker with invalid coords:", coordsGmap);
        }
      }
    });
    self.fitBounds();
    if (typeof callback == "function") callback();
  },
  clearMarkers: function clearMarkers() {
    FullSearch.markers.forEach(function (marker) {
      if (FullSearch.googleMap.hasLayer(marker)) {
        FullSearch.googleMap.removeLayer(marker);
      }
    });
    FullSearch.markers = [];
  },
  onScroll: function onScroll(scrollTop) {
    var sticky = $(".filtersV2-sticky.mono-results-sticky, .filtersV2-sticky.multi-results-sticky");
    if (sticky.length > 0) {
      sticky = sticky.first();
      var stickyTop = sticky.offset().top;
      if (scrollTop > stickyTop) {
        sticky.addClass("fixed");
      } else {
        sticky.removeClass("fixed");
      }
    }
  },
  onResize: function onResize(windowWidth, windowHeight) {
    self.suppressNextMoveend = true;
    if ($("#content").size()) {
      var headerHeight = $(".filtersV2-sticky.mono-results-sticky").outerHeight();
      var targetHeight = windowHeight - headerHeight - $(".cookie-toolbar-container.open").outerHeight();
      $("#map").css({
        height: targetHeight
      });
      if (!Device.isMobile) {
        $(".side-by-side-container").css("min-height", targetHeight);
      }
    }
  },
  createPinIcon: function createPinIcon(number, isActive) {
    // Change colors as needed for active/inactive
    var pinColor = isActive ? "#1AAE94" : "#999999";
    var circleColor = "#fff";
    var textColor = "#fff";
    var width = isActive ? 33 : 25;
    var height = isActive ? 39 : 30;
    var html = "\n            <svg width=\"".concat(width, "px\" height=\"").concat(height, "px\" viewBox=\"0 0 33 39\" xmlns=\"http://www.w3.org/2000/svg\">\n                <g>\n                    <path fill=\"").concat(pinColor, "\" d=\"M16.5,0 C7.425,0 0,7.3125 0,16.25 C0,28.275 15.015,38.35 15.51,38.675 C15.84,38.8375 16.17,39 16.5,39 C16.83,39 17.16,38.8375 17.49,38.675 C17.985,38.35 33,28.275 33,16.25 C33,7.3125 25.575,0 16.5,0 Z\"/>\n                    ").concat(number > 1 ? "<text x=\"16.5\" y=\"23\" text-anchor=\"middle\" font-size=\"18\" font-weight=\"600\" fill=\"".concat(textColor, "\" font-family=\"Arial\" font-weight=\"bold\">").concat(number, "</text>") : "<circle cx=\"16.5\" cy=\"16\" r=\"7\" fill=\"".concat(circleColor, "\" />"), "\n                </g>\n            </svg>\n        ");
    return L.divIcon({
      className: isActive ? "active-pin" : "inactive-pin",
      html: html,
      iconSize: [width, height],
      iconAnchor: [width / 2, height],
      popupAnchor: [0, -height]
    });
  },
  removeTabindexIfPointer: function removeTabindexIfPointer() {
    var self = FullSearch;
    if (self.hasRemovedTabindex) return;
    self.hasRemovedTabindex = true;
    $(".google-map").removeAttr("tabindex");
    window.removeEventListener("pointerdown", self.removeTabindexIfPointer, true);
    window.removeEventListener("mousedown", self.removeTabindexIfPointer, true);
    window.removeEventListener("wheel", self.removeTabindexIfPointer, true);
    window.removeEventListener("mousemove", self.removeTabindexIfPointer, true);
  },
  fitBounds: function fitBounds() {
    var self = FullSearch;
    // Fit bounds
    if (!self.suppressFitBounds) {
      if (self.LatLngList.length > 1) {
        self.suppressNextMoveend = true;
        self.googleMap.fitBounds(self.LatLngList, {
          padding: [20, 20]
        });
      } else if (self.LatLngList.length === 1) {
        self.suppressNextMoveend = true;
        self.googleMap.setView(self.LatLngList[0], 12);
      }
      self.suppressFitBounds = true;
    }
  }
};
;
var GmapSharedEmbed = {
  init: function init() {
    $(window).load(function () {
      $('.gmap-shared-embed-map-container iframe[data-src]').each(function () {
        $(this).attr('src', $(this).data('src'));
      });
    });
  }
};
var GmapStaticLoader = {
  el: {
    container: '.gmap-container'
  },
  // Methods
  init: function init() {
    var self = this;
    if ($(this.el.container).length == 0) return;
    GoogleMap.load('GmapStaticLoader.gmapLoaded');
  },
  gmapLoaded: function gmapLoaded() {
    $(this.el.container).each(function (i, res) {
      new GmapStatic($(res).data('lat'), $(res).data('lng'), $(res).data('zoom'), $(res).find('.google-map'), $(res).data('ico'), $(res).find('.tooltip-container-hidden').html(), $(res).data('pan-target'));
    });
  }
};
var GmapStatic = function GmapStatic(lat, lng, zoom, el, ico, content, pan_target) {
  this.el = el;
  this.lat = lat;
  this.lng = lng;
  this.ico = ico;
  this.pan_target = pan_target;
  if (typeof zoom !== 'undefined') this.zoom = zoom;
  if (typeof content !== 'undefined') this.infoWindowContent = content;
  this.init();
};
GmapStatic.prototype.gmap = null;
GmapStatic.prototype.lat = null;
GmapStatic.prototype.pan_target = null;
GmapStatic.prototype.center = 0;
GmapStatic.prototype.old_pan_x = 0;
GmapStatic.prototype.ico = null;
GmapStatic.prototype.lng = null;
GmapStatic.prototype.zoom = 7;
GmapStatic.prototype.el = null;
GmapStatic.prototype.mainMarker = null;
GmapStatic.prototype.infoWindowContent = "";
GmapStatic.prototype.init = function () {
  var self = this;
  var mapOptions = {
    center: {
      lat: this.lat,
      lng: this.lng
    },
    zoom: 15,
    scrollwheel: false,
    navigationControl: true,
    mapTypeControl: false,
    scaleControl: false,
    draggable: true
  };
  this.gmap = new google.maps.Map($(this.el).get(0), mapOptions);
  $('body').on('touchstart', function () {
    self.gmap.setOptions({
      draggable: false
    });
  });
  var LatLngMarker = new google.maps.LatLng(this.lat, this.lng);
  var markerOptions = {
    position: LatLngMarker,
    map: this.gmap,
    animation: 2 // dropped
  };

  self.center = self.gmap.getCenter();
  if (typeof this.ico !== 'undefined') {
    markerOptions.icon = this.ico;
  }
  // add marker
  this.mainMarker = new google.maps.Marker(markerOptions);
  // add tooltip
  if (self.infoWindowContent !== '') {
    var infowindow = new google.maps.InfoWindow({
      content: self.infoWindowContent
    });
    infowindow.open(self.gmap, self.mainMarker);
    google.maps.event.addListener(infowindow, 'domready', function () {
      self.setCenter(-$(self.el).find('.gm-style-iw').height());
    });
  }
  // trigger on resize event
  google.maps.event.addDomListener(window, "resize", function () {
    google.maps.event.trigger(self.gmap, "resize");
    self.setCenter(-$(self.el).find('.gm-style-iw').height());
  });
};
GmapStatic.prototype.setCenter = function (y, x) {
  var self = this;
  if (typeof x == 'undefined') {
    if (self.pan_target && $(self.pan_target).width() != 0) {
      x = $(self.pan_target).width() / 2 - $(self.el).find('.gm-style-iw').width();
    } else {
      x = 0;
    }
  }
  if (typeof y == 'undefined') {
    y = 0;
  }
  setTimeout(function () {
    if (x != 0 || y != 0) {
      self.gmap.setCenter(self.center);
      self.gmap.panBy(x, y);
    }
  }, '1000');
};
;
var HeaderFiltersTitle = {
  // Methods
  init: function init() {
    $('body').on('click', '.header-filters-title .filters-list li a', function () {
      $(this).parents('.filters-list').find('.active').removeClass('active');
      $(this).parent().addClass('active');
      HeaderFiltersTitle._moveBar($(this).parents('.filters-list'));
    });
    $('body').on('mouseover', '.header-filters-title .filters-list', function () {
      HeaderFiltersTitle._moveBar($(this));
    });
    $('.header-filters-title .filters-list').each(function () {
      HeaderFiltersTitle._moveBar($(this));
    });
  },
  _moveBar: function _moveBar(container) {
    if (!container.hasClass('ready')) {
      container.addClass('ready');
      container.append('<li class="bar"></li>');
    }
    var link = container.find('.active');
    var bar = container.find('.bar');
    var width = link.outerWidth() + 5;
    var left = link.offset().left - container.offset().left;
    bar.css({
      width: width + 'px',
      left: left + 'px'
    });
    setTimeout(function () {
      bar.addClass('displayed');
    }, 100);
  },
  onResize: function onResize() {
    $('.header-filters-title .filters-list').each(function () {
      HeaderFiltersTitle._moveBar($(this));
    });
  }
};
;
var IntroductionTabs = {
  actions: ["introVignerons-presentation", "introPartners-presentation"],
  // controller-actions where this should be initialized
  iconsSlider: [],
  timeoutResize: false,
  prevTab: 1,
  init: function init() {
    var self = this;
    var action = App.controller + "-" + App.action;
    if ($.inArray(action, self.actions) === -1) {
      return;
    }
    var controllerName = App.controller.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var actionName = App.action.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var $body = $('body');
    $body.on('click', '.module-front.controller-' + controllerName + '.action-' + actionName + ' .bloc-top .icons a', function (e) {
      e.preventDefault();
      var tab = $(this).data('tab');
      self.setTab(tab, true);
    });
    $body.on('click', '.module-front.controller-' + controllerName + '.action-' + actionName + ' #tabs-menu a', function (e) {
      e.preventDefault();
      var tab = $(this).data('tab');
      self.setTab(tab, false);
    });
    $body.on('click', '.module-front.controller-' + controllerName + '.action-' + actionName + ' #tabs-items a.tab-name', function (e) {
      e.preventDefault();
      var tab = $(this).data('tab');
      self.setTab(tab, false);
    });
    $body.on('click', '.module-front.controller-' + controllerName + '.action-' + actionName + ' #bloc-pourquoi #tabs-items .icons .icon', function (e) {
      e.preventDefault();
      var tab = $(this).data('tab');
      $('#tabs-items .tab.active .icon,#tabs-items .descr').removeClass('active');
      $('#tabs-items .descr-' + tab).addClass('active');
      $(this).addClass('active');
    });
    IntroductionTabs.contructTabSlider();
  },
  contructTabSlider: function contructTabSlider() {
    if (Device.isMobile) {
      if (!IntroductionTabs.iconsSlider.length) {
        $('#tabs-items .tab.active .icons').each(function () {
          var slider = $(this);
          IntroductionTabs.iconsSlider.push(slider.bxSlider({
            slideSelector: 'a.icon',
            pager: false,
            prevText: '',
            nextText: '',
            adaptiveHeight: true,
            onSlideAfter: function onSlideAfter($slideElement, oldIndex, newIndex) {
              slider.find('a.icon').removeClass('active');
              $slideElement.addClass('active').trigger('click');
            }
          }));
        });
      }
    } else {
      IntroductionTabs.destroyTabSlider();
    }
  },
  destroyTabSlider: function destroyTabSlider() {
    if (IntroductionTabs.iconsSlider.length) {
      for (var i in IntroductionTabs.iconsSlider) {
        var slider = IntroductionTabs.iconsSlider[i];
        slider.destroySlider();
      }
      IntroductionTabs.iconsSlider = [];
    }
  },
  setTab: function setTab(num, scroll) {
    if (IntroductionTabs.prevTab == num) {
      return;
    }
    $('#bloc-pourquoi #tabs-menu .tab,#bloc-pourquoi #tabs-items .tab,#bloc-pourquoi #tabs-items a.tab-name').removeClass('active').filter('.tab-' + num).addClass('active');
    if (scroll) {
      $('body,html').animate({
        scrollTop: $('#tabs-menu').offset().top
      }, 600);
    }
    IntroductionTabs.destroyTabSlider();
    IntroductionTabs.contructTabSlider();
    IntroductionTabs.prevTab = num;
  },
  onResize: function onResize() {
    if (App.action == 'presentation') {
      clearTimeout(IntroductionTabs.timeoutResize);
      IntroductionTabs.timeoutResize = setTimeout(IntroductionTabs.contructTabSlider, 1000);
    }
  }
};
;
var Layout_Favorites = {
  loginUrl: false,
  // Methods
  init: function init() {
    $('body').on('click', 'span.layout-favorites-button', function (e) {
      e.preventDefault();
      var button = $(this);
      var favorites_type = button.data('favorites-type');
      var favorites_id = button.data('favorites-id');
      Layout_Favorites.loginUrl = button.data('login-url');
      var addUrl = '/index/add-to-favorites/?' + jQuery.param({
        favorites_type: favorites_type,
        favorites_id: favorites_id,
        return_url: window.location.href
      });
      if ($('#content').hasClass('connected-1') || $('#content').hasClass('connected-partner-1')) {
        $.ajax({
          cache: false,
          url: addUrl,
          success: function success(data) {
            if (data === 'ok-0') {
              button.removeClass('ico-heart-hover');
              button.addClass('ico-heart');
              return;
            }
            if (data === 'ok-1') {
              button.addClass('ico-heart-hover');
              button.removeClass('ico-heart');
              return;
            }
            if (data === 'login') {
              Popin.open(Layout_Favorites.loginUrl, {
                'callback-js': 'Layout_Favorites.callback'
              });
            }
          }
        });
      } else {
        Popin.open(Layout_Favorites.loginUrl, {
          'callback-js': 'Layout_Favorites.callback',
          'callback': addUrl
        });
      }
    });
  },
  callback: function callback(favorites_type, favorites_id) {
    alert('callback');
  },
  _login: function _login(favorites_type, favorites_id) {}
};
;
var Layout_MenuMobile = {
  menu_mobile: null,
  open_buttons: [],
  nav: null,
  close_buttons: [],
  links: null,
  slider: null,
  slides: null,
  back_buttons: null,
  speed_animation: 500,
  current_path: [0],
  menu_width: 0,
  menu_height: 0,
  current_deepness: 0,
  body_class: "menu_mobile_displayed",
  height_header: 0,
  init: function init() {
    var self = this;
    this.open_buttons.push($("#header .menu-btn-desktop"));
    this.nav = $("#nav_mobile");
    this.close_buttons.push(this.nav.find(".sandwich"));
    this.close_buttons.push(this.nav.find(".close-button"));
    this.links = this.nav.find("li a, li span");
    this.slider = this.nav.find(".slider");
    this.slides = this.slider.find(".slide");
    this.back_buttons = this.nav.find(".back_button");
    this.height_header = this.slides.find("header").first().outerHeight(true);
    this.setSize();
    this.watchSandwiches();
    this.watchLinks();
    this.watchBackButtons();
    this.watchResize();
  },
  watchSandwiches: function watchSandwiches() {
    var self = this;
    this.open_buttons.forEach(function (button) {
      button.click(function (e) {
        e.preventDefault();
        if (self.nav.hasClass("shown")) {
          self.nav.removeClass("shown");
          $("body").removeClass(self.body_class);
        } else {
          self.nav.addClass("shown");
          $("body").addClass(self.body_class);
        }
      });
    });
    this.close_buttons.forEach(function (button) {
      button.click(function (e) {
        e.preventDefault();
        self.nav.removeClass("shown");
        $("body").removeClass(self.body_class);
      });
    });
  },
  watchLinks: function watchLinks() {
    var self = this;
    this.links.click(function (e) {
      var $self = $(this);
      if ($self.attr("href") === undefined) {
        e.preventDefault();
        var id = $self.attr("data-id");
        self.slide("left", id);
      }
    });
  },
  watchBackButtons: function watchBackButtons() {
    var self = this;
    this.back_buttons.click(function (e) {
      e.preventDefault();
      self.slide("right");
    });
  },
  watchResize: function watchResize() {
    var self = this;
    $(window).resize($.proxy(self.setSize, self));
  },
  slide: function slide(direction, id) {
    var self = this;
    if (direction == "left") {
      if ($.inArray(id, self.current_path) === -1) {
        self.current_deepness++;
        self.links.filter("[data-id_parent='" + id + "']").show();
        self.slides.filter(":gt(" + (self.current_path.length - 1) + ")").find("li a, li span").not("[data-id_parent='" + id + "']").hide();
        self.current_path.push(id);
        self.slider.css("left", Math.max(-self.menu_width * self.current_deepness, -self.current_deepness * self.menu_width) + "px");
      }
    } else {
      self.current_deepness--;
      self.current_path.pop();
      self.slider.css("left", Math.min(0, -self.current_deepness * self.menu_width) + "px");
    }
  },
  setSize: function setSize() {
    var self = this;
    self.menu_width = Math.min($(window).width(), 600);
    self.menu_height = $(window).height();
    self.slider.css("left", -self.current_deepness * self.menu_width + "px");
    self.slides.find("ul").css("height", self.menu_height - self.height_header + "px");
  }
};
;
var LinkBySms = {
  // Methods
  init: function init() {
    $('body').on('submit', 'form#Front_Form_LinkBySms', function (e) {
      e.preventDefault();
      var form = $(this);
      $.ajax({
        cache: false,
        url: form.attr('action'),
        data: form.serialize(),
        type: 'post',
        success: function success(data) {
          form.replaceWith(data);
        }
      });
    });
  }
};
;
var Loading = {
  // Methods
  init: function init() {
    $('body').on('click', "button:not(.no-loading),a[href]:not(.no-loading,.bx-next,.bx-prev)", function (e) {
      if ($(this).attr('href') && $(this).attr('href').substring(0, 1) !== '#' && $(this).attr('target') !== '_blank') {
        if ((typeof PhoneApp === "undefined" ? "undefined" : _typeof(PhoneApp)) == 'object') {
          e.preventDefault();
          PhoneApp.goto($(this).attr('href'));
        }
        Loading.start();
      }
    });
    $(document).ajaxStart(function () {
      Loading.start();
    });
    $(document).ajaxComplete(function () {
      Loading.end();
    });
    $(window).blur(function () {
      // Put your blur logic here
      Loading.end();
    });
  },
  start: function start() {
    $('#loading-barre').removeClass('loaded');
    if ($('body').hasClass('mobile-app')) parent.postMessage({
      action: 'app.unload'
    }, '*');
  },
  end: function end() {
    $('#loading-barre').addClass('loaded');
  }
};
;
var MobileBottomBar = {
  mapForMobileInitialized: false,
  needZoomReset: true,
  initMapForMobile: function initMapForMobile() {
    if (!MobileBottomBar.mapForMobileInitialized) {
      if (window.innerWidth <= 500) {
        FullSearch.fixedPopups = true;
      }
      FullSearch.gmapLoaded();
      // Enable all gesture controls (Leaflet)
      FullSearch.googleMap.dragging.enable();
      FullSearch.googleMap.touchZoom.enable();
      FullSearch.googleMap.scrollWheelZoom.enable();
      FullSearch.googleMap.doubleClickZoom.enable();
      FullSearch.googleMap.boxZoom.enable();
      FullSearch.googleMap.keyboard.enable();
      // Move zoom control to top right (Leaflet)
      if (FullSearch.googleMap.zoomControl) {
        FullSearch.googleMap.zoomControl.setPosition('topright');
      }
      FullSearch.suppressFitBounds = false;
      FullSearch.fitBounds();
      FullSearch.suppressNextMoveend = false;
    }
    MobileBottomBar.mapForMobileInitialized = true;
  },
  centerMapToScrolledDomain: function centerMapToScrolledDomain() {
    var $first = $('.layout-domain-container.first');
    if ($first.length > 0) {
      var gpsStr = $first.data('gps');
      if (gpsStr) {
        var coords = gpsStr.split(',');
        var lat = parseFloat(coords[0]);
        var lng = parseFloat(coords[1]);
        FullSearch.googleMap.setView([lat, lng], 9);
      }
    }
  },
  showError: function showError(message) {
    if ($('#g-tooltip-message').length > 0) {
      $('#g-tooltip-message').remove();
    }
    var close = $('.gps_error_close').text();
    var tooltipDom = $('<div id="g-tooltip-message" class="tooltip testtt">\n' + '    <div class="layer_mobile">\n' + '        <div class="content"><p>' + message + '</p>\n' + '            <div class="btn-border-green close-tooltip">' + close + '</div>\n' + '        </div>\n' + '    </div>\n' + '</div>');
    $('body').append(tooltipDom);
    tooltipDom.addClass('currently-displayed').find('.layer_mobile').fadeIn();
  },
  init: function init() {
    //Around me
    $(document).on('click', '.js-btn-geoloc', function () {
      $("#loading-barre").removeClass('loaded');
      navigator.geolocation.getCurrentPosition(function (position) {
        $('.form-search .results').addClass('hidden');
        $('input#type_location').val('geoloc');
        $('input#id_location').val(position.coords.latitude + ',' + position.coords.longitude);
        $('input#location').val('Autour de moi');
        $('#order').val('distance');
        setTimeout(function () {
          $('form.form-search').first().trigger('submit');
        });
      }, function (error) {
        $("#loading-barre").addClass('loaded');
        var messageId = '.gps_position_error_' + error.code;
        if ($(messageId).length > 0) {
          var message = $(messageId).text();
          MobileBottomBar.showError(message);
        }
      });
    });
    $(document).on('click', '.js-mobile-toggle-map', function () {
      if ($('main.controller-search.action-index, main.controller-experience.action-index, main.controller-wine-tour.action-index').hasClass('mobile-map-opened')) {
        // will close
        $('main').removeClass('mobile-map-opened');
        $('body').removeClass('fc-disable-scroll');
        $('.filtersV2-sticky.mono-results-sticky').css('position', '').removeClass('fixed');
        $('.side-by-side-container > .right').css({
          top: ''
        });
        $('#map').css({
          top: ''
        });
        FullSearch.onResize(0, $(window).height());
        FullSearch.onScroll($(window).scrollTop());
      } else {
        // will open
        $(window).scrollTop(0);
        $('body').addClass('fc-disable-scroll');
        $('main').addClass('mobile-map-opened');
        $('.filtersV2-sticky.mono-results-sticky').css('position', 'fixed').addClass('fixed');
        var headerHeight = $('.filtersV2-sticky.mono-results-sticky').outerHeight();
        headerHeight = parseInt(headerHeight);
        var rightTop = isNaN(headerHeight) ? 0 : parseInt(headerHeight) - 1;
        $('.side-by-side-container > .right').css({
          top: "".concat(rightTop, "px")
        });
        $('#map').css({
          top: 0
        });
        MobileBottomBar.initMapForMobile();
      }
    });
  }
};
var ModuleCommand = {
  tabListIds: [],
  saveDataUrl: null,
  activityPriceUrl: null,
  messageStepError: "",
  messageRequiredField: "",
  messageApiError: "",
  init: function init() {
    if (typeof commandGlobals !== "undefined") {
      this.tabListIds = commandGlobals.tabListIds;
      this.saveDataUrl = commandGlobals.saveDataUrl;
      this.activityPriceUrl = commandGlobals.activityPriceUrl;
      this.messageStepError = commandGlobals.messageStepError;
      this.messageRequiredField = commandGlobals.messageRequiredField;
      this.messageApiError = commandGlobals.messageApiError;
      var activeStep = commandGlobals.activeStep;
      var that = this;
      var buttonsNext = document.getElementsByClassName("button-next");
      for (var i = 0; i < buttonsNext.length; i++) {
        buttonsNext[i].addEventListener("click", function (e) {
          that.onClickNext(e, that);
        });
      }
      this.openTab("tab-" + activeStep);
      this.onChangeFormElement();
      this.onChangeSelectAmount();
      this.onChangeAmount();
      this.initPersons("adults", "children");
      this.initPersons("children", "adults");
      this.initChildren();
      this.initSpecialTariffs();
      if (activeStep === 2) {
        this.activeStepHeader("tab-1");
      } else if (activeStep === 3) {
        this.activeStepHeader("tab-1");
        this.activeStepHeader("tab-2");
      }
    }
  },
  onClickNext: function onClickNext(evt, that) {
    that.removeAllTabMessage();
    var currentTarget = evt.currentTarget;
    var selfTab = currentTarget.closest("div.tabContent");
    var selfTabId = selfTab.id;
    var stepIndex = that.tabListIds.indexOf(selfTabId);
    var nexStepId = that.tabListIds[stepIndex + 1];
    if (that.validateFormElement(selfTabId)) {
      that.saveStepData(selfTabId, nexStepId);
    } else {
      that.showTabMessage(selfTabId, that.messageStepError);
    }
  },
  validateFormElement: function validateFormElement(selfTabId) {
    var selfTab = document.getElementById(selfTabId);
    var htmlElements = selfTab.querySelectorAll("input,select,textarea");
    var isValid = true;
    htmlElements.forEach(function (e) {
      if (e.required && !e.value) {
        isValid = false;
        e.classList.add("error");
      }
    });
    return isValid;
  },
  onChangeAmount: function onChangeAmount() {
    var labels = document.querySelectorAll("#proposed-amounts span");
    var that = this;
    if (labels) {
      labels.forEach(function (e) {
        e.addEventListener("click", function (e) {
          that.purgeActiveAmounts();
          var step1Footer = document.getElementById("amount-step-footer");
          step1Footer.style.display = "block";
          document.getElementById("amount").value = e.target.dataset.value;
          e.target.classList.add("active");
          if ($(window).height() < 850) {
            $("body,html").animate({
              scrollTop: $(".layout-booking-card").offset().top - 20
            }, 300);
          }
        });
      });
    }
  },
  onChangeSelectAmount: function onChangeSelectAmount() {
    var select = document.querySelector("select#amount");
    var that = this;
    if (!select) {
      return;
    }
    select.addEventListener("change", function (e) {
      that.purgeActiveAmounts();
      var step1Footer = document.getElementById("amount-step-footer");
      step1Footer.style.display = "block";
    });
  },
  updateTariffs: function updateTariffs() {
    $("#special_tariffs").val(JSON.stringify(Object.fromEntries($("[id^=tablebookingform-tariffs-]").filter(function () {
      return $(this).val() !== "0";
    }).toArray().map(function (el) {
      return [$(el).data("tariff"), $(el).val()];
    }))));
  },
  handleTariffsChange: function handleTariffsChange(e) {
    $(this).off("change");
    var newVal = parseInt($(this).val());
    var max = parseInt($(this).find("option:last").val());
    var othersNonNull = $("[id^=tablebookingform-tariffs-]:not(#".concat($(this).attr("id"), ")")).filter(function () {
      return $(this).val() !== "0";
    });
    if ($(othersNonNull).length > 0) {
      var totalOthers = 0;
      $(othersNonNull).each(function () {
        totalOthers += parseInt($(this).val());
      });
      while (totalOthers + newVal > max) {
        var lastNonNull = $(othersNonNull)[$(othersNonNull).length - 1];
        $(lastNonNull).val(Math.max(0, parseInt($(lastNonNull).val()) - (totalOthers + newVal - max)));
        totalOthers = 0;
        othersNonNull = $("[id^=tablebookingform-tariffs-]:not(#".concat($(this).attr("id"), ")")).filter(function () {
          return $(this).val() !== "0";
        });
        $(othersNonNull).each(function () {
          totalOthers += parseInt($(this).val());
        });
      }
    }
    ModuleCommand.updateTariffs();
    $(this).on("change", ModuleCommand.handleTariffsChange);
  },
  initSpecialTariffs: function initSpecialTariffs() {
    $("[id^=tablebookingform-tariffs-]").on("change", ModuleCommand.handleTariffsChange);
  },
  initPersons: function initPersons(baseSelect, otherSelect) {
    var that = this;
    var baseSelectElement = document.getElementById(baseSelect);
    if (baseSelectElement) {
      baseSelectElement.addEventListener("change", function (e) {
        var number = parseInt(e.target.value ? e.target.value : 0);
        var max = parseInt(e.target.dataset.max);
        var otherSelectMax = max - number;
        var otherSelectElement = document.getElementById(otherSelect);
        var options = Array.from(otherSelectElement.getElementsByTagName("option"));
        var lastMax = parseInt(options[options.length - 1] && options[options.length - 1].value ? options[options.length - 1].value : 0);
        var diff = otherSelectMax - lastMax;
        if (diff > 0) {
          for (var i = 0; i < diff; i++) {
            var optVal = lastMax + i + 1;
            otherSelectElement.insertAdjacentHTML("beforeend", '<option value="' + optVal + '">' + optVal + "</option>");
          }
        } else {
          options.slice(diff).forEach(function (i) {
            otherSelectElement.removeChild(i);
          });
          if (options.length + diff === 0) {
            otherSelectElement.insertAdjacentHTML("beforeend", '<option value=""> - </option>');
          }
        }
        if (baseSelect === "adults" && $("[id^=tablebookingform-tariffs-]").length > 0) {
          $("[id^=tablebookingform-tariffs-]").off("change");
          var _max = number;
          var _lastMax = parseInt($("[id^=tablebookingform-tariffs-] option:last").val());
          var all = $("[id^=tablebookingform-tariffs-]");
          var nonNulls = $(all).filter(function () {
            return $(this).val() !== "0";
          });
          if ($(nonNulls).length > 0) {
            var total = 0;
            $(nonNulls).each(function () {
              total += parseInt($(this).val());
            });
            var count = 0;
            while (total > _max) {
              var lastNonNull = $(nonNulls)[$(nonNulls).length - 1];
              var prevVal = $(lastNonNull).val();
              $(lastNonNull).val(Math.max(0, parseInt($(lastNonNull).val()) - (total - _max)));
              total = 0;
              $(nonNulls).each(function () {
                total += parseInt($(this).val());
              });
              nonNulls = $(all).filter(function () {
                return $(this).val() !== "0";
              });
              console.log("HERE while adult", $(lastNonNull), prevVal, $(lastNonNull).val());
              if (count > 3) {
                break;
              }
              count++;
            }
          }
          $(all).each(function () {
            var diff = _max - _lastMax;
            if (diff > 0) {
              for (var _i = 0; _i < diff; _i++) {
                var _optVal = _lastMax + _i + 1;
                $(this).append('<option value="' + _optVal + '">' + _optVal + "</option>");
              }
            } else {
              $(this).find("option").slice(diff).remove();
            }
          });
          that.updateTariffs();
          $("[id^=tablebookingform-tariffs-]").on("change", that.handleTariffsChange);
        }
      });
    }
  },
  initChildren: function initChildren() {
    var children = document.getElementById("children");
    if (children) {
      children.addEventListener("change", function (e) {
        var value = parseInt(e.target.value ? e.target.value : 0);
        var childrenAgeContainer = document.getElementById("children-age-container");
        var children = Array.from(childrenAgeContainer.children);
        var currentValue = children.length;
        var diff = value - currentValue;
        if (diff > 0) {
          for (var i = 0; i < diff; i++) {
            var childrenElement = document.createElement("div");
            childrenElement.classList.add("children-age-select-container");
            childrenElement.insertAdjacentHTML("beforeend", '<div class="select-style white"><select name="children_ages[]" class="age-select"></select></div>');
            for (var j = 1; j <= 17; j++) {
              childrenElement.querySelector("select").insertAdjacentHTML("beforeend", '<option value="' + j + '" ' + (j === 12 ? 'selected="selected"' : "") + ">" + j + "</option>");
            }
            childrenAgeContainer.appendChild(childrenElement);
          }
        } else {
          children.slice(diff).forEach(function (i) {
            childrenAgeContainer.removeChild(i);
          });
        }
        var childrenAge = document.getElementById("children-age");
        if (childrenAgeContainer.children.length === 0) {
          childrenAge.style.display = "none";
        } else {
          childrenAge.style.display = "block";
        }
      });
    }
  },
  showTabMessage: function showTabMessage(selfTabId, message) {
    var selfTab = document.getElementById(selfTabId);
    selfTab.insertAdjacentHTML("afterbegin", '<p class="error-message">' + message + "</p>");
  },
  removeAllTabMessage: function removeAllTabMessage(selfTabId, message) {
    var errors = document.querySelectorAll("#module-gift-card-command p.error-message");
    errors.forEach(function (e) {
      e.parentNode.removeChild(e);
    });
    var errorsInput = document.querySelectorAll("#module-gift-card-command input.error");
    errorsInput.forEach(function (e) {
      e.classList.remove("error");
    });
  },
  purgeActiveAmounts: function purgeActiveAmounts() {
    var labels = document.querySelectorAll("#proposed-amounts span");
    labels.forEach(function (e) {
      e.classList.remove("active");
    });
  },
  onChangeFormElement: function onChangeFormElement() {
    var htmlElements = document.querySelectorAll("input,select,textarea");
    var isValid = true;
    htmlElements.forEach(function (e) {
      e.addEventListener("change", function (e) {
        e.target.className = e.target.className.replace("error", "");
      });
    });
    return isValid;
  },
  saveStepData: function saveStepData(selfTabId, nexStepId) {
    var data = {};
    var that = this;
    var selfTab = document.getElementById(selfTabId);
    var htmlElements = selfTab.querySelectorAll("input,select:not([id^=tablebookingform-tariffs-]),textarea");
    htmlElements.forEach(function (e) {
      if (e.name.includes("[]")) {
        var key = e.name.replace("[]", "");
        if (data[key]) {
          data[key].push(e.value);
        } else {
          data[key] = [e.value];
        }
      } else {
        data[e.name] = e.value;
      }
    });
    var myInit = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    };
    fetch(that.saveDataUrl, myInit).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.error) {
        that.showTabMessage(selfTabId, that.messageApiError);
      } else {
        that.activeStepHeader(selfTabId);
        that.openTab(nexStepId);
        that.changeSummaryValues(selfTabId, data);
      }
    }).catch(function (reason) {
      that.showTabMessage(selfTabId, that.messageApiError);
    });
  },
  changeSummaryValues: function changeSummaryValues(selfTabId, data) {
    var that = this;
    var description = document.getElementById("tabs-head-" + selfTabId).querySelector("span.header-description");
    Object.keys(data).forEach(function (key) {
      var value = data[key];
      switch (key) {
        case "adults":
          description.innerHTML = value;
          var myInit = {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin"
          };
          fetch(that.activityPriceUrl, myInit).then(function (response) {
            return response.json();
          }).then(function (json) {
            if (!json.error) {
              $(".gift-card-summary-container .price-detail .total-price-value").each(function () {
                $(this).html(json.value);
              });
              $(".gift-card-summary-container .price-detail .payment-mode").each(function () {
                $(this).removeClass("hidden");
              });
              $(".gift-card-summary-container .call-price").each(function () {
                $(this).addClass("hidden");
              });
              $(".layout-booking-card.gift-card .price-container .total-price-value").each(function () {
                $(this).html(json.value);
              });
              $(".layout-booking-card.gift-card .price-container").each(function () {
                $(this).removeClass("hidden");
              });
            }
          }).catch(function (reason) {
            console.log(reason);
          });
          break;
        case "amount":
          $(".gift-card-summary-container .price-detail .total-price-value").each(function () {
            $(this).html(value + "€");
          });
          $(".gift-card-summary-container .price-detail .payment-mode").each(function () {
            $(this).removeClass("hidden");
          });
          $(".gift-card-summary-container .call-price").each(function () {
            $(this).addClass("hidden");
          });
          $(".layout-booking-card.gift-card .price-container .total-price-value").each(function () {
            $(this).html(value + "€");
          });
          $(".layout-booking-card.gift-card .price-container").each(function () {
            $(this).removeClass("hidden");
          });
          description.innerHTML = value + "€";
          break;
        case "receiver":
          $(".gift-card-summary-container .price-detail .price-detail-for-value").each(function () {
            $(this).html(value);
          });
          description.innerHTML = value;
          break;
        case "transmitter":
          $(".gift-card-summary-container .price-detail .price-detail-from-value").each(function () {
            $(this).html(value);
          });
          break;
        default:
          break;
      }
    });
  },
  openTab: function openTab(selfTabId) {
    var that = this;
    document.querySelectorAll("#step-content .tabContent").forEach(function (e) {
      e.style.display = "none";
    });
    document.querySelectorAll("#tabs li").forEach(function (e) {
      e.classList.remove("active");
    });
    var header = document.getElementById("tabs-head-" + selfTabId);
    var headerDescription = header.querySelector(".header-description");
    var defaultDescription = headerDescription.dataset.default;
    header.classList.remove("passed");
    header.classList.remove("checked");
    header.classList.add("active");
    headerDescription.innerHTML = defaultDescription;
    header.removeEventListener("click", function () {
      that.openTab(selfTabId);
    });
    document.getElementById(selfTabId).style.display = "block";
  },
  activeStepHeader: function activeStepHeader(selfTabId) {
    var element = document.getElementById("tabs-head-" + selfTabId);
    var that = this;
    element.addEventListener("click", function () {
      that.openTab(selfTabId);
    });
    element.classList.remove("active");
    element.classList.add("passed");
    element.classList.add("checked");
    that.removeAllTabMessage();
  }
};
;
var ModuleReservation = {
  scrollEnabled: false,
  oldScrollTop: 0,
  limitTop: null,
  limitBottom: null,
  heightBlock: null,
  el: {
    container: $("#module-reservation-container"),
    block: $("#module-reservation"),
    blockLimitTop: $("#scrollTopLimitReservation"),
    blockLimitBottom: $("#scrollBottomLimitReservation")
  },
  init: function init() {
    this.start();
    this.onScroll($("window").scrollTop());
  },
  start: function start() {
    var that = this;
    $("#module-reservation:not(.started)").each(function () {
      var module = $(this);
      module.addClass("started");
      var url = module.find("#module-reservation-url").val();
      var loader = $("#loading-calendar-data");
      that.updateSummary();
      module.find("a.module-reservation-ajax").click(function (e) {
        var _href$split$;
        e.preventDefault();
        var href = $(this).attr("href");
        var queryString = (_href$split$ = href.split('?')[1]) !== null && _href$split$ !== void 0 ? _href$split$ : false;
        var urlParams = queryString ? that.parseQueryString(queryString) : {};
        var allParams = _objectSpread(_objectSpread({}, that.getCurrentValues()), urlParams);
        console.log('allParams', allParams);
        loader.removeClass("hidden");
        $.ajax({
          cache: false,
          data: allParams,
          url: url,
          success: function success(data) {
            module.replaceWith(data);
            that.start();
          }
        });
      });
      module.find(".js-btn-confirm-people").click(function (e) {
        e.preventDefault();
        var adults = parseInt($("#tablebookingform-adults-select").val());
        var children = $(".children-age-select-container select").map(function (idx, elem) {
          return $(elem).val();
        }).toArray();
        var specialTariffs = {};
        var specialTariffNames = {};
        $(".special-tariff").each(function () {
          var val = parseInt($(this).val());
          if (val > 0) {
            specialTariffs[$(this).data("tariff")] = val;
            specialTariffNames[$(this).data("tariff")] = $(this).data("tariff-name-fr");
          }
        });
        loader.removeClass("hidden");

        // update contact form data
        $('#module-reservation-contact form input[name="nombre_d_adultes__form2_"]').val("".concat(adults, " adultes").concat(Object.keys(specialTariffs).length ? "\ndont:\n" + Object.entries(specialTariffs).map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            id = _ref8[0],
            count = _ref8[1];
          return "".concat(count, " x ").concat(specialTariffNames[id], " (id ").concat(id, ")");
        }).join("\n") : "")).change();
        $('#module-reservation-contact form input[name="form_nb_enfants"]').val(children.length).change();
        $('#module-reservation-contact form input[name="form_ages_enfants"]').val(children.join(",")).change();
        $('#module-reservation-contact form input[name="form_nb_personnes"]').val(adults + children.length).change();
        var data = _objectSpread(_objectSpread({}, that.getCurrentValues()), {}, {
          adults: adults,
          children: children.length ? children : false,
          special_tariffs: specialTariffs,
          people_confirmed: 1
        });
        // confirm people
        $.ajax({
          cache: false,
          url: $(this).data("url"),
          data: data,
          success: function success(data) {
            module.replaceWith(data);
            that.start();
          }
        });
      });
      function handleTariffsChange(e) {
        $(this).off("change");
        var newVal = parseInt($(this).val());
        var max = parseInt($(this).find("option:last").val());
        var othersNonNull = $("[id^=tablebookingform-tariffs-]:not(#".concat($(this).attr("id"), ")")).filter(function () {
          return $(this).val() !== "0";
        });
        if ($(othersNonNull).length > 0) {
          var totalOthers = 0;
          $(othersNonNull).each(function () {
            totalOthers += parseInt($(this).val());
          });
          while (totalOthers + newVal > max) {
            var lastNonNull = $(othersNonNull)[$(othersNonNull).length - 1];
            $(lastNonNull).val(Math.max(0, parseInt($(lastNonNull).val()) - (totalOthers + newVal - max)));
            totalOthers = 0;
            othersNonNull = $("[id^=tablebookingform-tariffs-]:not(#".concat($(this).attr("id"), ")")).filter(function () {
              return $(this).val() !== "0";
            });
            $(othersNonNull).each(function () {
              totalOthers += parseInt($(this).val());
            });
            console.log("HERE while tariff");
          }
        }
        $(this).on("change", handleTariffsChange);
      }
      $("[id^=tablebookingform-tariffs-]").on("change", handleTariffsChange);
      module.find("#tablebookingform-adults-select").change(function (e) {
        var adults = parseInt($(this).val());
        var areChildrenAccounted = $("#mr_account_for_children").val() === "1";
        if (areChildrenAccounted) {
          var max = parseInt($("#mr_max_people").val());
          var newChildrenMax = max - adults;
          var lastMax = parseInt($("#tablebookingform-children-select option:last").val());
          var diff = newChildrenMax - lastMax;
          if (diff > 0) {
            for (var i = 0; i < diff; i++) {
              var optVal = lastMax + i + 1;
              $("#tablebookingform-children-select").append('<option value="' + optVal + '">' + optVal + "</option>");
            }
          } else if (diff < 0) {
            $("#tablebookingform-children-select option").slice(diff).remove();
          }
        }
        if ($("[id^=tablebookingform-tariffs-]").length > 0) {
          $("[id^=tablebookingform-tariffs-]").off("change");
          var _max2 = adults;
          var _lastMax2 = parseInt($("[id^=tablebookingform-tariffs-] option:last").val());
          var all = $("[id^=tablebookingform-tariffs-]");
          var nonNulls = $(all).filter(function () {
            return $(this).val() !== "0";
          });
          if ($(nonNulls).length > 0) {
            var total = 0;
            $(nonNulls).each(function () {
              total += parseInt($(this).val());
            });
            var count = 0;
            while (total > _max2) {
              var lastNonNull = $(nonNulls)[$(nonNulls).length - 1];
              var prevVal = $(lastNonNull).val();
              $(lastNonNull).val(Math.max(0, parseInt($(lastNonNull).val()) - (total - _max2)));
              total = 0;
              $(nonNulls).each(function () {
                total += parseInt($(this).val());
              });
              nonNulls = $(all).filter(function () {
                return $(this).val() !== "0";
              });
              console.log("HERE while adult", $(lastNonNull), prevVal, $(lastNonNull).val());
              if (count > 3) {
                break;
              }
              count++;
            }
          }
          $(all).each(function () {
            var diff = _max2 - _lastMax2;
            if (diff > 0) {
              for (var _i2 = 0; _i2 < diff; _i2++) {
                var _optVal2 = _lastMax2 + _i2 + 1;
                $(this).append('<option value="' + _optVal2 + '">' + _optVal2 + "</option>");
              }
            } else if (diff < 0) {
              $(this).find("option").slice(diff).remove();
            }
          });
          $("[id^=tablebookingform-tariffs-]").on("change", handleTariffsChange);
        }
      });
      module.find("#tablebookingform-children-select").change(function (e) {
        e.preventDefault();
        var minimumAge = parseInt($(".people-count").data("minimumchildage"));
        minimumAge = !isNaN(minimumAge) ? minimumAge : 1;
        var selectedAge = Math.max(minimumAge, 12);
        var newValue = $(this).val();
        var currentValue = $(".module-reservation-people .children-age .children-age-select-container").length;
        var diff = newValue - currentValue;
        var $childrenAgeContainer = $(".module-reservation-people .children-age");
        if (diff > 0) {
          for (var i = 0; i < diff; i++) {
            var $elem = $('<div class="children-age-select-container"> \
                                     <div class="select-style white">\
                                         <select class="age-select"></select> \
                                     </div>\
                             </div>');
            for (var j = minimumAge; j <= 17; j++) {
              $elem.find("select").append('<option value="' + j + '" ' + (j === selectedAge ? 'selected="selected"' : "") + ">" + j + "</option>");
            }
            $childrenAgeContainer.append($elem);
          }
        } else if (diff < 0) {
          $(".module-reservation-people .children-age .children-age-select-container").slice(diff).remove();
        }
        if (newValue > 0) {
          $("#module-reservation .children-age").show();
        } else {
          $("#module-reservation .children-age").hide();
        }
        var areChildrenAccounted = $("#mr_account_for_children").val() === "1";
        var children = parseInt($("#tablebookingform-children-select").val());
        if (areChildrenAccounted) {
          var max = parseInt($("#mr_max_people").val());
          var newChildrenMax = max - children;
          var lastMax = parseInt($("#tablebookingform-adults-select option:last").val());
          var sub = newChildrenMax - lastMax;
          if (sub >= 0) {
            for (var i = 0; i < sub; i++) {
              var optVal = lastMax + i + 1;
              $("#tablebookingform-adults-select").append('<option value="' + optVal + '">' + optVal + "</option>");
            }
          } else {
            $("#tablebookingform-adults-select option").slice(sub).remove();
          }
        }
      });
      module.find(".module-reservation-lang a").click(function (e) {
        // update contact form data
        $('#module-reservation-contact form input[name="form_langue"]').val($(this).attr("data-value")).change();
      });
      module.find(".module-reservation-hours a").click(function (e) {
        module.find(".module-reservation-hours a").removeClass("active");
        $(this).addClass("active");
        if (![1, "1"].includes($('input[name="has_extras"]').val())) {
          loader.removeClass("hidden");
        } else {
          e.preventDefault();
          // confirm hour
          $.ajax({
            cache: false,
            url: $(this).attr("href"),
            data: _objectSpread(_objectSpread({}, that.getCurrentValues()), {}, {
              hour: $(this).data("hour"),
              event_id: $(this).data("event")
            }),
            success: function success(data) {
              module.replaceWith(data);
              that.start();
            }
          });
        }

        // update contact form data
        $('#module-reservation-contact form input[name="form_heure"]').val($(this).attr("data-value")).change();
      });
      module.find(".module-reservation-extras .extra-input").on("change", function (e) {
        var newVal = parseInt($(this).val());
        var max = parseInt($("#ajax_adults").val()) + parseInt($("#nb_children").val());
        var othersNonNull = $("[id^=tablebookingform-extras-]:not(#".concat($(this).attr("id"), ")")).filter(function () {
          return $(this).val() !== "0";
        });
        var total = $(othersNonNull).toArray().reduce(function (acc, extra) {
          return acc + parseInt($(extra).val());
        }, newVal);
        var remaining = max - total;
        var updateMax = function updateMax(el) {
          var oldMax = parseInt($(el).find("option:last").val());
          var newMax = parseInt($(el).val()) + remaining;
          var diff = newMax - oldMax;
          if (diff > 0) {
            for (var i = 0; i < diff; i++) {
              var optVal = oldMax + i + 1;
              $(el).append('<option value="' + optVal + '">' + optVal + "</option>");
            }
          } else if (diff < 0) {
            $(el).find("option").slice(diff).remove();
          }
        };
        $("[id^=tablebookingform-extras-]").toArray().forEach(function (extra) {
          updateMax($(extra));
        });

        // update
        var extras = {};
        var extraNames = {};
        $(".extra-input").each(function () {
          var val = parseInt($(this).val());
          if (val > 0) {
            extras[$(this).data("extra")] = val;
            extraNames[$(this).data("extra")] = $(this).data("extra-name-fr");
          }
        });
        // loader.removeClass("hidden"); // FOUC LOADER

        // update contact form data
        $('#module-reservation-contact form input[name="form_extras"]').val(Object.entries(extras).map(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
            id = _ref10[0],
            count = _ref10[1];
          return "".concat(count, " x ").concat(extraNames[id], " (id ").concat(id, ")");
        }).join("\n")).change();

        // update data
        $.ajax({
          cache: false,
          url: $(this).data("url"),
          data: _objectSpread(_objectSpread({}, that.getCurrentValues()), {}, {
            extras: extras
          }),
          success: function success(data) {
            module.replaceWith(data);
            that.start();
          }
        });
      });
      module.find(".btn-confirm-extras").click(function (e) {
        e.preventDefault();
        loader.removeClass("hidden");
        var link = $(this).attr("href");
        var extrasParams = {};
        $(".module-reservation-extras  .extra-input").each(function (index, el) {
          extrasParams[$(el).data("extra")] = $(el).val();
        });
        var urlParams = _objectSpread(_objectSpread({}, that.getCurrentValues()), {}, {
          extras: JSON.stringify(extrasParams),
          validation: 1
        });
        var searchParams = new URLSearchParams(urlParams);
        var queryString = searchParams.toString();
        var redirect = "".concat(link, "?").concat(queryString);
        window.location = redirect;
        return false;
      });
      var currentDate = new Date();
      module.find("#module-reservation-date").datetimepicker({
        lang: $("#CURRENT_LANG").val(),
        inline: true,
        todayButton: false,
        timepicker: false,
        format: "d/m/Y",
        scrollMonth: false,
        scrollTime: true,
        scrollInput: false,
        dayOfWeekStart: 1,
        yearStart: currentDate.getFullYear(),
        yearEnd: currentDate.getFullYear() + 2,
        formatDate: "d/m/Y",
        minDate: "0",
        timepickerScrollbar: false,
        onSelectDate: function onSelectDate(ct, $i) {
          var date = ct.dateFormat("Y-m-d");
          $.ajax({
            cache: false,
            url: url,
            data: _objectSpread(_objectSpread({}, that.getCurrentValues()), {}, {
              date: date
            }),
            success: function success(data) {
              module.replaceWith(data);
              that.start();
            }
          });
          // update contact form data
          $('#module-reservation-contact form input[name="form_date"]').val(date).change();
        },
        onGenerate: function onGenerate(e) {
          console.log("onGenerate", e);
          that.refreshCells(module, e.dateFormat("Y-m-d"));
          $(".xdsoft_datetimepicker ").addClass("search-datetimepicker");
        }
      });
    });
  },
  refreshCells: function refreshCells(module, date) {
    var that = this;
    var loader = $("#loading-calendar-data");
    var loadingAvailabilityMessage = $("#loading-calendar-data .loading-availability-message");
    loader.removeClass("hidden");
    var done = false;
    function handleRefreshDone() {
      done = true;
      loader.addClass("hidden");
      loadingAvailabilityMessage.addClass("hidden");
    }
    setTimeout(function () {
      if (!done) {
        loadingAvailabilityMessage.removeClass("hidden");
      }
    }, 2000);
    if (date) {
      var url = $('input[name="ajax_url"]').val();
      var data = {
        date: date,
        lang: $('input[name="ajax_lang"]').val(),
        activity: $('input[name="ajax_id_activity"]').val(),
        adults: $('input[name="ajax_adults"]').val(),
        children: $('input[name="ajax_children"]').val()
      };
      var myInit = {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      };
      fetch(url, myInit).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (json.error) {
          that.displayError(loader, json.message);
        }
        that.changeCalendarDays(module, json.value && json.value.dates ? json.value.dates : []);
        handleRefreshDone();
      }).catch(function (reason) {
        that.displayError(loader, reason);
        that.changeCalendarDays(module, []);
        handleRefreshDone();
      });
    } else {
      if ($("#module-reservation-dates-dispo").length > 0) {
        var dates = $("#module-reservation-dates-dispo").val().split(",");
        that.changeCalendarDays(module, dates);
      }
    }
  },
  displayError: function displayError(loader, message) {
    var parent = loader.parent();
    parent.find(".error").remove();
    parent.prepend('<div class="error">' + message + "</div>");
  },
  changeCalendarDays: function changeCalendarDays(module, dates) {
    var cells = module.find("td:not(.xdsoft_disabled)").addClass("off");
    for (var dateKey in dates) {
      var dateString = dates[dateKey];
      if (dateString && dateString !== "") {
        dateString = dateString.split("-");
        cells.filter("td[data-month=" + (parseInt(dateString[1]) - 1) + "][data-year=" + parseInt(dateString[0]) + "][data-date=" + parseInt(dateString[2]) + "]").removeClass("off");
      }
    }
    module.find(".off").addClass("xdsoft_disabled").removeClass("off");
  },
  onScroll: function onScroll(scrollTop) {
    if (this.scrollEnabled || this.el.container.size() && this.el.blockLimitBottom.size() && this.el.blockLimitTop.size()) {
      this.scrollEnabled = true;
      if (this.limitTop == null) {
        this.limitTop = this.el.blockLimitTop.offset().top;
      }
      if (this.limitBottom == null) this.limitBottom = this.el.blockLimitBottom.offset().top - 20;
      if (this.heightBlock == null) {
        this.heightBlock = this.el.container.height();
      }
      if (parseInt(scrollTop + this.heightBlock) < this.limitBottom && scrollTop > this.limitTop) {
        this.el.container.css("top", scrollTop - this.limitTop);
        this.el.container.addClass("fixed");
      }
      if (scrollTop <= this.limitTop) {
        // reset
        this.el.container.css("top", "");
        this.el.container.removeClass("fixed");
      }
      this.oldScrollTop = scrollTop;
    }
  },
  onResize: function onResize() {
    this.limitBottom = this.limitTop = this.heightBlock = null;
    this.onScroll($(window).scrollTop());
  },
  getCurrentValues: function getCurrentValues() {
    var _$$val, _$$val2, _$$val3, _$$val4, _$$val5, _$$val6, _$$val7;
    var nbAdults = (_$$val = $("#ajax_adults").val()) !== null && _$$val !== void 0 ? _$$val : "";
    var childrenAges = (_$$val2 = $("#ajax_children").val()) !== null && _$$val2 !== void 0 ? _$$val2 : "";
    var specialTariffs = $("#ajax_special_tariffs").val();
    var lang = (_$$val3 = $("#ajax_lang").val()) !== null && _$$val3 !== void 0 ? _$$val3 : "";
    var date = (_$$val4 = $("#ajax_date").val()) !== null && _$$val4 !== void 0 ? _$$val4 : "";
    var hour = (_$$val5 = $("#ajax_hour").val()) !== null && _$$val5 !== void 0 ? _$$val5 : "";
    var eventId = (_$$val6 = $("#ajax_event_id").val()) !== null && _$$val6 !== void 0 ? _$$val6 : "";
    var extras = $("#ajax_extras").val();
    var peopleConfirmed = (_$$val7 = $("#people_confirmed").val()) !== null && _$$val7 !== void 0 ? _$$val7 : "";
    return {
      adults: nbAdults !== "" ? nbAdults : null,
      people: nbAdults !== "" ? nbAdults : null,
      children: childrenAges !== "" && childrenAges !== "[]" ? childrenAges : null,
      people_confirmed: peopleConfirmed !== "" ? peopleConfirmed : null,
      date: date !== "" ? date : null,
      event_id: eventId !== "" ? eventId : null,
      extras: extras !== "" && extras !== "[]" ? extras : null,
      hour: hour !== "" ? hour : null,
      lang: lang !== "" ? lang : null,
      special_tariffs: specialTariffs !== "" && specialTariffs !== "[]" ? specialTariffs : null
    };
  },
  updateSummary: function updateSummary() {
    var summaryActivity = $(".layout-summary-activity-container");
    var summaryActivityUrl = $("#summary_activity_url").val();
    var bookingCard = $(".layout-booking-card");
    var bookingCardUrl = $("#booking_card_url").val();
    var urlParams = "";
    if (summaryActivity.length && summaryActivityUrl || bookingCard.length && bookingCardUrl) {
      var formValues = this.getCurrentValues();
      if (formValues.people != null) {
        urlParams += "?people=".concat(formValues.people);
        if (formValues.children != null) {
          var children = JSON.parse(formValues.children);
          children.forEach(function (childAge, i) {
            urlParams += "&".concat(encodeURIComponent("children[".concat(i, "]")), "=").concat(childAge);
          });
        }
        if (formValues.special_tariffs != null) {
          var specialTariffs = JSON.parse(formValues.special_tariffs);
          Object.entries(specialTariffs).forEach(function (_ref11) {
            var _ref12 = _slicedToArray(_ref11, 2),
              id = _ref12[0],
              nbPersons = _ref12[1];
            urlParams += "&".concat(encodeURIComponent("special_tariffs[".concat(id, "]")), "=").concat(nbPersons);
          });
        }
        if (formValues.extras != null) {
          var extras = JSON.parse(formValues.extras);
          Object.entries(extras).forEach(function (_ref13) {
            var _ref14 = _slicedToArray(_ref13, 2),
              id = _ref14[0],
              nbPersons = _ref14[1];
            urlParams += "&".concat(encodeURIComponent("extras[".concat(id, "]")), "=").concat(nbPersons);
          });
        }
        if (formValues.lang != null) {
          urlParams += "&lang=".concat(formValues.lang);
        }
        if (formValues.date != null) {
          urlParams += "&date=".concat(formValues.date);
        }
        if (formValues.hour != null) {
          urlParams += "&hour=".concat(formValues.hour);
        }
        if (formValues.eventId != null) {
          urlParams += "&event_id=".concat(formValues.eventId);
        }
      }
    }

    // update summary activity
    if (summaryActivity.length && summaryActivityUrl) {
      $.ajax({
        cache: false,
        url: "".concat(summaryActivityUrl).concat(urlParams),
        dataType: "html",
        success: function success(data) {
          // Parse the HTML properly before using it
          var parsedData = $.parseHTML(data, document, true);
          summaryActivity.each(function () {
            $(this).replaceWith(parsedData);
          });
        },
        error: function error(xhr, status, _error) {
          console.error("AJAX error:", _error);
        }
      });
    } else {
      console.warn("updateSummary summaryActivity is missing: ".concat(summaryActivity.length ? "" : "summaryActivityElement", " ").concat(summaryActivityUrl ? "" : "".concat(summaryActivity.length ? " " : " and ", "summaryActivityUrl")));
    }
    // update booking card
    if (bookingCard.length && bookingCardUrl) {
      $.ajax({
        cache: false,
        url: "".concat(bookingCardUrl).concat(urlParams),
        dataType: "html",
        success: function success(data) {
          // Parse the HTML properly before using it
          var parsedData = $.parseHTML(data, document, true);
          $("#booking-detail-activity-" + $("#activity_id").val()).remove();
          bookingCard.each(function () {
            $(this).replaceWith(parsedData);
          });
          DialogV2.initializeDialogs();
        },
        error: function error(xhr, status, _error2) {
          console.error("AJAX error:", _error2);
        }
      });
    } else {
      console.warn("updateSummary bookingCard is missing: ".concat(bookingCard.length ? "" : "bookingCardElement", " ").concat(bookingCardUrl ? "" : "".concat(bookingCard.length ? " " : " and ", "bookingCardUrl")));
    }
  },
  parseQueryString: function parseQueryString(queryString) {
    var params = {};
    if (queryString.startsWith('?')) {
      queryString = queryString.substring(1);
    }
    var pairs = queryString.split('&');
    var _iterator = _createForOfIteratorHelper(pairs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var pair = _step.value;
        var _pair$split = pair.split('='),
          _pair$split2 = _slicedToArray(_pair$split, 2),
          key = _pair$split2[0],
          value = _pair$split2[1];
        var decodedKey = decodeURIComponent(key);
        var decodedValue = decodeURIComponent(value || '');
        params[decodedKey] = decodedValue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return params;
  }
};
;
var MoveReservation = {
  activeTab: '',
  selectedDate: null,
  selectedAvailability: null,
  el: {},
  init: function init() {
    this.el.$container = $('#module-move-reservation-container');
    if (this.el.$container.length === 0) {
      return;
    }
    this.el.$datepicker = $('#module-reservation-date');
    this.el.$datepickerContainer = this.el.$datepicker.parent();
    this.el.$datepickerLoader = $('.dates-tab .loader');
    this.el.$hoursContainer = $('.module-reservation-hours');
    this.el.$hoursLoader = $('.hours-tab .loader');
    this.openTab("tab-1");
    this.el.$container.on('click', 'ul.tabs li', function (e) {
      that.openTab($(e.currentTarget).data('tab'));
    });
    var that = this;
    this.el.$container.on('click', '.module-reservation-hours a', function (e) {
      e.preventDefault();
      that.el.$container.find('.module-reservation-hours a').removeClass('active');
      var $link = $(this);
      $link.addClass('active');
      that.selectedAvailability = {
        'id': $link.data('id'),
        'text': $link.text()
      };
      var $header = that.el.$container.find("ul.tabs li[data-tab=\"".concat(that.activeTab, "\"]"));
      $header.addClass("active").addClass("checked").addClass("passed");
      $header.find('.header-description').text($link.text());
      that.el.$container.find('.btn-container').addClass('show');
    });
    this.el.$container.on('click', '.js-move-reservation', function (e) {
      var confirm = window.confirm(that.el.$container.data('confirmmessage'));
      if (!confirm) {
        return;
      }
      var loader = $(".loader");
      loader.show();
      var url = that.el.$container.data('moveurl');
      var query = {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          token: that.el.$container.data('token'),
          slotId: that.selectedAvailability.id
        })
      };
      fetch(url, query).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (json.error !== undefined) {
          throw json.error;
        }
        loader.hide();
        setTimeout(function () {
          alert(that.el.$container.data('successmessage'));
          window.document.location = that.el.$container.data('returnsuccessurl');
        }, 100);
      }).catch(function (reason) {
        alert(reason);
      }).finally(function () {
        loader.hide();
      });
    });
  },
  openTab: function openTab(selfTabId) {
    if (selfTabId === this.activeTab) {
      return;
    }
    if (this.selectedDate === null && selfTabId === "tab-2") {
      return;
    }
    this.activeTab = selfTabId;
    this.el.$container.find(".content .tabContent").hide();
    this.el.$container.find("ul.tabs li").removeClass("active");
    this.el.$container.find(".content .tabContent[data-tab='" + selfTabId + "']").show();
    var tab = selfTabId;
    if (tab === 'tab-1') {
      this.onOpenStepDate();
    }
    if (tab === 'tab-2') {
      this.onOpenStepHour();
    }
  },
  onOpenStepDate: function onOpenStepDate() {
    var that = this;
    this.selectedDate = null;
    this.selectedAvailability = null;
    var $header = this.el.$container.find("ul.tabs li[data-tab=\"tab-1\"]");
    $header.addClass('active').removeClass("passed").removeClass("checked");
    var $headerDescription = $header.find('.header-description');
    $headerDescription.text($headerDescription.data('default'));
    $header = this.el.$container.find("ul.tabs li[data-tab=\"tab-2\"]");
    $header.removeClass("passed").removeClass("checked");
    $headerDescription = $header.find('.header-description');
    $headerDescription.text($headerDescription.data('default'));
    that.el.$container.find('.btn-container').removeClass('show');
    if (!this.el.$datepicker.hasClass('initialized')) {
      var currentDate = new Date();
      this.el.$datepicker.datetimepicker({
        lang: $('#CURRENT_LANG').val(),
        inline: true,
        todayButton: false,
        timepicker: false,
        format: 'd/m/Y',
        scrollMonth: false,
        scrollTime: true,
        scrollInput: false,
        dayOfWeekStart: 1,
        yearStart: currentDate.getFullYear(),
        yearEnd: currentDate.getFullYear() + 2,
        formatDate: 'd/m/Y',
        minDate: '0',
        timepickerScrollbar: false,
        onSelectDate: function onSelectDate(ct, $i) {
          that.selectedDate = ct.dateFormat('Y-m-d');
          that.openTab('tab-2');
        },
        onGenerate: function onGenerate(e) {
          $('.xdsoft_datetimepicker ').addClass('search-datetimepicker');
          that.loadDates(e.dateFormat('Y-m-d'));
        }
      });
      this.el.$datepicker.addClass('initialized');
    }
  },
  onOpenStepHour: function onOpenStepHour() {
    $header = this.el.$container.find("ul.tabs li[data-tab=\"tab-1\"]");
    $header.removeClass('active').addClass("passed").addClass("checked");
    $headerDescription = $header.find('.header-description');
    $headerDescription.text(new Date(this.selectedDate).toLocaleDateString());
    $header = this.el.$container.find("ul.tabs li[data-tab=\"tab-2\"]");
    $header.addClass('active').removeClass("passed").removeClass("checked");
    var $headerDescription = $header.find('.header-description');
    $headerDescription.text($headerDescription.data('default'));
    this.loadHours(this.selectedDate);
  },
  loadDates: function loadDates(fromDateString) {
    var that = this;
    var loader = this.el.$datepickerLoader;
    loader.removeClass('hidden');
    var url = this.el.$container.data('datesurl');
    var query = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        token: this.el.$container.data('token'),
        date: fromDateString
      })
    };
    fetch(url, query).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.error !== undefined) {
        throw json.error;
      }
      if (json.dates !== undefined) {
        that.setEnabledDates(json.dates);
      }
    }).finally(function () {
      loader.addClass('hidden');
    }).catch(function (reason) {
      that.el.$datepickerContainer.hide();
      that.showTabError(reason);
    });
  },
  setEnabledDates: function setEnabledDates(allowedDates) {
    var cells = this.el.$datepickerContainer.find('td.xdsoft_date');
    cells.addClass('off');
    var _iterator2 = _createForOfIteratorHelper(allowedDates),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var dateString = _step2.value;
        var dateParts = dateString.split('-');
        cells.filter('td[data-month=' + (parseInt(dateParts[1]) - 1) + '][data-year=' + parseInt(dateParts[0]) + '][data-date=' + parseInt(dateParts[2]) + ']').removeClass('off');
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    this.el.$datepickerContainer.find('.off').addClass('xdsoft_disabled').removeClass('off');
  },
  loadHours: function loadHours(fromDateString) {
    var that = this;
    var loader = this.el.$hoursLoader;
    loader.removeClass('hidden');
    that.setVisibleHours([]);
    var url = this.el.$container.data('hoursurl');
    var query = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        token: this.el.$container.data('token'),
        date: fromDateString
      })
    };
    fetch(url, query).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.error !== undefined) {
        throw json.error;
      }
      if (json.availabilities !== undefined) {
        that.setVisibleHours(json.availabilities);
      }
    }).finally(function () {
      loader.addClass('hidden');
    }).catch(function (reason) {
      that.showTabError(reason);
    });
  },
  setVisibleHours: function setVisibleHours(availabilities) {
    this.el.$hoursContainer.empty();
    var _iterator3 = _createForOfIteratorHelper(availabilities),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var av = _step3.value;
        var link = "<a data-id=\"".concat(av.id, "\">").concat(av.hour, "</a>");
        this.el.$hoursContainer.append(link);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  },
  showTabError: function showTabError(errorTxt) {
    var tabContent = this.el.$container.find('.tabContent[data-tab="' + this.activeTab + '"]');
    tabContent.find('.error-message').remove();
    tabContent.prepend('<p class="error-message">' + errorTxt + "</p>");
  }
};
var OrderBtn = {
  init: function init() {
    $('.container-order-btn.ajaxify #order').on('change', function () {
      var $tableContainer = $(this).parents('.container-order-btn').next('.table-container');
      $.ajax({
        url: $tableContainer.data('ajax-url'),
        data: {
          order: $(this).val()
        },
        cache: false,
        success: function success(data) {
          $tableContainer.replaceWith(data);
          CssRadioCheckbox.parseAll();
        }
      });
    });
    $('.container-order-btn #order').on('change', function () {
      if ($(this).val() != '') {
        $("#value-order").text($('#order option:selected').text());
      }
    });
  }
};
var Pepites = {
  element: false,
  isOpen: false,
  // Methods
  reset: function reset() {
    Pepites.isOpen = false;
    Pepites.element = false;
  },
  init: function init() {
    Pepites.element = document.getElementById('pepites');
    if (Pepites.element) {
      Pepites.element = $(Pepites.element);
      Pepites.element.find('a.close').click(function (e) {
        e.preventDefault();
        Pepites.close();
      });
      var button = $("a[href='#pepites']").click(function (e) {
        e.preventDefault();
        Pepites.open();
      });
      if (window.location.hash == '#pepites') button.trigger('click');
    }
  },
  open: function open() {
    Pepites.isOpen = true;
    var pepiteHeight = Pepites.element.get(0).offsetHeight;
    $('#content').get(0).style.cssText = CSS.translate3d(0, pepiteHeight + 'px', 0);
    $('html,body').animate({
      scrollTop: 0
    }, 600);
    Front_IndexController.moveBackground(($(window).scrollTop() - pepiteHeight) / 4, 1000);
  },
  close: function close() {
    Pepites.isOpen = false;
    $('#content').get(0).style.cssText = CSS.translate3d(0, 0, 0);
    Front_IndexController.moveBackground($(window).scrollTop() / 4, 1000);
  },
  onResize: function onResize() {
    if (Pepites.isOpen) {
      setTimeout(Pepites.open, 100);
      setTimeout(Pepites.open, 1000);
    }
  }
};
;
var Popin = {
  popupInner: false,
  popupInnerContent: false,
  popupElement: false,
  // Methods
  init: function init() {
    $("body").on("click", "a.popinify:not(.facebook-connect,[data-confirm])", function (e) {
      e.preventDefault();
      Popin.open($(this).attr("href"), undefined, undefined, undefined, $(this).attr("data-popin-classname"));
    });
    $("body").on("submit", "#popin form.popinify", function (e) {
      e.preventDefault();
      Popin.open($(this).attr("action"), $(this).serializeArray(), "POST", undefined, $(this).attr("data-popin-classname"));
    });
    $("body").on("click", "#popin:not(.exit-by-btn) a#popin-overlay, #popin:not(.exit-by-btn) a#popin-close-btn", function (e) {
      e.preventDefault();
      Popin.close();
    });
    $("body").on("click", ".close-popin", function (e) {
      e.preventDefault();
      Popin.close();
    });
    var param = Popin.getQueryVariable("popinify");
    if (param) {
      Popin.open(decodeURIComponent(param));
    }
  },
  getQueryVariable: function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },
  open: function open(url, data, type, onSuccess, popinClassName) {
    if (typeof data === "undefined") data = {};
    if (typeof type === "undefined") type = "GET";
    if (typeof popinClassName === "undefined") popinClassName = "";
    data.popin = 1;
    Popin._createPopin(popinClassName);
    $.ajax({
      cache: false,
      url: url,
      data: data,
      type: type,
      success: function success(data) {
        $("body,html").animate({
          scrollTop: 0
        }, 600, function () {
          $("body").addClass("popin-open");
        });
        Popin.popupInnerContent.html(data);
        CssRadioCheckbox.parseAll();
        Popin.popupElement.fadeTo(600, 1);
        if (typeof onSuccess === "function") onSuccess();
      }
    });
  },
  close: function close() {
    Popin.popupElement.fadeTo(600, 0, function () {
      // reset
      $(this).hide();
      Popin.popupElement.removeClass("exit-by-btn");
      $("body").removeClass("popin-open");
      $(this).find("iframe").remove();
    });
  },
  _createPopin: function _createPopin(popinClassName) {
    if (Popin.popupElement && Popin.popupElement.size()) {
      return;
    }
    Popin.popupElement = $('<div id="popin" class="' + popinClassName + '"/>');
    Popin.popupElement.append('<a id="popin-overlay"></a>');
    Popin.popupElement.append('<div id="popin-content"></div>');
    Popin.popupInner = $('<div id="popin-inner"></div>');
    Popin.popupInner.append('<a id="popin-close-btn">&times;</a>');
    Popin.popupInnerContent = $('<div id="popin-inner-content"></div>');
    Popin.popupInner.append(Popin.popupInnerContent);
    Popin.popupElement.find("#popin-content").html(Popin.popupInner);
    Popin.popupElement.insertAfter($("main#content"));
  }
};
;
var TableManager = {
  init: function init() {
    this.initSearch();
    this.initClick();
  },
  initSearch: function initSearch() {
    if ($("#table-search").length == 0) return;

    // FILTER list
    $('#table-search').on("keyup", function () {
      var $tableContainer = $(this).parents('.table-container');
      var results = $tableContainer.find('table tbody tr');
      var colSearch = $tableContainer.find('.search-container').data('search-col');
      results.show();
      var val = $(this).val().toLowerCase();
      if (val.length > 2) {
        $(results).each(function (i, res) {
          var name = $(res).find('.col-' + colSearch).text().trim().toLowerCase();
          if (name.indexOf(val) != -1) {
            $(res).show();
          } else {
            $(res).hide();
          }
        });
      }
    });
  },
  initClick: function initClick() {
    $('body').on('dblclick', '.table-container table tbody tr[data-href]', function () {
      var href = $(this).data('href');
      if ($(this).hasClass('popinify')) {
        Popin.open(href);
      } else {
        App.gotoPage(href);
      }
    });
  }
};
var Tooltip = {
  init: function init() {
    var $body = $("body");
    $body.on('click', ".tooltip a[href='#']", function (e) {
      e.preventDefault();
    });
    $body.on("click", ".tooltip", function (e) {
      e.stopPropagation();
      var $self = $(this);
      if ($("html").hasClass("touch")) {
        // we're on mobile or tablet
        $self.find(".layer_mobile").fadeIn();
        $self.addClass("currently-displayed");
      }
    });
    $body.on("click", ".close-tooltip", function (e) {
      e.stopPropagation();
      $(this).parentsUntil(".tooltip").last().fadeOut(function () {
        $(this).parent().removeClass("currently-displayed");
      });
    });
  }
};
;
var Twitter = {
  // Methods
  init: function init() {},
  open: function open(href) {
    var h = 314;
    var w = 585;

    // Fixes dual-screen position                                Most browsers       Firefox
    var dualScreenLeft = typeof window.screenLeft === 'number' ? window.screenLeft : screen.left;
    var dualScreenTop = typeof window.screenTop === 'number' ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    window.open(href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=' + h + ',width=' + w + ',top=' + top + ',left=' + left);
  }
};
;
var VigneronsMenu = {
  // Methods
  init: function init() {
    $('#vignerons-menu .vignette > a').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
    });
  }
};
